import { useState, useEffect, useCallback, useRef, Fragment } from 'react'
import api from '../api'
import { SmsLinkRow } from './LessonBookingBlock'
import { pullOldMk as pullOldMkShared, PULL_OLDMK_LABEL, PULL_OLDMK_TITLE } from './pullOldMk'
import ReportIssueButton from '../components/ReportIssueButton'
import TrialSignupModal from './TrialSignupModal'
import TeacherRating from './TeacherRating'
import { TutorPickerCard, TutorWeekSlots, TutorPickerSubjectHint } from './TutorPicker'
import OtborTab from './OtborTab'
import BadReviewsTab from './BadReviewsTab'
import CallReviewCard from './CallReviewCard'
import { CallDetailModal, DealWorkspace } from './CallerDashboard'
import PromoView from './PromoView'
import TrialsBoard from './TrialsBoard'

// Короткое время для списка чатов MAX: сегодня → ЧЧ:ММ, иначе ДД.ММ
function fmtChatTime(ms) {
  if (!ms) return ''
  const d = new Date(Number(ms))
  const now = new Date()
  return d.toDateString() === now.toDateString()
    ? d.toLocaleTimeString('ru', { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString('ru', { day: '2-digit', month: '2-digit' })
}

// Кабинет сопроводителя: шапка + тумблер «На смене» + очередь реальных задач + карточка.
// Стили блока задач взяты из согласованного макета и заскоуплены под .sopwrap.
// Задачи тянутся с /api/support-tasks (движок supportTasks.js). Пока карточка — универсальная
// (контекст + кнопки итога по типу); богатый UI (чат/причины) вернём, когда пойдут реальные сигналы с meta.

export const TASK_CSS = `
.sopwrap { max-width:1180px; margin:0 auto; padding:22px 16px 40px; display:grid; grid-template-columns:1fr 330px; gap:18px; align-items:start; color:#0F172A; }
@media (max-width:900px){ .sopwrap { grid-template-columns:1fr; } }
.sopwrap .card { background:#fff; border:1px solid #E5E7EB; border-radius:18px; overflow:hidden; box-shadow:0 10px 30px rgba(15,23,42,.06); }
.sopwrap .chead { padding:18px 22px; border-bottom:1px solid #EEF2F6; display:flex; align-items:center; gap:14px; }
.sopwrap .chead .ava { width:46px; height:46px; border-radius:12px; background:#38BDF8; color:#fff; display:flex; align-items:center; justify-content:center; font-weight:700; font-size:20px; }
.sopwrap .chead .ttl b { font-size:18px; }
.sopwrap .chead .ttl .sub { font-size:12.5px; color:#94A3B8; margin-top:2px; }
.sopwrap .chead .qn { margin-left:auto; font-size:11px; color:#94A3B8; font-weight:600; text-align:right; }
.chead .trialbtn { margin-left:auto; height:40px; padding:0 18px; border-radius:12px; font-weight:700; font-size:13.5px; color:#fff; background:#FBBF24; border:none; box-shadow:0 1px 0 rgba(180,83,9,0.2); cursor:pointer; }
.sopwrap .banner { margin:16px 22px 0; border-radius:12px; padding:12px 14px; font-size:13.5px; font-weight:600; display:flex; align-items:center; gap:9px; }
.sopwrap .banner.red { background:#FEF2F2; color:#B91C1C; border:1px solid #FECACA; }
.sopwrap .banner.amber { background:#FFF7ED; color:#B45309; border:1px solid #FDE68A; }
.sopwrap .banner.blue { background:#EFF6FF; color:#1D4ED8; border:1px solid #BFDBFE; }
.sopwrap .banner.purple { background:#F5F3FF; color:#6D28D9; border:1px solid #DDD6FE; }
.sopwrap .banner.green { background:#ECFDF5; color:#047857; border:1px solid #A7F3D0; }
.sopwrap .banner .tag { font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:.04em; background:#fff; padding:3px 8px; border-radius:6px; white-space:nowrap; }
.sopwrap .body { padding:16px 22px 22px; }
.sopwrap .panel { background:#F8FAFC; border:1px solid #EEF2F6; border-radius:14px; padding:16px; }
.sopwrap .panel h3 { font-size:11px; text-transform:uppercase; letter-spacing:.05em; color:#94A3B8; font-weight:700; margin-bottom:12px; }
.sopwrap .row { display:flex; justify-content:space-between; gap:12px; padding:8px 0; border-bottom:1px dashed #EEF2F6; font-size:13.5px; }
.sopwrap .row:last-child { border-bottom:none; }
.sopwrap .row .k { color:#94A3B8; }
.sopwrap .row .v { font-weight:600; text-align:right; }
.sopwrap .btn { font-size:13px; font-weight:700; padding:11px 16px; border-radius:10px; cursor:pointer; border:1px solid transparent; }
.sopwrap .btn.quiet { background:#fff; color:#475569; border-color:#E2E8F0; }
.sopwrap .btn.yes { background:#10B981; color:#fff; }
.sopwrap .btn.no  { background:#fff; color:#B91C1C; border-color:#FECACA; }
.sopwrap .sep { font-size:12px; color:#94A3B8; font-weight:600; margin:16px 22px 9px; display:flex; align-items:center; gap:8px; }
.sopwrap .sep::after { content:''; flex:1; height:1px; background:#EEF2F6; }
.sopwrap .actrow { display:flex; gap:9px; flex-wrap:wrap; padding:0 22px 22px; }
.sopwrap .coldgrid { display:grid; grid-template-columns:minmax(0,0.95fr) minmax(0,1.05fr); gap:2px 22px; margin-top:14px; padding:0 22px; }
.sopwrap .coldgrid > div { min-width:0; }
.sopwrap .cf-cap { font-size:10.5px; font-weight:700; letter-spacing:.08em; color:#98A2B3; text-transform:uppercase; padding:0 0 6px; }
.sopwrap .cf-row { display:flex; align-items:center; gap:6px; min-height:40px; font-size:12.5px; }
.sopwrap .cf-k { flex:none; color:#7B8794; font-size:12px; white-space:nowrap; }
.sopwrap .cf-k.req::after { content:' *'; color:#EF4444; }
.sopwrap .cf-in { flex:0 1 auto; min-width:56px; border:1px solid #E2E8F0; border-radius:9px; padding:7px 10px; background:#fff; font-weight:600; color:#0F172A; font-size:12.5px; outline:none; }
.sopwrap .cf-in.filled { background:#F0F9FF; border-color:#D6ECFB; }
.sopwrap .cf-hist { grid-column:1 / -1; margin-top:8px; background:#F0F9FF; border:1px solid #BAE6FD; border-radius:12px; padding:10px 14px; font-size:12px; line-height:1.5; color:#0369A1; }
.sopwrap .cf-pill { grid-column:1 / -1; margin-top:8px; display:flex; justify-content:flex-end; }
.sopwrap .cf-pill span { font-size:11.5px; font-weight:700; color:#B45309; background:#FFFBEB; border:1px solid #FDE68A; border-radius:999px; padding:4px 12px; }
.sopwrap .cf-form { display:flex; gap:8px; margin-top:10px; flex-wrap:wrap; align-items:center; }
.sopwrap .cold-badge { margin-left:auto; align-self:flex-start; font-size:10px; font-weight:800; letter-spacing:.03em; color:#0369A1; background:#F0F9FF; border:1px solid #BAE6FD; border-radius:6px; padding:2px 8px; text-transform:uppercase; white-space:nowrap; }

.sopwrap .side { display:flex; flex-direction:column; gap:16px; }
.sopwrap .skpi { background:#fff; border:1px solid #E5E7EB; border-radius:16px; padding:16px; display:flex; gap:12px; }
.sopwrap .skpi .num { font-size:26px; font-weight:800; line-height:1; }
.sopwrap .skpi .lbl { font-size:12px; color:#64748B; margin-top:4px; }
.sopwrap .queue { background:#fff; border:1px solid #E5E7EB; border-radius:16px; padding:14px 12px 8px; }
.sopwrap .queue h4 { font-size:12px; text-transform:uppercase; letter-spacing:.05em; color:#94A3B8; font-weight:700; margin-bottom:10px; padding:0 4px; }
.sopwrap .qitem { display:flex; align-items:flex-start; gap:10px; padding:10px 8px; border-radius:10px; cursor:pointer; }
.sopwrap .qitem.cur { background:#F0F9FF; box-shadow:inset 0 0 0 1px #BAE6FD; }
.sopwrap .qitem:hover:not(.cur) { background:#F8FAFC; }
.sopwrap .qitem .dot { width:9px; height:9px; border-radius:50%; flex:none; margin-top:5px; }
.sopwrap .dot.r { background:#EF4444; } .sopwrap .dot.o { background:#F59E0B; } .sopwrap .dot.y { background:#FACC15; } .sopwrap .dot.b { background:#3B82F6; } .sopwrap .dot.p { background:#7C3AED; } .sopwrap .dot.g { background:#10B981; }
.sopwrap .qitem .qn2 { font-size:13px; font-weight:600; }
.sopwrap .qitem .qr { font-size:11.5px; color:#94A3B8; margin-top:2px; }
.sopwrap .qtag { display:inline-block; font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:.02em; padding:1px 6px; border-radius:5px; margin-bottom:3px; }
.sopwrap .qtag.t1 { background:#FFF7ED; color:#C2410C; }
.sopwrap .qtag.t2 { background:#FEFCE8; color:#A16207; }
.sopwrap .qtag.t3 { background:#FEF2F2; color:#B91C1C; }
.sopwrap .qtag.t4 { background:#EFF6FF; color:#1D4ED8; }
.sopwrap .qtag.t5 { background:#F5F3FF; color:#6D28D9; }
.sopwrap .qtag.t6 { background:#ECFDF5; color:#047857; }
.sopwrap .empty { grid-column:1 / -1; background:#fff; border:1px solid #E5E7EB; border-radius:18px; padding:48px 24px; text-align:center; box-shadow:0 10px 30px rgba(15,23,42,.06); }
.sopwrap .empty .big { font-size:15px; font-weight:600; color:#0F172A; }
.sopwrap .empty .small { font-size:13.5px; color:#64748B; margin-top:8px; }

/* «Мои клиенты»: поиск по телефону + карточка найденного */
.cl-col { min-height:200px; }
.cl-phonesearch { display:flex; gap:10px; padding:16px; align-items:center; }
.cl-phonesearch input { flex:1; font-size:14px; border:1px solid #E2E8F0; border-radius:10px; padding:11px 14px; outline:none; font-family:inherit; box-sizing:border-box; }
.cl-phonesearch input:focus { border-color:#38BDF8; }
.cl-hint { padding:16px; text-align:center; color:#94A3B8; font-size:13px; }
.cl-llist { display:flex; flex-direction:column; gap:0; }
.cl-litem { display:flex; align-items:center; gap:10px; padding:10px 0; border-bottom:1px solid #CBD5E1; font-size:13px; }
.cl-llist .cl-litem:last-child { border-bottom:none; }
.cl-dt { font-weight:700; width:124px; flex:none; line-height:1.35; }
/* min-width:0 — иначе длинный текст (напр. ФИО в надгробии) не сжимается, а схлопывается до самого длинного слова и переносится по одному слову на строку */
.cl-meta { flex:1; min-width:0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.cl-st { font-size:9.5px; font-weight:700; padding:0 6px; border-radius:999px; white-space:nowrap; flex:none; }
.cl-st.done { color:#047857; background:#ECFDF5; }
.cl-st.planned { color:#0369A1; background:#E0F2FE; }
.cl-st.skip { color:#B91C1C; background:#FEF2F2; }

/* «Пробные уроки» */
.tr-kpirow { display:grid; grid-template-columns:repeat(3,1fr); gap:14px; margin-bottom:22px; }
.tr-kpi { background:#fff; border:1px solid #E5E7EB; border-radius:16px; padding:16px 18px; cursor:pointer; }
.tr-kpi .num { font-size:26px; font-weight:800; line-height:1; }
.tr-kpi .lbl { font-size:12.5px; color:#64748B; margin-top:6px; }
.tr-kpi.on { box-shadow:inset 0 0 0 2px #38BDF8; }
.tr-kpi.on .num { color:#0369A1; }
.tr-dayhead { font-size:13px; font-weight:700; color:#64748B; text-transform:uppercase; letter-spacing:.05em; margin:22px 4px 10px; }
.tr-dayhead:first-child { margin-top:0; }
.tr-card { background:#fff; border:1px solid #E5E7EB; border-radius:16px; box-shadow:0 6px 18px rgba(15,23,42,.05); padding:16px 18px; margin-bottom:12px; }
.tr-thead { display:flex; align-items:flex-start; gap:14px; }
.tr-time { flex:none; font-size:13px; font-weight:800; color:#0369A1; background:#E0F2FE; border-radius:10px; padding:7px 10px; min-width:46px; text-align:center; }
.tr-ava { flex:none; width:44px; height:44px; border-radius:12px; background:#38BDF8; color:#fff; display:flex; align-items:center; justify-content:center; font-size:17px; font-weight:700; }
.tr-who { flex:1; min-width:0; }
.tr-nm { font-size:16px; font-weight:700; }
.tr-phone { font-size:13px; color:#475569; margin-top:2px; }
.tr-subj { font-size:13px; color:#64748B; margin-top:5px; }
.tr-theadright { flex:none; display:flex; flex-direction:column; align-items:flex-end; gap:8px; }
.tr-st { font-size:11.5px; font-weight:700; padding:4px 10px; border-radius:999px; white-space:nowrap; }
.tr-st.planned { color:#0369A1; background:#E0F2FE; }
.tr-st.confirmed { color:#047857; background:#ECFDF5; }
.tr-st.done { color:#047857; background:#ECFDF5; }
.tr-st.noshow { color:#B91C1C; background:#FEF2F2; }
.tr-st.new { color:#B45309; background:#FFF7ED; }
.tr-st.notstayed { color:#B45309; background:#FFF7ED; }
.tr-infopanel { background:#F8FAFC; border:1px solid #EEF2F6; border-radius:12px; padding:2px 14px; margin-top:12px; }
.tr-irow { display:flex; justify-content:space-between; align-items:baseline; gap:10px; padding:7px 0; border-bottom:1px dashed #EEF2F6; font-size:12.5px; }
.tr-irow:last-child { border-bottom:none; }
.tr-irow .k { color:#94A3B8; flex:none; }
.tr-irow .v { font-weight:600; text-align:right; }
.tr-irow .v.yes { color:#047857; }
.tr-irow .v.no { color:#B91C1C; }
.tr-irow .v.wait { color:#B45309; }
.tr-irow .v.muted { color:#94A3B8; font-weight:400; }
.tasktag { margin-top:12px; display:flex; align-items:center; justify-content:flex-end; gap:8px; font-size:12.5px; font-weight:700; cursor:pointer; }
.tasktag.r { color:#B91C1C; } .tasktag.o { color:#B45309; }
.tasktag .dotpulse { width:7px; height:7px; border-radius:50%; background:currentColor; }
.tasktag span.lnk { text-decoration:underline; text-underline-offset:2px; }

/* Модалки (карточка клиента / задачи) — общие для «Пробных уроков» */
.iconbtn { width:30px; height:30px; border-radius:9px; border:1px solid #E2E8F0; background:#fff; color:#64748B; display:flex; align-items:center; justify-content:center; font-size:13px; cursor:pointer; }
.iconbtn:hover { background:#F8FAFC; }
.overlay { position:fixed; inset:0; background:rgba(15,23,42,.45); display:flex; align-items:center; justify-content:center; z-index:50; padding:20px; }
.modal { background:#fff; border-radius:18px; width:100%; max-width:480px; max-height:90vh; overflow-y:auto; box-shadow:0 20px 60px rgba(15,23,42,.25); }
.mhead { padding:18px 20px; border-bottom:1px solid #EEF2F6; display:flex; align-items:center; gap:12px; }
.mhead .ava { width:44px; height:44px; border-radius:12px; background:#38BDF8; color:#fff; display:flex; align-items:center; justify-content:center; font-weight:700; font-size:18px; flex:none; }
.mhead .ttl b { font-size:16px; display:block; }
.mhead .ttl .sub { font-size:12.5px; color:#94A3B8; margin-top:2px; }
.mhead .x { margin-left:auto; cursor:pointer; color:#94A3B8; font-size:16px; width:28px; height:28px; display:flex; align-items:center; justify-content:center; border-radius:8px; flex:none; }
.mhead .x:hover { background:#F8FAFC; }
.mbody { padding:16px 20px 20px; display:flex; flex-direction:column; gap:14px; }
.mfoot { padding:14px 20px; border-top:1px solid #EEF2F6; display:flex; gap:9px; justify-content:flex-end; flex-wrap:wrap; }
.mpanel { background:#F8FAFC; border:1px solid #EEF2F6; border-radius:14px; padding:14px 16px; }
.mrow { display:flex; justify-content:space-between; gap:12px; padding:7px 0; border-bottom:1px dashed #EEF2F6; font-size:13.5px; }
.mrow:last-child { border-bottom:none; }
.mrow .k { color:#94A3B8; }
.mrow .v { font-weight:600; text-align:right; }
.mbanner { border-radius:12px; padding:12px 14px; font-size:13.5px; font-weight:600; display:flex; align-items:center; gap:9px; }
.mbanner .tag { font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:.04em; background:#fff; padding:3px 8px; border-radius:6px; white-space:nowrap; }
.mbtn { font-size:13px; font-weight:700; padding:10px 16px; border-radius:10px; cursor:pointer; border:1px solid transparent; }
.mbtn.primary { background:#38BDF8; color:#fff; }
.mbtn.quiet { background:#fff; color:#475569; border-color:#E2E8F0; }
.mfield label { display:block; font-size:11px; text-transform:uppercase; letter-spacing:.05em; color:#94A3B8; font-weight:700; margin-bottom:6px; }
.mfield select { width:100%; font-size:14px; border:1px solid #E2E8F0; border-radius:10px; padding:10px 12px; outline:none; font-family:inherit; box-sizing:border-box; background:#fff; appearance:none;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394A3B8'/%3E%3C/svg%3E"); background-repeat:no-repeat; background-position:right 12px center; }
.mfield select:focus { border-color:#38BDF8; }
.mfield input, .mfield textarea { width:100%; font-size:14px; border:1px solid #E2E8F0; border-radius:10px; padding:10px 12px; outline:none; font-family:inherit; box-sizing:border-box; background:#fff; }
.mfield input:focus, .mfield textarea:focus { border-color:#38BDF8; }

/* «Новый клиент» — полная анкета (как у звонильщика), окно шире обычной модалки */
.modal.wide { max-width:760px; }
.anketa-grid { display:grid; grid-template-columns:1fr 1fr; gap:0 28px; }
@media (max-width:620px){ .anketa-grid { grid-template-columns:1fr; } }
.anketa-col-title { font-size:11px; text-transform:uppercase; letter-spacing:.05em; color:#94A3B8; font-weight:700; padding-bottom:6px; margin-bottom:8px; border-bottom:1px solid #F1F5F9; }
.anketa-grid .mfield { margin-bottom:12px; }
.cl-newbtn { display:block; width:calc(100% - 24px); margin:12px 12px 4px; height:42px; border-radius:12px; font-weight:700; font-size:13.5px; color:#fff; background:#38BDF8; border:none; cursor:pointer; }
.cl-newbtn:hover { background:#0EA5E9; }

/* Лента переписки ученик↔препод в карточке «вопрос в чате» (стили из согласованного макета) */
.sopwrap .schat { background:#f8fafc; border:1px solid #EEF2F6; border-radius:14px;
  padding:12px; margin-top:14px; max-height:340px; overflow-y:auto;
  display:flex; flex-direction:column; gap:8px; }
.sopwrap .schat .m { max-width:78%; align-self:flex-start; }
.sopwrap .schat .m .who { font-size:10.5px; font-weight:700; margin:0 0 2px 4px; }
.sopwrap .schat .m.student .who { color:#1D4ED8; }
.sopwrap .schat .m.teacher .who { color:#7C3AED; }
.sopwrap .schat .m .bub { background:#fff; color:#0F172A; border-radius:14px;
  border-bottom-left-radius:4px; padding:9px 12px; font-size:13.5px; line-height:1.4;
  box-shadow:0 1px 2px rgba(15,23,42,.06); word-break:break-word; }
.sopwrap .schat .m .tm { font-size:10px; color:#94A3B8; margin:3px 4px 0; }
.sopwrap .schat .note { align-self:center; font-size:11.5px; color:#94A3B8; padding:4px; }
.sopwrap .schat .phone { align-self:stretch; background:#FFFBEB; color:#B45309; border:1px solid #FDE68A; border-radius:12px; padding:10px 12px; font-size:13px; font-weight:600; }
.sopwrap .schat .phone b { font-size:15px; }
.sopwrap .schat .phone span { display:block; font-weight:500; color:#92400E; font-size:12px; margin-top:2px; }
.sopwrap .schat .m.support { align-self:flex-end; }
.sopwrap .schat .m.support .who { color:#0369A1; text-align:right; margin:0 4px 2px 0; }
.sopwrap .schat .m.support .bub { background:#3bc8f5; color:#fff;
  border-bottom-left-radius:14px; border-bottom-right-radius:4px; }
.sopwrap .schat .m.support .tm { text-align:right; }
.sopwrap .scomposer { display:flex; gap:8px; margin-top:10px; }
.sopwrap .scomposer input { flex:1; border:1px solid #E2E8F0; border-radius:10px;
  padding:10px 12px; font-size:13.5px; outline:none; font-family:inherit; }
.sopwrap .scomposer input:focus { border-color:#3bc8f5; }
.sopwrap .scomposer button { background:#3bc8f5; color:#fff; border:0; border-radius:10px;
  padding:10px 16px; font-size:13px; font-weight:700; cursor:pointer; white-space:nowrap; }
.sopwrap .scomposer button:disabled { opacity:.5; cursor:default; }

/* Срочная задача «вопрос в чате» — пульсирующая плашка-алерт под шапкой */
.sop-urgent { position:sticky; top:56px; z-index:25; background:#DC2626; color:#fff;
  padding:12px 16px; display:flex; align-items:center; justify-content:center; gap:14px;
  font-size:14px; font-weight:700; box-shadow:0 6px 18px rgba(220,38,38,.35);
  animation:sopPulse 1.1s ease-in-out infinite; }
@keyframes sopPulse { 0%,100% { background:#DC2626; } 50% { background:#B91C1C; } }
.sop-urgent .who { font-weight:600; opacity:.95; }
.sop-urgent button { background:#fff; color:#B91C1C; border:0; border-radius:10px;
  padding:9px 18px; font-size:13.5px; font-weight:800; cursor:pointer; white-space:nowrap; }
.sop-urgent button:hover { background:#FEF2F2; }

/* «⚠️ Расхождения» — баланс платформы vs МойКласс */
.disc-navbadge { background:#DC2626; color:#fff; font-size:10.5px; font-weight:800; border-radius:999px; padding:1px 6px; line-height:1.4; }
.disc-kpirow { display:grid; grid-template-columns:repeat(3,1fr); gap:14px; margin-bottom:18px; }
@media (max-width:620px){ .disc-kpirow { grid-template-columns:1fr; } }
.disc-kpi { background:#fff; border:1px solid #E5E7EB; border-radius:16px; padding:16px 18px; }
.disc-kpi .num { font-size:26px; font-weight:800; line-height:1; }
.disc-kpi .lbl { font-size:12.5px; color:#64748B; margin-top:6px; }
.disc-kpi.warn .num { color:#B45309; }
.disc-kpi.crit .num { color:#B91C1C; }
.disc-banner { border-radius:12px; padding:12px 14px; font-size:13.5px; font-weight:600; background:#EFF6FF; color:#1D4ED8; border:1px solid #BFDBFE; margin-bottom:18px; line-height:1.45; }
.disc-row { display:flex; align-items:center; gap:14px; padding:13px 18px; border-bottom:1px solid #F8FAFC; }
.disc-row:last-child { border-bottom:none; }
.disc-ava { width:36px; height:36px; border-radius:10px; background:#E2E8F0; color:#475569; display:flex; align-items:center; justify-content:center; font-size:13px; font-weight:700; flex:none; }
.disc-who { min-width:0; width:168px; flex:none; }
.disc-who .nm { font-size:13.5px; font-weight:600; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.disc-who .sub { font-size:11.5px; color:#94A3B8; margin-top:1px; }
.disc-action { flex:1; min-width:0; }
.disc-action .verb { font-size:14px; font-weight:800; display:flex; align-items:center; gap:6px; white-space:nowrap; }
.disc-action .verb.down { color:#B45309; }
.disc-action .verb.up { color:#047857; }
.disc-action .cap { font-size:11.5px; color:#94A3B8; margin-top:2px; }
.disc-action .cap s { color:#CBD5E1; text-decoration-color:#CBD5E1; }
.disc-btns { display:flex; gap:8px; flex:none; }
.disc-btns .mklink, .disc-btns .fixbtn { font-size:12.5px; font-weight:700; padding:8px 13px; border-radius:9px; cursor:pointer; border:1px solid #E2E8F0; background:#fff; flex:none; white-space:nowrap; text-decoration:none; display:inline-flex; align-items:center; }
.disc-btns .mklink { color:#0369A1; }
.disc-btns .mklink:hover { background:#F0F9FF; border-color:#BAE6FD; }
.disc-btns .fixbtn { color:#334155; }
.disc-btns .fixbtn:hover:not(:disabled) { background:#ECFDF5; border-color:#A7F3D0; color:#047857; }
.disc-btns .fixbtn:disabled { opacity:.6; cursor:default; }
@media (max-width:620px){ .disc-row { flex-wrap:wrap; } .disc-action { width:100%; order:3; } }
`

// Короткий звуковой сигнал «срочная задача» (WebAudio, без файла).
// Может не сыграть, если менеджер ещё ни разу не кликал по странице (политика браузера) — не критично.
function playUrgentBeep() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)()
    const notes = [880, 660, 880, 660, 880, 660]
    notes.forEach((freq, i) => {
      const osc = ctx.createOscillator()
      const gain = ctx.createGain()
      osc.type = 'sine'
      osc.frequency.value = freq
      const t0 = ctx.currentTime + i * 0.22
      gain.gain.setValueAtTime(0.0001, t0)
      gain.gain.exponentialRampToValueAtTime(0.28, t0 + 0.02)
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.19)
      osc.connect(gain); gain.connect(ctx.destination)
      osc.start(t0); osc.stop(t0 + 0.2)
    })
    setTimeout(() => ctx.close().catch(() => {}), 2200)
  } catch { /* звук не критичен */ }
}

// Конфиг по типу задачи: ярлык, цвет точки/плашки, кнопки итога
const TYPES = {
  chat:      { tag: 't4', dot: 'b', banner: 'blue',  label: 'Вопрос в чате',        outcomes: [{ k: 'решено', t: '✓ Решено', c: 'yes' }, { k: 'передал преподу', t: '↪ Передать преподу', c: 'quiet' }] },
  noconfirm: { tag: 't2', dot: 'y', banner: 'amber', label: 'Первый урок: не подтвердил', outcomes: [{ k: 'подтвердил', t: '✓ Подтвердил — придёт', c: 'yes' }, { k: 'перезаписал', t: '↪ Перезаписать', c: 'quiet', action: 'reschedule' }, { k: 'не выйдет', t: '✗ Не выйдет', c: 'no' }, { k: 'не дозвонился', t: '↻ Не дозвонился', c: 'quiet' }] },
  noshow:    { tag: 't3', dot: 'r', banner: 'red',   label: 'Не зашёл на урок',      outcomes: [{ k: 'зашёл', t: '✓ Зашёл', c: 'yes' }, { k: 'не зашёл', t: '✗ Не зашёл', c: 'no' }] },
  rebook:    { tag: 't2', dot: 'y', banner: 'amber', label: 'Перезаписать на пробный', outcomes: [{ k: 'перезаписал', t: '✓ Перезаписал на пробный', c: 'yes' }, { k: 'не дозвонился', t: '↻ Не дозвонился', c: 'quiet' }, { k: 'отказался', t: '✗ Отказался', c: 'no' }] },
  // 22.09: самозапись без урока после окна ожидания (макет _notime-task-preview.html)
  notime:    { tag: 't2', dot: 'y', banner: 'amber', label: 'Не договорились о времени', outcomes: [{ k: 'записал', t: '✓ Записал на урок', c: 'yes' }, { k: 'не дозвонился', t: '↻ Не дозвонился', c: 'quiet' }, { k: 'не актуально', t: '✗ Не актуально', c: 'no' }] },
  selfbook:  { tag: 't6', dot: 'g', banner: 'green', label: 'Сам записался',         outcomes: [{ k: 'подтвердил', t: '✓ Подтвердил — придёт', c: 'yes' }, { k: 'отменил', t: '✗ Отменил запись', c: 'no' }] },
  noteacher: { tag: 't3', dot: 'r', banner: 'red',   label: 'Препод не подтвердил',  outcomes: [{ k: 'решено', t: '✓ Решено — урок состоится', c: 'yes' }, { k: 'урок не состоится', t: '✗ Урок не состоится', c: 'no' }] },
  // 16.09: 5-я минута урока, ученик в комнате, препода нет и не активен в кабинете (макет _teacher-noshow-task-preview.html)
  // 07.10: увод общения мимо платформы (макет _contact-violation-task-preview.html). «Связался» включается после сообщения преподавателю в чат; «Вернуть/Оставить» — только после бана
  contact_violation: { tag: 't3', dot: 'r', banner: 'red', label: 'Увод общения мимо платформы', outcomes: [{ k: 'связался с преподавателем', t: '✓ Связался с преподавателем', c: 'yes', needWrote: true }, { k: 'вернул на сайт', t: '↩ Вернуть на сайт', c: 'quiet', action: 'cvrestore', onlyBan: true }, { k: 'оставил бан', t: '✗ Оставить бан', c: 'no', onlyBan: true }] },
  teacher_noshow: { tag: 't3', dot: 'r', banner: 'red', label: 'Препод не вышел', outcomes: [{ k: 'решено', t: '✓ Решено — урок состоится', c: 'yes' }, { k: 'перезаписал', t: '↪ Перезаписать', c: 'quiet', action: 'reschedule' }, { k: 'урок не состоится', t: '✗ Урок не состоится', c: 'no' }] },
  // 24.09: занимался, 7 дней без уроков и ничего впереди (макет _lapsed-task-preview.html); «Отказ» → окно причины, как в карточке клиента
  lapsed:    { tag: 't4', dot: 'b', banner: 'blue',  label: 'Пропал ученик',         outcomes: [{ k: 'записал на урок', t: '✓ Записал на урок', c: 'yes' }, { k: 'не дозвонился', t: '↻ Не дозвонился', c: 'quiet' }, { k: 'отказ', t: '✗ Отказ', c: 'no', action: 'refuse' }] },
  // 06.10: «Допродать предмет» (макет _upsell5-task-preview.html). «Взял новый предмет» → кнопки записи из «Мои клиенты»; «Перезвонить» = «Перенести звонок»
  upsell:    { tag: 't4', dot: 'b', banner: 'blue',  label: 'Допродать предмет',     outcomes: [{ k: 'взял новый предмет', t: '✓ Взял новый предмет', c: 'yes', action: 'upsellbook' }, { k: 'перезвонить', t: '↪ Подумает — перезвонить', c: 'quiet', action: 'snooze' }, { k: 'не дозвонился', t: '↻ Не дозвонился', c: 'quiet' }, { k: 'не нужно', t: '✗ Не нужно', c: 'no', action: 'upsellno' }] },
  nobook:    { tag: 't1', dot: 'o', banner: 'amber', label: 'Недозабронировал',      outcomes: [{ k: 'актуально', t: '✓ Актуально', c: 'yes' }, { k: 'не актуально', t: '✗ Не актуально', c: 'no' }] },
  // 24.09.2026: ученик сам отменил пробный урок — перезвонить и попробовать вернуть
  trial_cancel: { tag: 't3', dot: 'r', banner: 'red', label: 'Отменил пробный', outcomes: [{ k: 'перезаписал', t: '✓ Перезаписал на пробный', c: 'yes' }, { k: 'не дозвонился', t: '↻ Не дозвонился', c: 'quiet' }, { k: 'отказался', t: '✗ Отказался совсем', c: 'no' }] },
  notstayed: { tag: 't5', dot: 'p', banner: 'purple', label: 'Не остался после пробного', outcomes: [{ k: 'вернулся', t: '✓ Записали на постоянные', c: 'yes' }, { k: 'не вернулся', t: '✗ Не вернулся', c: 'no' }] },
  selfreg:   { tag: 't6', dot: 'g', banner: 'green', label: 'У нас саморег! Позвонить!',
    checklist: [
      'Рассказать, как проходит оплата',
      'Рассказать, что после первого урока можно сменить преподавателя',
      'Предложить подключиться и проверить связь',
      'Рассказать про приложения',
    ],
    outcomes: [
      { k: 'позвонил, всё рассказал', t: '✓ Позвонил — всё рассказал', c: 'yes' },
      { k: 'не дозвонился', t: '↻ Не дозвонился', c: 'quiet' },
      { k: 'не актуально', t: '✗ Не актуально', c: 'no' },
    ] },
  other:     { tag: 't1', dot: 'o', banner: 'amber', label: 'Задача',                outcomes: [{ k: 'готово', t: '✓ Готово', c: 'yes' }] },
  own_task:  { tag: 't5', dot: 'p', banner: 'purple', label: 'Своя задача',          outcomes: [{ k: 'готово', t: '✓ Выполнена', c: 'yes' }] },
}
// Подпись типа задачи: гостевой чат (meta.guestId) подписываем «Пишет гость»
const taskLabel = (t) => (t && t.meta && (t.meta.kind === 'trial_today' || t.meta.kind === 'trial_done')) ? 'Автозадача' : (t && t.meta && t.meta.phoneLeftAt) ? 'Гость оставил номер' : (t && t.meta && t.meta.guestId) ? 'Пишет гость' : T(t.type).label
// Гость оставил номер в чате (meta.phoneLeftAt, 29.09): жёлтая шапка, телефон в строке и плашка в переписке
const isPhoneLeft = (t) => !!(t && t.meta && t.meta.phoneLeftAt)
const fmtPhoneNice = (p) => { const d = String(p || '').replace(/\D/g, ''); return d.length === 11 ? '+7 ' + d.slice(1, 4) + ' ' + d.slice(4, 7) + '-' + d.slice(7, 9) + '-' + d.slice(9) : String(p || '') }
const fmtMskDateTime = (iso) => { const x = new Date(iso); return isNaN(x) ? '' : x.toLocaleString('ru-RU', { timeZone: 'Europe/Moscow', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' }) }
const T = (t) => TYPES[t] || TYPES.other

// «Мои клиенты» → 📅 Перенести урок. Тот же принцип, что и «Перенести» в «Мои
// пробные» ЛК звонильщика (CallerDashboard.js): свободные окошки ТОГО ЖЕ препода,
// выбор дня+времени, подтверждение — только для обычных (не пробных) уроков.
function RescheduleLessonModal({ studentId, lesson, onClose, onDone }) {
  const [slots, setSlots] = useState(null)
  const [error, setError] = useState(null)
  const [activeDate, setActiveDate] = useState(null)
  const [chosen, setChosen] = useState(null)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    let alive = true
    api.get(`/api/platform/support-clients/${studentId}/${lesson.is_trial ? 'trials/' + lesson.booking_id : 'lessons/' + lesson.lesson_id}/reschedule-slots`)
      .then(r => {
        if (!alive) return
        if (!r.data.ok) { setError(r.data.error || 'Не удалось получить окошки'); return }
        const s = r.data.slots || []
        setSlots(s)
        if (s.length) setActiveDate(s[0].date)
      })
      .catch(e => { if (alive) setError(e.response?.data?.error || 'Платформа недоступна') })
    return () => { alive = false }
  }, [studentId, lesson.lesson_id])

  const dayLabel = (iso) => {
    try { return new Date(iso + 'T00:00:00').toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' }) }
    catch { return iso }
  }

  const days = slots ? [...new Set(slots.map(s => s.date))] : []
  const daySlots = slots ? slots.filter(s => s.date === activeDate) : []

  async function confirm() {
    if (!chosen) return
    setSaving(true)
    setError(null)
    try {
      const r = await api.post(`/api/platform/support-clients/${studentId}/${lesson.is_trial ? 'trials/' + lesson.booking_id : 'lessons/' + lesson.lesson_id}/reschedule`, {
        new_date: chosen.date, new_begin_time: chosen.begin_time,
      })
      if (!r.data.ok) { setError(r.data.error || 'Не удалось перенести'); setSaving(false); return }
      onDone()
    } catch (e) {
      setError(e.response?.data?.error || 'Платформа недоступна')
      setSaving(false)
    }
  }

  return (
    <div className="overlay" onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal">
        <div className="mhead">
          <div className="ttl">
            <b>Перенести урок</b>
            <div className="sub">{lesson.subject || 'Предмет не указан'} · сейчас {lesson.date} {lesson.begin_time} · {lesson.teacher || 'препод не указан'}</div>
          </div>
          <div className="x" onClick={onClose}>✕</div>
        </div>
        <div className="mbody">
          {error && <div style={{ color: '#B91C1C', fontSize: 13 }}>{error}</div>}
          {!slots && !error && <div className="cl-hint">Загрузка окошек...</div>}
          {slots && slots.length === 0 && <div className="cl-hint">У препода нет свободных окошек</div>}

          {days.length > 0 && (
            <>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {days.map(d => (
                  <button key={d} onClick={() => { setActiveDate(d); setChosen(null) }}
                    className="mbtn quiet" style={activeDate === d ? { background: '#F0F9FF', color: '#0369A1', borderColor: '#BAE6FD' } : {}}>
                    {dayLabel(d)}
                  </button>
                ))}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 }}>
                {daySlots.map(s => (
                  <button key={s.begin_time} onClick={() => setChosen(s)}
                    className="mbtn quiet" style={chosen === s ? { background: '#38BDF8', color: '#fff', borderColor: '#38BDF8' } : {}}>
                    {s.begin_time}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
        <div className="mfoot">
          <button className="mbtn quiet" onClick={onClose}>Отмена</button>
          <button className="mbtn primary" disabled={!chosen || saving} onClick={confirm} style={!chosen || saving ? { opacity: 0.5, cursor: 'default' } : {}}>
            {saving ? 'Переношу...' : chosen ? `Подтвердить на ${chosen.begin_time}` : 'Выберите время'}
          </button>
        </div>
      </div>
    </div>
  )
}

// «Мои клиенты» → «Поставить уроки»: обычные ПЛАТНЫЕ уроки без пробного
// (Антон 29.07: старые клиенты возвращаются). Преподы берутся из истории клиента,
// занятые окна подсвечены, можно выбрать несколько времён и повтор по неделям.
// Дни недели для сводки: порядок как в интерфейсе, воскресенье последним.
const WD_SHORT = [[1, 'пн'], [2, 'вт'], [3, 'ср'], [4, 'чт'], [5, 'пт'], [6, 'сб'], [0, 'вс']]

// Быстрые «до какой даты»: конец учебного года — то, как ставят бронь.
function untilPresets() {
  const now = new Date()
  const y = now.getFullYear()
  const nextMay = new Date(Date.UTC(now.getUTCMonth() > 4 ? y + 1 : y, 4, 31))
  const nextJune = new Date(Date.UTC(now.getUTCMonth() > 5 ? y + 1 : y, 5, 30))
  const newYear = new Date(Date.UTC(y, 11, 31))
  const iso = d => d.toISOString().slice(0, 10)
  const out = []
  if (newYear > now) out.push(['до Нового года', iso(newYear)])
  out.push(['до конца мая', iso(nextMay)], ['до конца июня', iso(nextJune)])
  return out
}

export function AddLessonsModal({ studentId, clientName, onClose, onDone, paid, grade }) {
  const [ctx, setCtx] = useState(null)
  const [error, setError] = useState(null)
  const [teacher, setTeacher] = useState(null)
  const [cls, setCls] = useState(null)          // выбранная группа (предмет+уровень)
  const [tres, setTres] = useState([])
  const [tsearching, setTsearching] = useState(false)
  const [date, setDate] = useState(() => {
    const d = new Date(Date.now() + 86400000)
    return d.toISOString().slice(0, 10)
  })
  const [times, setTimes] = useState([])
  const [busy, setBusy] = useState([])
  const [avail, setAvail] = useState([])
  const [dayTimes, setDayTimes] = useState({})   // weekday → [times] (режим «дни недели»)
  const [dayAvail, setDayAvail] = useState({})   // weekday → { date, avail, busy }
  const [tq, setTq] = useState('')             // поиск по фамилии преподавателя
  const [weekdays, setWeekdays] = useState([]) // 0=вс…6=сб, пусто = один день
  const [repeat, setRepeat] = useState('weekly')
  const [until, setUntil] = useState(() => new Date(Date.now() + 30 * 86400000).toISOString().slice(0, 10))
  const [saving, setSaving] = useState(false)
  const [result, setResult] = useState(null)
  const [batchProgress, setBatchProgress] = useState(null)
  // Платный режим («Записать на платное»): любой предмет + редактируемая цена.
  const [paidSubject, setPaidSubject] = useState(TRIAL_PICKER_SUBJECTS[0])
  const [paidPrice, setPaidPrice] = useState(paidDefaultPrice(TRIAL_PICKER_SUBJECTS[0]))

  // Подсказка ОГЭ/ЕГЭ по классу ученика (кейс Кожохина 21.08: вписали обычную
  // «Математику» 9-класснику вместо «Математика ОГЭ» → урок сел базовым, цена/
  // уровень потерялись). Если выбран базовый предмет без уровня, ученик 9 кл (→ОГЭ)
  // или 10–11 кл (→ЕГЭ), и есть готовый вариант «<предмет> ОГЭ/ЕГЭ» — предлагаем.
  const gradeNum = parseInt(String(grade || '').replace(/\D/g, ''), 10)
  const wantLevel = gradeNum === 9 ? 'ОГЭ' : (gradeNum === 10 || gradeNum === 11) ? 'ЕГЭ' : null
  const suggestSubject = (wantLevel && !/(ОГЭ|ЕГЭ)/i.test(paidSubject)) ? `${paidSubject} ${wantLevel}` : null
  const levelHint = (suggestSubject && TRIAL_PICKER_SUBJECTS.includes(suggestSubject))
    ? { to: suggestSubject, level: wantLevel } : null

  const SLOTS = ['09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00']

  useEffect(() => {
    let alive = true
    api.get(`/api/platform/support-clients/${studentId}/lesson-context`)
      .then(r => {
        if (!alive) return
        if (!r.data.ok) { setError(r.data.error || 'Не удалось получить данные'); return }
        setCtx(r.data)
        if (r.data.teachers && r.data.teachers.length) {
          const t = r.data.teachers[0]
          setTeacher(t)
          const c = (r.data.classes || []).find(x => x.class_id === t.class_id)
          if (c) setCls(c)
        }
      })
      .catch(e => { if (alive) setError(e.response?.data?.error || 'Платформа недоступна') })
    return () => { alive = false }
  }, [studentId])

  // Смена предмета/уровня → цена сбрасывается на дефолт по уровню (ОГЭ 1400 /
  // ЕГЭ 1600 / обычная 1200). Дешевле — менеджер меняет поле руками.
  useEffect(() => { if (paid) setPaidPrice(paidDefaultPrice(paidSubject)) }, [paid, paidSubject])

  // Платный режим: виртуальная «группа» из выбранного предмета + цены.
  useEffect(() => {
    if (!paid) return
    const m = String(paidSubject).match(/(ОГЭ|ЕГЭ)/i)
    const level = m ? (m[1].toUpperCase() === 'ОГЭ' ? 'oge' : 'ege') : null
    setCls({ name: paidSubject, class_id: 0, level, price_rub: paidPrice, price_source: 'manual' })
  }, [paid, paidSubject, paidPrice])

  // список преподов предмета — при каждой смене группы/даты
  useEffect(() => {
    if (!cls) return
    loadSubjectTeachers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cls && cls.class_id, cls && cls.name, date])

  // занятость препода на выбранную дату
  useEffect(() => {
    if (!teacher || !date) return
    let alive = true
    setBusy([]); setAvail([])
    api.get(`/api/platform/support-clients/${studentId}/lesson-busy`, { params: { teacher_mk_id: teacher.mk_id, date } })
      .then(r => { if (alive && r.data.ok) { setBusy(r.data.busy || []); setAvail(r.data.avail || []) } })
      .catch(() => {})
    return () => { alive = false }
  }, [studentId, teacher, date])

  const isBusy = (t) => busy.some(b => t >= b.from && t < b.to)
  const toggleTime = (t) => {
    if (isBusy(t)) return
    setTimes(prev => prev.includes(t) ? prev.filter(x => x !== t) : [...prev, t].sort())
  }

  // Реальные окна доступности препода (avail) минус занятость (busy).
  // Старт валиден, если 55-мин урок укладывается в открытое окно и не пересекается с уроком.
  const _pm = (hhmm) => { const a = String(hhmm).split(':'); return (Number(a[0]) || 0) * 60 + (Number(a[1]) || 0) }
  const _fm = (min) => String(Math.floor(min / 60)).padStart(2, '0') + ':' + String(min % 60).padStart(2, '0')
  const LESSON_DUR = 55
  const computeSlots = (av, bz) => {
    const out = []
    for (const w of (av || [])) {
      const wf = _pm(w.from), wt = _pm(w.to)
      for (let sMin = wf; sMin + LESSON_DUR <= wt; sMin += 30) {
        const end = sMin + LESSON_DUR
        const clash = (bz || []).some(bb => sMin < _pm(bb.to) && end > _pm(bb.from))
        if (!clash) out.push(_fm(sMin))
      }
    }
    return out
  }
  const slotOptions = computeSlots(avail, busy)
  // выбранные времена (одиночный режим), которых больше нет в окошках, — убираем
  useEffect(() => {
    setTimes(prev => { const f = prev.filter(t => slotOptions.includes(t)); return f.length === prev.length ? prev : f })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avail, busy])
  // Режим «дни недели»: у каждого выбранного дня — свои окошки (первое вхождение
  // дня в диапазоне) и своё время. Тянем доступность на первую такую дату.
  const firstOccurISO = (startISO, wd) => {
    const d = new Date(startISO + 'T00:00:00Z')
    for (let i = 0; i < 7; i++) { if (d.getUTCDay() === wd) return d.toISOString().slice(0, 10); d.setUTCDate(d.getUTCDate() + 1) }
    return startISO
  }
  useEffect(() => {
    if (!teacher || !date || !weekdays.length) { setDayAvail({}); return }
    let alive = true
    ;(async () => {
      const next = {}
      for (const wd of weekdays) {
        const dd = firstOccurISO(date, wd)
        try {
          const r = await api.get(`/api/platform/support-clients/${studentId}/lesson-busy`, { params: { teacher_mk_id: teacher.mk_id, date: dd } })
          next[wd] = { date: dd, avail: (r.data && r.data.ok && r.data.avail) || [], busy: (r.data && r.data.ok && r.data.busy) || [] }
        } catch { next[wd] = { date: dd, avail: [], busy: [] } }
      }
      if (alive) setDayAvail(next)
    })()
    return () => { alive = false }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentId, teacher, date, JSON.stringify(weekdays)])
  // подрезаем выбранные времена дней, которых больше нет в окошках
  useEffect(() => {
    setDayTimes(prev => {
      const next = {}
      for (const wd of weekdays) {
        const slots = computeSlots(dayAvail[wd] && dayAvail[wd].avail, dayAvail[wd] && dayAvail[wd].busy)
        next[wd] = (prev[wd] || []).filter(t => slots.includes(t))
      }
      return next
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dayAvail, JSON.stringify(weekdays)])

  // сколько уроков получится
  // Считаем ровно так же, как бэкенд (buildDates): выбранные дни недели в
  // диапазоне, иначе прежний шаг. Потолок 150 — решение Антона 30.07.
  const count = (() => {
    // Режим «дни недели»: у каждого дня своё время (dayTimes[wd]).
    if (weekdays.length) {
      if (!until) return 0
      const a = new Date(date + 'T00:00:00Z'), b = new Date(until + 'T00:00:00Z')
      if (b < a) return 0
      let n = 0
      for (const d = new Date(a); d <= b && n < 150; d.setUTCDate(d.getUTCDate() + 1)) {
        const wd = d.getUTCDay()
        if (weekdays.includes(wd)) n += (dayTimes[wd] || []).length
      }
      return Math.min(n, 150)
    }
    if (!times.length) return 0
    if (!until) return times.length
    const a = new Date(date + 'T00:00:00Z'), b = new Date(until + 'T00:00:00Z')
    if (b < a) return times.length
    if (repeat === 'once') return times.length
    const step = repeat === 'weekly' ? 7 : 1
    const days = Math.floor((b - a) / 86400000 / step) + 1
    return Math.min(days * times.length, 150)
  })()

  // Преподаватели, которые ВЕДУТ выбранный предмет (тот же подбор, что при смене
  // препода на пробном) + занятость на выбранные дату/время.
  // Грузим ВСЕГДА при смене предмета — иначе в списке оставались только те 1-2,
  // кто вёл клиента раньше (жалоба Антона 29.07: «список только из двух преподов»).
  async function loadSubjectTeachers() {
    if (!cls) return
    setTsearching(true); setTres([])
    const m = cls.name.match(/^(.*?)(\s+(ОГЭ|ЕГЭ))?$/i)
    const subject = (m ? m[1] : cls.name).trim()
    const level = cls.level === 'oge' ? 'ОГЭ' : cls.level === 'ege' ? 'ЕГЭ' : ''
    try {
      const r = await api.get(`/api/platform/support-clients/${studentId}/lesson-teachers`, {
        params: { subject, level, date, time: times[0] || '', price_rub: cls.price_rub },
      })
      setTres((r.data && r.data.teachers) || [])
    } catch { setTres([]) }
    setTsearching(false)
  }

  function pollBatch(batchId) {
    let stop = false
    const tick = () => {
      if (stop) return
      api.get(`/api/platform/support-clients/${studentId}/lesson-batch/${batchId}`)
        .then(r => {
          if (!r.data || !r.data.ok) return
          setBatchProgress(r.data)
          if (r.data.status === 'finished') { stop = true; return }
          setTimeout(tick, 3000)
        })
        .catch(() => { setTimeout(tick, 6000) })
    }
    tick()
  }

  async function submit() {
    if (!teacher || count < 1) return
    setSaving(true); setError(null)
    try {
      const body = { teacher_mk_id: teacher.mk_id, class_id: cls ? cls.class_id : teacher.class_id, date }
      if (paid) {
        const m = String(paidSubject).match(/(ОГЭ|ЕГЭ)/i)
        body.subject = paidSubject
        body.level = m ? m[1].toUpperCase() : null
        body.price_rub = paidPrice
        body.class_id = 0   // бэк резолвит class_id из subject
      }
      if (weekdays.length) {
        const dt = {}
        for (const wd of weekdays) if ((dayTimes[wd] || []).length) dt[wd] = dayTimes[wd]
        body.day_times = dt
        body.until = until
      } else {
        body.times = times
        body.repeat = repeat
        body.weekdays = []
        body.until = repeat !== 'once' ? until : null
      }
      const r = await api.post(`/api/platform/support-clients/${studentId}/lessons`, body)
      if (!r.data.ok) { setError(r.data.error || 'Не удалось создать уроки'); setSaving(false); return }
      setResult(r.data)
      setSaving(false)
      // Уроки уезжают в МойКласс фоном — опрашиваем, пока не доделается.
      if (r.data.batch_id) pollBatch(r.data.batch_id)
    } catch (e) {
      setError(e.response?.data?.error || 'Платформа недоступна')
      setSaving(false)
    }
  }

  return (
    <div className="overlay">{/* клик по фону НЕ закрывает окно (Роман 20.08) — только крестик, чтобы случайный тап не сбросил форму */}
      <div className="modal">
        <div className="mhead">
          <div className="ava">{(clientName || '?').split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase()}</div>
          <div className="ttl">
            <b>{paid ? 'Записать на платное' : 'Поставить уроки'}</b>
            <div className="sub">{clientName} · {paid ? 'предмет, цена и слот препода' : 'без пробного, сразу платные'}</div>
          </div>
          <div className="x" onClick={onClose}>✕</div>
        </div>

        <div className="mbody">
          {error && <div style={{ color: '#B91C1C', fontSize: 13 }}>{error}</div>}
          {!ctx && !error && <div className="cl-hint">Загрузка…</div>}

          {result ? (
            <div style={{ background: '#ECFDF5', border: '1px solid #A7F3D0', borderRadius: 14, padding: '14px 16px', fontSize: 13.5, lineHeight: 1.6 }}>
              {result.batch_id ? (() => {
                const p = batchProgress
                const done = p ? p.done : 0
                const total = p ? p.total : result.queued
                const finished = p && p.status === 'finished'
                const pct = total ? Math.round((done / total) * 100) : 0
                return (
                  <>
                    <b style={{ color: '#047857' }}>
                      {finished ? `Готово: поставлено ${done} ${done === 1 ? 'урок' : 'уроков'}` : `Ставим уроки: ${done} из ${total}`}
                    </b>
                    {!finished && (
                      <>
                        <div style={{ height: 6, borderRadius: 999, background: '#D1FAE5', marginTop: 10, overflow: 'hidden' }}>
                          <div style={{ height: '100%', width: pct + '%', background: '#10B981', borderRadius: 999, transition: 'width .4s' }} />
                        </div>
                        <div style={{ marginTop: 8, color: '#64748B' }}>
                          Уроки ставятся в расписание по одному — окно можно закрыть, постановка продолжится сама.
                        </div>
                      </>
                    )}
                    {(p && p.skipped && p.skipped.length > 0) && (
                      <div style={{ marginTop: 8, color: '#B45309' }}>
                        Пропущено {p.skipped.length}: {p.skipped.slice(0, 4).map(x => `${x.date} ${x.time} (${x.reason})`).join('; ')}
                        {p.skipped.length > 4 ? ' и ещё…' : ''}
                      </div>
                    )}
                    {finished && <div style={{ marginTop: 8, color: '#64748B' }}>Преподавателю ушло уведомление.</div>}
                  </>
                )
              })() : (
                <>
                  <b style={{ color: '#047857' }}>Создано уроков: {result.created}</b>
                  {result.skipped && result.skipped.length > 0 && (
                    <div style={{ marginTop: 8, color: '#B45309' }}>
                      Пропущено {result.skipped.length}: {result.skipped.slice(0, 4).map(s => `${s.date} ${s.time} (${s.reason})`).join('; ')}
                    </div>
                  )}
                  <div style={{ marginTop: 8, color: '#64748B' }}>Преподавателю ушло уведомление.</div>
                </>
              )}
            </div>
          ) : ctx && (
            <>
              {paid ? (
                <div className="mfield">
                  <label>Предмет</label>
                  <select value={paidSubject} onChange={e => setPaidSubject(e.target.value)}>
                    {TRIAL_PICKER_SUBJECTS.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                  {levelHint && (
                    <div style={{ marginTop: 8, background: '#FEF3C7', border: '1px solid #FCD34D', borderRadius: 10, padding: '8px 10px', fontSize: 12.5, color: '#92400E', display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                      <span>Ученик {gradeNum} класса — возможно, нужен <b>{levelHint.level}</b>?</span>
                      <button type="button" onClick={() => setPaidSubject(levelHint.to)} style={{ border: 'none', background: '#F59E0B', color: '#fff', fontWeight: 600, borderRadius: 8, padding: '4px 10px', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12 }}>Поставить «{levelHint.to}»</button>
                    </div>
                  )}
                  <label style={{ marginTop: 12, display: 'block' }}>Цена за урок, ₽ (500–2000, шаг 100)</label>
                  <input type="number" min={500} max={2000} step={100} value={paidPrice} onChange={e => setPaidPrice(Number(e.target.value))} style={{ width: '100%', fontSize: 14, border: '1px solid #E2E8F0', borderRadius: 10, padding: '10px 12px', outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }} />
                  <div style={{ fontSize: 11.5, color: '#94A3B8', marginTop: 6 }}>Цена закрепится за учеником по этому предмету.</div>
                </div>
              ) : (
              <div className="mfield">
                <label>Предмет и уровень{'\u00A0'}<span style={{ color: '#94A3B8', fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>— выберите первым</span></label>
                <select value={cls ? cls.class_id : ''} onChange={e => {
                  const c = (ctx.classes || []).find(x => String(x.class_id) === e.target.value)
                  setCls(c || null)
                }}>
                  {(ctx.classes || []).filter(c => c.studied).length > 0 && (
                    <optgroup label="Занимался раньше">
                      {(ctx.classes || []).filter(c => c.studied).map(c => (
                        <option key={c.class_id} value={c.class_id}>{c.name} — {c.price_rub} ₽</option>
                      ))}
                    </optgroup>
                  )}
                  <optgroup label="Другие предметы">
                    {(ctx.classes || []).filter(c => !c.studied).map(c => (
                      <option key={c.class_id} value={c.class_id}>{c.name} — {c.price_rub} ₽</option>
                    ))}
                  </optgroup>
                </select>
                {cls && (
                  <div style={{ fontSize: 11.5, color: cls.price_source === 'personal' ? '#B45309' : '#94A3B8', marginTop: 6 }}>
                    {cls.price_source === 'personal'
                      ? `Личная цена клиента — ${cls.price_rub} ₽ за урок`
                      : `Стандартная цена уровня — ${cls.price_rub} ₽ за урок`}
                  </div>
                )}
              </div>
              )}

              <div className="mfield">
                <label>Преподаватель</label>
                {tsearching && <div style={{ fontSize: 12, color: '#94A3B8' }}>Подбираю преподавателей и проверяю занятость…</div>}
                {!tsearching && tres.length > 3 && (
                  <input type="text" value={tq} onChange={e => setTq(e.target.value)}
                    placeholder="Начните вводить фамилию…" autoComplete="off"
                    style={{ width: '100%', fontSize: 14, border: '1px solid #E2E8F0', borderRadius: 10, padding: '10px 12px', outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box', marginBottom: 8 }} />
                )}
                {!tsearching && (() => {
                  const hist = (ctx.teachers || []).map(t => t.mk_id)
                  const q = tq.trim().toLowerCase()
                  const all = [...tres].sort((a, b) => (hist.includes(b.mk_id) ? 1 : 0) - (hist.includes(a.mk_id) ? 1 : 0))
                  const list = q ? all.filter(t => String(t.name || '').toLowerCase().includes(q)) : all
                  if (!all.length) return <div style={{ fontSize: 12.5, color: '#94A3B8' }}>Выберите предмет ниже — покажу преподавателей</div>
                  if (!list.length) return <div style={{ fontSize: 12.5, color: '#94A3B8' }}>Никого не нашлось по запросу «{tq}»</div>
                  return (
                    <div style={{ maxHeight: 230, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 6 }}>
                      {list.map(t => (
                        <button key={t.mk_id} className={'mbtn ' + (teacher && teacher.mk_id === t.mk_id ? 'primary' : 'quiet')}
                          style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between', ...(t.free ? {} : { opacity: .45 }) }}
                          disabled={!t.free}
                          onClick={() => setTeacher({ mk_id: t.mk_id, name: t.name, class_id: cls ? cls.class_id : null, class_name: cls ? cls.name : '' })}>
                          <span>{t.name}<TeacherRating mkId={t.mk_id} />{hist.includes(t.mk_id) ? ' · вёл раньше' : ''}</span>
                          <span style={{ fontSize: 11, fontWeight: 600 }}>{t.free ? '' : 'занят'}</span>
                        </button>
                      ))}
                    </div>
                  )
                })()}
                {!tsearching && tres.length > 3 && (
                  <div style={{ fontSize: 11.5, color: '#94A3B8', marginTop: 6 }}>
                    {tq.trim()
                      ? `Найдено: ${tres.filter(t => String(t.name || '').toLowerCase().includes(tq.trim().toLowerCase())).length} из ${tres.length}`
                      : `Всего преподавателей: ${tres.length} — можно искать по фамилии`}
                  </div>
                )}
                {teacher && <div style={{ fontSize: 12.5, color: '#0369A1', marginTop: 8, fontWeight: 600 }}>Выбран: {teacher.name}</div>}
              </div>

              <div className="mfield">
                <label>С какого дня</label>
                <input type="date" value={date} onChange={e => { setDate(e.target.value); setTimes([]) }} />
              </div>

              <div className="mfield">
                <label>Дни недели — у каждого своё время</label>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {[[1, 'Пн'], [2, 'Вт'], [3, 'Ср'], [4, 'Чт'], [5, 'Пт'], [6, 'Сб'], [0, 'Вс']].map(([n, label]) => (
                    <button key={n} className={'mbtn ' + (weekdays.includes(n) ? 'primary' : 'quiet')}
                      style={{ width: 56, padding: '10px 0', textAlign: 'center' }}
                      onClick={() => setWeekdays(w => w.includes(n) ? w.filter(x => x !== n) : [...w, n])}>{label}</button>
                  ))}
                </div>
                <div style={{ fontSize: 11.5, color: '#94A3B8', marginTop: 8 }}>
                  Выберите дни — под каждым появятся окошки именно этого дня и своё время.
                </div>
              </div>

              {weekdays.length === 0 ? (
                <div className="mfield">
                  <div style={{ fontSize: 13, color: '#94A3B8', padding: '10px 0' }}>
                    {teacher ? 'Выберите день недели выше — под ним появятся окошки именно этого дня.' : 'Выберите преподавателя, затем день недели.'}
                  </div>
                </div>
              ) : (
                WD_SHORT.filter(w => weekdays.includes(w[0])).map(([wd]) => {
                  const da = dayAvail[wd]
                  const slots = computeSlots(da && da.avail, da && da.busy)
                  const picked = dayTimes[wd] || []
                  const fd = da && da.date ? da.date.split('-').reverse().join('.') : ''
                  const wdn = { 1: 'Понедельник', 2: 'Вторник', 3: 'Среда', 4: 'Четверг', 5: 'Пятница', 6: 'Суббота', 0: 'Воскресенье' }[wd]
                  return (
                    <div className="mfield" key={wd}>
                      <label>{wdn}{fd ? ` — окошки на ${fd}` : ''}</label>
                      {!da ? (
                        <div style={{ fontSize: 13, color: '#94A3B8', padding: '8px 0' }}>Загружаю окошки…</div>
                      ) : slots.length === 0 ? (
                        <div style={{ fontSize: 13, color: '#94A3B8', padding: '8px 0' }}>В этот день нет открытых окошек</div>
                      ) : (
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 }}>
                          {slots.map(t => {
                            const on = picked.includes(t)
                            return (
                              <button key={t} className={'mbtn ' + (on ? 'primary' : 'quiet')}
                                onClick={() => setDayTimes(prev => { const cur = prev[wd] || []; const nx = cur.includes(t) ? cur.filter(x => x !== t) : [...cur, t].sort(); return { ...prev, [wd]: nx } })}>{t}</button>
                            )
                          })}
                        </div>
                      )}
                    </div>
                  )
                })
              )}

              {(weekdays.length > 0 || repeat !== 'once') && (
                <div className="mfield">
                  <label>До какой даты</label>
                  <input type="date" value={until} onChange={e => setUntil(e.target.value)} />
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
                    {untilPresets().map(([label, val]) => (
                      <button key={val} className="mbtn quiet" style={{ fontSize: 12.5, padding: '7px 12px' }}
                        onClick={() => setUntil(val)}>{label}</button>
                    ))}
                  </div>
                </div>
              )}

              {count > 0 && (
                <div style={{ background: '#F8FAFC', border: '1px solid #EEF2F6', borderRadius: 14, padding: '14px 16px', fontSize: 13.5, lineHeight: 1.6 }}>
                  Будет создано <b style={{ color: '#0369A1' }}>{count}</b>{' '}
                  {count === 1 ? 'урок' : count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20) ? 'урока' : 'уроков'}
                  {weekdays.length > 0
                    ? `${WD_SHORT.filter(w => weekdays.includes(w[0]) && (dayTimes[w[0]] || []).length).map(w => ` — ${w[1]} ${(dayTimes[w[0]] || []).join('/')}`).join('')}, до ${until.split('-').reverse().join('.')}`
                    : `, время: ${times.join(', ')}${repeat !== 'once' ? `, до ${until.split('-').reverse().join('.')}` : ''}`}.
                </div>
              )}
            </>
          )}
        </div>

        <div className="mfoot">
          <button className="mbtn quiet" onClick={onClose}>{result ? 'Закрыть' : 'Отмена'}</button>
          {!result && (
            <button className="mbtn primary" disabled={!teacher || count < 1 || saving} onClick={submit}
              style={(!teacher || count < 1 || saving) ? { opacity: .5, cursor: 'default' } : {}}>
              {saving ? 'Создаю…' : count > 0 ? `Создать ${count}` : 'Выберите время'}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

// ─── Обзвон старой базы (Антон 11.08, макет artifact 6b39678f) ───
// Когда очередь задач пуста, сопроводитель получает лида своей support-пачки
// (раздатчик выдал заранее, leadDistributor.distributeSupportLeads) и продаёт.
// Механика полностью звонильщицы, не плодим код: лид из /api/deals, анкета через
// /api/survey, итоги через /api/tasks + /api/deals/move, запись — общий
// TrialSignupModal + /api/platform/book (trial_booked попадает в план и премию).
const COLD_FIELDS_LEFT = [
  { key: 'phone',         label: 'Телефон',                  kind: 'text', w: 120 },
  { key: 'parentName',    label: 'Имя родителя',             kind: 'text', w: 110 },
  { key: 'sourceChannel', label: 'Откуда пришёл',            kind: 'select', req: 1,
    options: ['Сайт','ВКонтакте','Рекомендация знакомых','Яндекс услуги','Обзвон старой базы','Блог','Школа блогинга','лингва','Другое'] },
  { key: 'goal',          label: 'Что хотите от репетитора', kind: 'select', req: 1,
    options: ['Подтянуть оценки','Подготовка к ОГЭ','Подготовка к ЕГЭ','Помощь с ДЗ','Углублённые знания','Подготовка к олимпиаде'] },
  { key: 'city',          label: 'Город',                    kind: 'text', w: 100 },
]
const COLD_FIELDS_RIGHT = [
  { key: 'childName', label: 'Имя Фамилия ребёнка',  kind: 'text', req: 1, w: 150 },
  { key: 'classNum',  label: 'Класс',                kind: 'select', req: 1,
    options: ['Дошкольник','1 класс','2 класс','3 класс','4 класс','5 класс','6 класс','7 класс','8 класс','9 класс','10 класс','11 класс','Колледж или Техникум'] },
  { key: 'subject',   label: 'Предмет',              kind: 'select', req: 1,
    options: ['Математика','Математика ОГЭ','Математика ЕГЭ','Русский язык','Русский язык ОГЭ','Русский язык ЕГЭ','Английский язык','Английский язык ОГЭ','Английский язык ЕГЭ','Физика','Физика ОГЭ','Физика ЕГЭ','Химия','Химия ОГЭ','Химия ЕГЭ','Биология','Биология ОГЭ','Биология ЕГЭ','Информатика','Информатика ОГЭ','Информатика ЕГЭ','Обществознание','Обществознание ОГЭ','Обществознание ЕГЭ','История','История ОГЭ','История ЕГЭ','География','География ОГЭ','Окружающий мир','Немецкий','Китайский язык','Турецкий язык','Фин.грамостность','Психология','Блогинг','Дошкольник Математика'] },
  { key: 'scoreNow',  label: 'Оценка сейчас',        kind: 'select', req: 1, options: ['2','3','4','5'] },
  { key: 'scorePrev', label: 'Оценка в прошлом году', kind: 'select', req: 1, options: ['2','3','4','5'] },
]
const COLD_ALL = [...COLD_FIELDS_LEFT, ...COLD_FIELDS_RIGHT]
const COLD_REQUIRED = COLD_ALL.filter(f => f.req).map(f => f.key)
// «Просили не звонить» — окончательный отказ, закрывает все карточки телефона (Антон 22.09, routes/deals.js)
const COLD_REJECT_REASONS = ['Дорого', 'Не берёт трубку', 'Не актуально', 'Просили не звонить', 'Другое']

function ColdCallCard({ deal, onDone, onBook, onMoveClient }) {
  const [form, setForm] = useState({})
  const [recallOpen, setRecallOpen] = useState(false)
  const [rejectOpen, setRejectOpen] = useState(false)
  const [recall, setRecall] = useState({ date: '', time: '', comment: '' })
  const [reason, setReason] = useState(COLD_REJECT_REASONS[0])
  const [reasonText, setReasonText] = useState('')
  // «Уже занимаются» (Антон 04.09): отдельный итог обзвона старой базы — у нас или в другом месте
  const [alreadyOpen, setAlreadyOpen] = useState(false)
  const [alreadyWhere, setAlreadyWhere] = useState('в другом месте')
  const [busy, setBusy] = useState(false)
  // Таймер автосейва — НА КАЖДОЕ ПОЛЕ СВОЙ (12.08): общий таймер молча терял
  // правку поля, если менеджер в течение паузы начинал править соседнее
  // (случай Верчебы: имя мамы и ребёнка, сохранённые с разницей в секунды).
  const saveTimers = useRef({})
  const pendingSaves = useRef({})

  useEffect(() => {
    const f = {}
    COLD_ALL.forEach(fd => { f[fd.key] = deal[fd.key] || '' })
    setForm(f); setRecallOpen(false); setRejectOpen(false); setRecall({ date: '', time: '', comment: '' })
    Object.values(saveTimers.current).forEach(clearTimeout)
    saveTimers.current = {}; pendingSaves.current = {}
  }, [deal.id]) // eslint-disable-line react-hooks/exhaustive-deps

  // Автосохранение как у звонильщицы: правка поля улетает в /api/survey с паузой
  const change = (key, val) => {
    setForm(p => ({ ...p, [key]: val }))
    pendingSaves.current[key] = val
    clearTimeout(saveTimers.current[key])
    saveTimers.current[key] = setTimeout(() => {
      delete pendingSaves.current[key]
      api.patch('/api/survey/' + deal.id, { [key]: val }).catch(() => {})
    }, 1200)
  }
  // «Подтянуть данные из старого МК»: ищем по телефону в выгрузке старой базы
  // (11 911 карточек) и заполняем ПУСТЫЕ поля анкеты + дописываем историю в
  // комментарий. Заполненное сопроводителем не перетираем.
  const [pulling, setPulling] = useState(false)
  const [pullMsg, setPullMsg] = useState(null)
  const pullOldMk = async () => {
    setPulling(true); setPullMsg(null)
    try {
      // Общая реализация с карточкой звонильщика — pages/pullOldMk.js
      const res = await pullOldMkShared({
        leadId: deal.id, phone: deal.phone || deal.parentPhone, form,
        applyFields: async (patch) => {
          setForm(p => ({ ...p, ...patch }))
          await api.patch('/api/survey/' + deal.id, patch)
        },
      })
      setPullMsg(res.msg)
      if (res.found) onDone()
    } catch (e) {
      setPullMsg('Ошибка: ' + ((e.response && e.response.data && e.response.data.error) || e.message))
    } finally { setPulling(false) }
  }

  const done = COLD_REQUIRED.filter(k => String(form[k] || '').trim() !== '').length
  const canBook = done >= COLD_REQUIRED.length
  // Итог по лиду: несохранённые правки не отменяем, а дошлём одним запросом
  const finish = () => {
    Object.values(saveTimers.current).forEach(clearTimeout)
    const rest = pendingSaves.current
    saveTimers.current = {}; pendingSaves.current = {}
    if (Object.keys(rest).length) api.patch('/api/survey/' + deal.id, rest).catch(() => {})
    onDone()
  }

  const doRecall = async () => {
    if (!recall.date || !recall.time) return
    setBusy(true)
    try {
      await api.post('/api/tasks', { leadId: deal.id, text: 'Перезвонить' + (recall.comment ? ': ' + recall.comment : ''), date: recall.date + ' ' + recall.time })
      await api.post('/api/deals/move', { leadId: deal.id, action: 'recall' })
      finish()
    } catch (e) { alert((e.response && e.response.data && e.response.data.error) || 'Не получилось') }
    setBusy(false)
  }

  // Единый путь отказа для «Не интересно» и «Уже занимаются»: задача с текстом
  // причины (как у звонильщицы) + перевод лида в rejected с причиной в meta.
  const refuse = async (reasonFull) => {
    setBusy(true)
    try {
      const when = new Date(Date.now() + 24 * 3600 * 1000)
      const pad = n => String(n).padStart(2, '0')
      const date = when.getFullYear() + '-' + pad(when.getMonth() + 1) + '-' + pad(when.getDate()) + ' ' + pad(when.getHours()) + ':' + pad(when.getMinutes())
      await api.post('/api/tasks', { leadId: deal.id, text: 'Отказ: ' + reasonFull, date })
      await api.post('/api/deals/move', { leadId: deal.id, action: 'refuse', reason: reasonFull })
      finish()
    } catch (e) { alert((e.response && e.response.data && e.response.data.error) || 'Не получилось') }
    setBusy(false)
  }
  const doReject = () => refuse(reason === 'Другое' ? (reasonText || 'без причины') : reason)
  const doAlready = () => refuse('Уже занимаются: ' + alreadyWhere)

  const fld = f => (
    <div className="cf-row" key={f.key}>
      <span className={'cf-k' + (f.req ? ' req' : '')}>{f.label}</span>
      {f.kind === 'select' ? (
        <select className={'cf-in' + (form[f.key] ? ' filled' : '')} value={form[f.key] || ''} onChange={e => change(f.key, e.target.value)}>
          <option value="">— выберите —</option>
          {f.options.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
      ) : (
        <input className={'cf-in' + (form[f.key] ? ' filled' : '')} style={{ width: f.w || 120 }} value={form[f.key] || ''} onChange={e => change(f.key, e.target.value)} />
      )}
    </div>
  )

  return (
    <div className="card">
      <div className="chead">
        <div className="ava">{String(deal.parentName || deal.name || '?').substring(0, 1).toUpperCase()}</div>
        <div className="ttl"><b>{deal.parentName || deal.name || 'Клиент'}</b></div>
        {/* Подпись пачки: «Май 2026 — занимались» → клиент реально ходил к нам (Антон 25.08), иначе — старая база */}
        <span className="cold-badge">{/май/i.test(deal.batchName || '') ? 'Занимался у нас в мае 2026' : ('Обзвон · ' + (deal.batchName || 'Старая база'))}</span>
      </div>

      <div className="coldgrid">
        <div>
          <div className="cf-cap">Контакты и источник</div>
          {COLD_FIELDS_LEFT.map(fld)}
        </div>
        <div>
          <div className="cf-cap">Ребёнок</div>
          {COLD_FIELDS_RIGHT.map(fld)}
        </div>
        {deal.comment ? <div className="cf-hist"><b>Занималась у нас раньше:</b> {deal.comment}</div> : null}
        <div className="cf-pill" style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <span>Заполнено {done}/{COLD_REQUIRED.length} обязательных</span>
          <button className="mbtn quiet" disabled={pulling} style={{ fontSize: 12, padding: '5px 10px' }}
            title={PULL_OLDMK_TITLE}
            onClick={pullOldMk}>{pulling ? '…' : PULL_OLDMK_LABEL}</button>
          <button className="mbtn primary" style={{ fontSize: 12, padding: '5px 10px' }}
            title="Создать клиента: поля анкеты перенесутся в форму нового клиента"
            onClick={() => onMoveClient && onMoveClient({ ...form, phone: form.phone || deal.phone })}>→ Перенести клиента</button>
          {pullMsg ? <span style={{ fontSize: 12, color: '#64748B' }}>{pullMsg}</span> : null}
        </div>
      </div>

      <div className="sep">Итог</div>
      <div className="actrow">
        <button className="btn yes" disabled={!canBook || busy} style={!canBook ? { opacity: 0.45, cursor: 'default' } : {}}
          title={canBook ? '' : 'Сначала заполните все обязательные поля анкеты'}
          onClick={() => onBook({ subject: form.subject, classNum: form.classNum })}>✓ Записать на пробный</button>
        <button className="btn quiet" disabled={busy} onClick={() => { setRecallOpen(v => !v); setRejectOpen(false); setAlreadyOpen(false) }}>Перезвонить</button>
        <button className="btn quiet" disabled={busy} onClick={() => { setAlreadyOpen(v => !v); setRecallOpen(false); setRejectOpen(false) }}>Уже занимаются</button>
        <button className="btn no" disabled={busy} onClick={() => { setRejectOpen(v => !v); setRecallOpen(false); setAlreadyOpen(false) }}>✗ Не интересно</button>
      </div>

      {alreadyOpen && (
        <div className="cf-form">
          <select className="cf-in" value={alreadyWhere} onChange={e => setAlreadyWhere(e.target.value)}>
            <option value="в другом месте">Занимаются в другом месте</option>
            <option value="у нас">Занимаются у нас</option>
          </select>
          <button className="mbtn primary" disabled={busy} onClick={doAlready}>Подтвердить</button>
        </div>
      )}

      {recallOpen && (
        <div className="cf-form">
          <input type="date" className="cf-in" value={recall.date} onChange={e => setRecall(p => ({ ...p, date: e.target.value }))} />
          <input type="time" className="cf-in" value={recall.time} onChange={e => setRecall(p => ({ ...p, time: e.target.value }))} />
          <input className="cf-in" style={{ flex: 1, minWidth: 140 }} placeholder="Комментарий" value={recall.comment} onChange={e => setRecall(p => ({ ...p, comment: e.target.value }))} />
          <button className="mbtn primary" disabled={busy || !recall.date || !recall.time} onClick={doRecall}>Перенести</button>
        </div>
      )}
      {rejectOpen && (
        <div className="cf-form">
          <select className="cf-in" value={reason} onChange={e => setReason(e.target.value)}>
            {COLD_REJECT_REASONS.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
          {reason === 'Другое' && <input className="cf-in" style={{ flex: 1, minWidth: 140 }} placeholder="Причина" value={reasonText} onChange={e => setReasonText(e.target.value)} />}
          <button className="mbtn primary" disabled={busy} onClick={doReject}>Подтвердить отказ</button>
        </div>
      )}
    </div>
  )
}

// «Мои клиенты» → 👤 Сменить преподавателя на ПРОБНОМ (Антон 29.07): та же
// внутренняя логика, что «Сменить препода» у звонильщика в «Мои пробные» —
// кандидаты того же предмета/уровня с пометкой свободен/занят; будущие уроки,
// заявки автозамены и карточка сделки обновляются на бэке.
function ChangeTrialTeacherModal({ studentId, lesson, onClose, onDone }) {
  const [cands, setCands] = useState(null)
  const [error, setError] = useState(null)
  const [query, setQuery] = useState('')
  const [chosen, setChosen] = useState(null)
  const [slot, setSlot] = useState(null)   // выбранное окошко {date, time}; null = оставить текущее время
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    let alive = true
    // Кандидаты (нужный предмет, свободен/занят) + богатые данные каталога
    // (цена, конверсия, фото, возраст, отзыв сопроводителя) — мержим по mkId.
    Promise.all([
      api.get(`/api/platform/support-clients/${studentId}/trials/${lesson.booking_id}/teacher-candidates`).then(r => r.data).catch(e => ({ error: e.response?.data?.error || 'Платформа недоступна' })),
      api.get('/api/platform/tutors', { params: { subject: lesson.subject } }).then(r => r.data).catch(() => ({ tutors: [] })),
    ]).then(([cand, tut]) => {
      if (!alive) return
      if (cand.error || !cand.ok) { setError(cand.error || 'Не удалось получить кандидатов'); return }
      const rich = {}
      ;(tut.tutors || []).forEach(t => { rich[t.mkId] = t })
      setCands((cand.candidates || []).map(c => ({ ...(rich[c.mkId] || {}), ...c })))
    })
    return () => { alive = false }
  }, [studentId, lesson.booking_id, lesson.subject])

  const lt = String(lesson.begin_time || '').slice(0, 5)
  const filtered = (cands || [])
    .filter(c => c.name.toLowerCase().includes(query.trim().toLowerCase()))
    .sort((a, b) =>
      ((b.otbor && b.otbor.waiting ? 1 : 0) - (a.otbor && a.otbor.waiting ? 1 : 0)) ||
      ((b.free ? 1 : 0) - (a.free ? 1 : 0)) ||
      // приоритет СРМ (платформа teacher_rank, 05.09): дно — вниз, выше приоритет — выше
      (((a.rank && a.rank.crm_floor) ? 1 : 0) - ((b.rank && b.rank.crm_floor) ? 1 : 0)) ||
      (((b.rank && b.rank.crm_rank) || 0) - ((a.rank && a.rank.crm_rank) || 0)) ||
      ((b.conv || 0) - (a.conv || 0)) ||
      a.name.localeCompare(b.name, 'ru'))

  const target = slot || { date: lesson.date, time: lt }
  const timeChanged = target.date !== lesson.date || target.time !== lt

  async function confirm() {
    if (!chosen) return
    setSaving(true)
    setError(null)
    try {
      const r = await api.post(`/api/platform/support-clients/${studentId}/trials/${lesson.booking_id}/change-teacher`, { teacher_mk_id: chosen.mkId })
      if (!r.data.ok) { setError(r.data.error || 'Не удалось сменить препода'); setSaving(false); return }
      // Выбрали другое окошко — переносим урок (тем же эндпоинтом, что «Перенести»).
      if (timeChanged) {
        const r2 = await api.post(`/api/platform/support-clients/${studentId}/trials/${lesson.booking_id}/reschedule`, { new_date: target.date, new_begin_time: target.time })
        if (!r2.data.ok) { setError('Препод сменён, но перенос не удался: ' + (r2.data.error || '')); setSaving(false); return }
      }
      onDone()
    } catch (e) {
      setError(e.response?.data?.error || 'Платформа недоступна')
      setSaving(false)
    }
  }

  return (
    <div className="overlay" onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal" style={{ maxWidth: 880, width: '100%' }}>
        <div className="mhead">
          <div className="ttl">
            <b>Сменить преподавателя</b>
            <div className="sub">{lesson.subject || 'Предмет не указан'} · {lesson.date} {lesson.begin_time} · сейчас {lesson.teacher || 'препод не указан'}</div>
          </div>
          <div className="x" onClick={onClose}>✕</div>
        </div>
        <div className="mbody">
          {error && <div style={{ color: '#B91C1C', fontSize: 13, marginBottom: 8 }}>{error}</div>}
          {!cands && !error && <div className="cl-hint">Ищу кандидатов и проверяю занятость...</div>}
          {cands && cands.length === 0 && <div className="cl-hint">Других преподавателей по этому предмету не нашлось</div>}
          {cands && cands.length > 0 && (
            <div style={{ display: 'grid', gap: 16, gridTemplateColumns: chosen ? '1.1fr 1fr' : '1fr' }}>
              <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                <TutorPickerSubjectHint subject={lesson.subject} />
                <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Поиск по имени..."
                  style={{ width: '100%', fontSize: 13, padding: '8px 12px', borderRadius: 10, border: '1px solid #E2E8F0', outline: 'none', marginBottom: 12 }} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxHeight: 440, overflowY: 'auto', paddingRight: 4 }}>
                  {filtered.map(c => (
                    <TutorPickerCard key={c.mkId} t={c} selected={chosen?.mkId === c.mkId} atSlotFree={c.free}
                      onClick={() => { setChosen(c); setSlot(null) }} />
                  ))}
                </div>
              </div>
              {chosen && (
                <div style={{ minWidth: 0, overflowY: 'auto', maxHeight: 440 }}>
                  <TutorWeekSlots mkId={chosen.mkId} lessonDate={lesson.date} lessonTime={lesson.begin_time} value={slot} onChange={setSlot} />
                </div>
              )}
            </div>
          )}
        </div>
        <div className="mfoot">
          <div style={{ flex: 1, fontSize: 11.5, color: '#667085' }}>
            {chosen ? <>Выбран(а) <b>{chosen.name.split(' ').slice(0, 2).join(' ')}</b>{chosen.price != null ? ` · ${chosen.price} ₽` : ''}{timeChanged ? ` · перенос на ${target.date}, ${target.time}` : ''}</> : ''}
          </div>
          <button className="mbtn quiet" onClick={onClose}>Отмена</button>
          <button className="mbtn primary" disabled={!chosen || saving} onClick={confirm} style={!chosen || saving ? { opacity: 0.5, cursor: 'default' } : {}}>
            {saving ? 'Меняю...' : chosen ? `Назначить: ${chosen.name.split(' ')[0]}` : 'Выберите преподавателя'}
          </button>
        </div>
      </div>
    </div>
  )
}

// «Записать на пробный» из «Мои клиенты»: у нас нет анкеты как у звонильщика,
// поэтому перед знакомым окном записи (TrialSignupModal) уточняем предмет+класс
// в маленьком окошке — класс НЕ спрашиваем (Антон: он и так виден у имени клиента
// в шапке карточки, см. clientDetail.grade) — только предмет.
const TRIAL_PICKER_SUBJECTS = ['Математика', 'Математика ОГЭ', 'Математика ЕГЭ', 'Русский язык', 'Русский язык ОГЭ', 'Русский язык ЕГЭ',
  'Английский язык', 'Английский язык ОГЭ', 'Английский язык ЕГЭ', 'Физика', 'Физика ОГЭ', 'Физика ЕГЭ',
  'Химия', 'Химия ОГЭ', 'Химия ЕГЭ', 'Биология', 'Биология ОГЭ', 'Биология ЕГЭ', 'Информатика', 'Информатика ОГЭ', 'Информатика ЕГЭ',
  'Обществознание', 'Обществознание ОГЭ', 'Обществознание ЕГЭ', 'История', 'История ОГЭ', 'История ЕГЭ',
  'География', 'География ОГЭ', 'Окружающий мир', 'Немецкий', 'Китайский язык', 'Турецкий язык',
  'Фин.грамотность', 'Психология', 'Блогинг', 'Дошкольник Математика']

// «2026-07-15 17:01:38» (МСК, из student_sessions) → «15.07.2026, 17:01».
function dayKey(ms) {
  const d = new Date(ms)
  return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate()
}
function fmtDayLabel(ms) {
  const d = new Date(ms), t = new Date(), y = new Date(t); y.setDate(t.getDate() - 1)
  const same = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
  if (same(d, t)) return 'Сегодня'
  if (same(d, y)) return 'Вчера'
  const M = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
  return d.getDate() + ' ' + M[d.getMonth()] + (d.getFullYear() !== t.getFullYear() ? ' ' + d.getFullYear() : '')
}
function fmtDateOnly(ts) {
  try { var m = String(ts).match(/(\d{4})-(\d{2})-(\d{2})/); return m ? m[3] + '.' + m[2] + '.' + m[1] : ts } catch (e) { return ts }
}
// Срок задачи: 'YYYY-MM-DD' или 'YYYY-MM-DD HH:MM'. Показываем дату + время, если задано.
function fmtDue(ts) {
  try {
    var m = String(ts).match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/)
    if (!m) return ts
    var d = m[3] + '.' + m[2] + '.' + m[1]
    return m[4] ? d + ' ' + m[4] + ':' + m[5] : d
  } catch (e) { return ts }
}
// Просрочена ли задача — по дате+времени (МСК-строку сравниваем с локальным now).
function isDueOverdue(ts) {
  try { return !!ts && new Date(String(ts).replace(' ', 'T')) < new Date() } catch (e) { return false }
}
function fmtLkActivity(ts) {
  try {
    var m = String(ts).match(/(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/)
    if (!m) return ts
    return `${m[3]}.${m[2]}.${m[1]}, ${m[4]}:${m[5]}`
  } catch (e) { return ts }
}

const DELETE_REASONS = [
  'Родитель оповестил об отмене',
  'Больничный',
  'Запрос преподавателя',
]
function RefuseModal({ client, onClose, onDone }) {
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  async function submit() {
    if (!reason.trim()) { setErr('Причина обязательна'); return }
    setBusy(true); setErr('')
    try {
      await api.post(`/api/platform/support-clients/${client.id}/refuse`, { reason: reason.trim() })
      if (onDone) onDone()
      onClose()
    } catch (e) { setErr(e.response?.data?.error || 'Не удалось сохранить отказ'); setBusy(false) }
  }
  return (
    <div className="overlay" onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal" style={{ maxWidth: 460 }}>
        <div className="mhead">
          <div className="ttl"><b>Отказ клиента</b><div className="sub">{client.name}</div></div>
          <div className="x" onClick={onClose}>✕</div>
        </div>
        <div className="mbody">
          <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 8, padding: '10px 12px', fontSize: 13, color: '#B91C1C', marginBottom: 12 }}>
            ⚠️ При сохранении отказа <b>всё будущее расписание ученика будет удалено</b>.
          </div>
          <div style={{ fontSize: 13, color: '#64748b', marginBottom: 6 }}>Почему клиент отказывается? <span style={{ color: '#DC2626' }}>*</span></div>
          <textarea value={reason} onChange={e => { setReason(e.target.value); setErr('') }} rows={3} placeholder="Обязательно укажите причину…" autoFocus style={{ width: '100%', boxSizing: 'border-box', padding: 10, borderRadius: 8, border: '1px solid #CBD5E1', fontFamily: 'inherit', fontSize: 14, resize: 'vertical' }} />
          {err && <div style={{ color: '#DC2626', fontSize: 12.5, marginTop: 6 }}>{err}</div>}
          <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'flex-end' }}>
            <button onClick={onClose} disabled={busy} style={{ padding: '9px 16px', borderRadius: 8, border: '1px solid #CBD5E1', background: '#fff', cursor: 'pointer', fontWeight: 600 }}>Отмена</button>
            <button onClick={submit} disabled={busy} style={{ padding: '9px 16px', borderRadius: 8, border: 0, background: '#DC2626', color: '#fff', cursor: 'pointer', fontWeight: 700 }}>{busy ? 'Сохраняю…' : 'Подтвердить отказ'}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

function DeleteLessonModal({ lesson, studentId, allLessons, onClose, onDeleted }) {
  const WDF = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']
  const wd = lesson.date ? new Date(lesson.date + 'T00:00:00').getDay() : null
  const time = lesson.begin_time || ''
  const todayISO = new Date(Date.now() + 3 * 3600 * 1000).toISOString().slice(0, 10)
  // Будущие запланированные уроки ученика в ТОТ ЖЕ день недели и время (не пробные).
  const matchAll = (allLessons || []).filter(l =>
    l.lesson_id && l.status === 'planned' && !l.is_trial && (l.begin_time || '') === time &&
    l.date && l.date >= todayISO && wd !== null && new Date(l.date + 'T00:00:00').getDay() === wd)
  // Преподаватели среди совпавших (у ученика может быть несколько учителей на этот слот).
  const teachers = []
  const seenT = {}
  for (const l of matchAll) {
    const k = String(l.teacher_mk_id != null ? l.teacher_mk_id : (l.teacher || ''))
    if (!seenT[k]) { seenT[k] = true; teachers.push({ id: l.teacher_mk_id, key: k, name: l.teacher || 'Без преподавателя' }) }
  }
  const curKey = String(lesson.teacher_mk_id != null ? lesson.teacher_mk_id : (lesson.teacher || ''))

  const [scope, setScope] = useState('one')            // one | all
  const [teacherSel, setTeacherSel] = useState(curKey) // ключ препода | '__all__'
  const [reason, setReason] = useState(DELETE_REASONS[0])
  const [other, setOther] = useState('')
  const [busy, setBusy] = useState(false)
  const [prog, setProg] = useState('')
  const [err, setErr] = useState('')
  const isOther = reason === '__other__'

  const targets = scope === 'one'
    ? [lesson]
    : matchAll.filter(l => {
        if (teacherSel === '__all__') return true
        const k = String(l.teacher_mk_id != null ? l.teacher_mk_id : (l.teacher || ''))
        return k === teacherSel
      })

  async function submit() {
    const finalReason = isOther ? other.trim() : reason
    if (!finalReason) { setErr('Укажите причину'); return }
    if (!targets.length) { setErr('Нет уроков для удаления'); return }
    setBusy(true); setErr('')
    let done = 0, fail = 0, notice = '', lastErr = ''
    for (const l of targets) {
      try {
        const r = await api.post(`/api/platform/support-clients/${studentId}/lessons/${l.lesson_id}/delete`, {
          reason: finalReason, date: l.date, begin_time: l.begin_time, subject: l.subject, teacher: l.teacher,
        })
        // Платформа убрала урок у нас, но МК молчит — она доведёт удаление сама.
        if (r.data && r.data.notice) notice = r.data.notice
        done++
      } catch (e) {
        fail++
        lastErr = (e.response && e.response.data && e.response.data.error) || ''
      }
      setProg(`Удаляю ${done + fail}/${targets.length}…`)
    }
    if (onDeleted) onDeleted()
    if (fail && !done) {
      setErr(lastErr || 'Не удалось удалить'); setBusy(false); setProg(''); return
    }
    if (notice) { setErr(notice); setBusy(false); setProg(''); return }
    onClose()
  }

  const rowStyle = { display: 'flex', alignItems: 'center', gap: 9, padding: '8px 4px', cursor: 'pointer', fontSize: 14 }
  const secTtl = { fontSize: 12, color: '#64748b', margin: '12px 0 4px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: .3 }
  return (
    <div className="overlay" onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal" style={{ maxWidth: 460 }}>
        <div className="mhead">
          <div className="ttl"><b>Удалить урок</b><div className="sub">{lesson.subject || 'Урок'}{lesson.date ? ' · ' + lesson.date + ' ' + (lesson.begin_time || '') : ''}{lesson.teacher ? ' · ' + lesson.teacher : ''}</div></div>
          <div className="x" onClick={onClose}>✕</div>
        </div>
        <div className="mbody">
          <div style={secTtl}>Что удалить</div>
          <label style={rowStyle}>
            <input type="radio" name="delscope" checked={scope === 'one'} onChange={() => setScope('one')} />
            Только этот урок
          </label>
          <label style={rowStyle}>
            <input type="radio" name="delscope" checked={scope === 'all'} onChange={() => setScope('all')} />
            Все уроки по {wd !== null ? WDF[wd] : ''} в {time}{scope === 'all' ? ` (${matchAll.length})` : ''}
          </label>

          {scope === 'all' && (
            <>
              <div style={secTtl}>Уроки какого преподавателя удалить</div>
              {teachers.map(t => (
                <label key={t.key} style={rowStyle}>
                  <input type="radio" name="delteacher" checked={teacherSel === t.key} onChange={() => setTeacherSel(t.key)} />
                  {t.name} <span style={{ color: '#94a3b8', fontSize: 12 }}>({matchAll.filter(l => String(l.teacher_mk_id != null ? l.teacher_mk_id : (l.teacher || '')) === t.key).length})</span>
                </label>
              ))}
              {teachers.length > 1 && (
                <label style={rowStyle}>
                  <input type="radio" name="delteacher" checked={teacherSel === '__all__'} onChange={() => setTeacherSel('__all__')} />
                  Всех преподавателей <span style={{ color: '#94a3b8', fontSize: 12 }}>({matchAll.length})</span>
                </label>
              )}
            </>
          )}

          <div style={secTtl}>Причина удаления</div>
          {DELETE_REASONS.map(r => (
            <label key={r} style={rowStyle}>
              <input type="radio" name="delreason" checked={reason === r} onChange={() => setReason(r)} />{r}
            </label>
          ))}
          <label style={rowStyle}>
            <input type="radio" name="delreason" checked={isOther} onChange={() => setReason('__other__')} />Другое
          </label>
          {isOther && (
            <textarea value={other} onChange={e => setOther(e.target.value)} placeholder="Опишите причину…" rows={2}
              style={{ width: '100%', padding: 10, border: '1px solid #e6ebf1', borderRadius: 10, fontSize: 14, fontFamily: 'inherit', outline: 'none', marginTop: 4, resize: 'vertical' }} />
          )}
          {err && <div style={{ color: '#B91C1C', fontSize: 13, marginTop: 8 }}>{err}</div>}
          <button disabled={busy || !targets.length} onClick={submit}
            style={{ marginTop: 14, width: '100%', background: (busy || !targets.length) ? '#f0a9b0' : '#e2606b', color: '#fff', border: 0, borderRadius: 10, padding: '12px 16px', fontWeight: 700, cursor: busy ? 'default' : 'pointer' }}>
            {busy ? (prog || 'Удаляю…') : `Удалить ${targets.length > 1 ? targets.length + ' урок(ов)' : 'урок'}`}
          </button>
        </div>
      </div>
    </div>
  )
}

function EditClientModal({ client, onClose, onSaved }) {
  const [name, setName] = useState(client.name || '')
  const [phone, setPhone] = useState(client.phone || '')
  const [email, setEmail] = useState(client.email || '')
  const [grade, setGrade] = useState(client.grade ? String(client.grade) : '')
  const [parent, setParent] = useState(client.parent || '')
  const [prices, setPrices] = useState(() => (client.subject_prices || []).map(sp => ({ slot: sp.slot, class_id: sp.class_id, subject: sp.subject, level: sp.level || 'regular', price_rub: sp.price_rub == null ? '' : String(sp.price_rub) })))
  // Цены у преподавателей: у одного ученика они разные, поэтому строка на каждого
  const [teacherPrices, setTeacherPrices] = useState(() => (client.teacher_prices || []).map(tp => ({
    teacher_mk_id: tp.teacher_mk_id,
    teacher_name: tp.teacher_name,
    subject: tp.subject,
    class_id: tp.class_id,
    price_rub: tp.price_rub == null ? '' : String(tp.price_rub),
    promo_code: tp.promo_code,
    discount_pct: tp.discount_pct,
    base_price_rub: tp.base_price_rub,
  })))
  const [tpMsg, setTpMsg] = useState('')

  async function saveTeacherPrice(idx, value) {
    const row = teacherPrices[idx]
    setTeacherPrices(arr => arr.map((x, i) => (i === idx ? { ...x, price_rub: value } : x)))
    try {
      await api.post('/api/platform/support-clients/' + client.id + '/teacher-price', {
        teacher_mk_id: row.teacher_mk_id,
        class_id: row.class_id || null,
        price_rub: value === '' ? null : Number(value),
      })
      setTpMsg('Цена сохранена')
      setTimeout(() => setTpMsg(''), 2500)
    } catch (e) {
      setTpMsg('Не удалось сохранить цену')
    }
  }
  const [saving, setSaving] = useState(false)
  const [err, setErr] = useState('')
  const [pw, setPw] = useState('')
  const [pwMsg, setPwMsg] = useState('')
  const [pwErr, setPwErr] = useState(false)
  const fld = { width: '100%', padding: '10px 12px', border: '1px solid #e6ebf1', borderRadius: 10, fontSize: 14, outline: 'none', marginTop: 4 }
  async function save() {
    setSaving(true); setErr('')
    try {
      const pricesPayload = prices.map(p => ({ slot: p.slot, class_id: p.class_id, price_rub: p.price_rub === '' ? null : Number(p.price_rub), level: p.level }))
      await api.post('/api/platform/support-clients/' + client.id, { name, phone, email, grade, parent, prices: pricesPayload })
      if (onSaved) onSaved()
      onClose()
    } catch (e) { setErr(e.response?.data?.error || 'Ошибка сохранения') } finally { setSaving(false) }
  }
  async function savePw() {
    setPwMsg(''); setPwErr(false)
    if (pw.length < 6) { setPwMsg('Пароль минимум 6 символов'); setPwErr(true); return }
    try {
      await api.post('/api/platform/support-clients/' + client.id + '/set-password', { password: pw })
      setPwMsg('Пароль сохранён'); setPw('')
    } catch (e) { setPwMsg(e.response?.data?.error || 'Ошибка'); setPwErr(true) }
  }
  return (
    <div className="overlay" onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal" style={{ maxWidth: 460 }}>
        <div className="mhead">
          <div className="ttl"><b>Редактирование клиента</b><div className="sub">Сохранится сразу у нас, затем в МойКласс</div></div>
          <div className="x" onClick={onClose}>✕</div>
        </div>
        <div className="mbody" style={{ display: 'grid', gap: 12 }}>
          <label style={{ fontSize: 13, color: '#475569' }}>Имя<input style={fld} value={name} onChange={e => setName(e.target.value)} /></label>
          <label style={{ fontSize: 13, color: '#475569' }}>Телефон<input style={fld} value={phone} onChange={e => setPhone(e.target.value)} /></label>
          <label style={{ fontSize: 13, color: '#475569' }}>Email<input style={fld} value={email} onChange={e => setEmail(e.target.value)} /></label>
          <label style={{ fontSize: 13, color: '#475569' }}>В каком классе<select style={fld} value={grade} onChange={e => setGrade(e.target.value)}><option value="">Не указан</option>{[1,2,3,4,5,6,7,8,9,10,11].map(g => <option key={g} value={String(g)}>{g} класс</option>)}</select></label>
          <label style={{ fontSize: 13, color: '#475569' }}>Родитель (имя, телефон)<input style={fld} value={parent} onChange={e => setParent(e.target.value)} placeholder="Имя и телефон родителя" /></label>
          {teacherPrices.length > 0 && (
            <div style={{ display: 'grid', gap: 8, borderTop: '1px solid #eef2f6', paddingTop: 10 }}>
              <div style={{ fontSize: 13, color: '#0f172a', fontWeight: 700 }}>Стоимость занятий у преподавателей</div>
              <div style={{ fontSize: 12, color: '#94a3b8', marginTop: -4 }}>
                По этой цене списываются деньги за урок. Цена своя у каждой пары «преподаватель · предмет».
              </div>
              {teacherPrices.map((tp, idx) => (
                <label key={tp.teacher_mk_id + '-' + (tp.class_id || 0)} style={{ fontSize: 13, color: '#475569' }}>
                  {tp.teacher_name}{tp.subject ? ' · ' + tp.subject : ''}
                  {tp.promo_code && (
                    <span style={{ marginLeft: 6, fontSize: 11.5, fontWeight: 700, color: '#0d8bb7',
                      background: '#e8f7fd', border: '1px solid #cdeefb', borderRadius: 6, padding: '1px 6px' }}>
                      промокод {tp.promo_code}{tp.discount_pct ? ' −' + tp.discount_pct + '%' : ''}
                      {tp.base_price_rub ? ', без скидки ' + tp.base_price_rub + ' ₽' : ''}
                    </span>
                  )}
                  <select style={fld} value={tp.price_rub} onChange={e => saveTeacherPrice(idx, e.target.value)}>
                    <option value="">По уровню (стандарт)</option>
                    {[500,600,700,800,900,1000,1100,1200,1300,1400,1500,1600,1700,1800,1900,2000,2200,2500,3000].map(v => <option key={v} value={String(v)}>{v} ₽</option>)}
                  </select>
                </label>
              ))}
              {tpMsg && <div style={{ fontSize: 12.5, color: tpMsg.indexOf('Не') === 0 ? '#B91C1C' : '#047857' }}>{tpMsg}</div>}
            </div>
          )}
          {err && <div style={{ color: '#B91C1C', fontSize: 13 }}>{err}</div>}
          <button disabled={saving} onClick={save} style={{ background: '#3bc8f5', color: '#fff', border: 0, borderRadius: 10, padding: '11px 16px', fontWeight: 600, cursor: 'pointer' }}>{saving ? 'Сохранение…' : 'Сохранить'}</button>
          <div style={{ borderTop: '1px solid #eef2f6', paddingTop: 12, marginTop: 4 }}>
            <b style={{ fontSize: 14 }}>Пароль от ЛК</b>
            <div style={{ fontSize: 12.5, color: '#64748b', margin: '4px 0 8px' }}>Задайте клиенту пароль для входа в личный кабинет.</div>
            <div style={{ display: 'flex', gap: 8 }}>
              <input style={{ ...fld, marginTop: 0, flex: 1 }} type="text" value={pw} onChange={e => setPw(e.target.value)} placeholder="Новый пароль" />
              <button onClick={savePw} style={{ background: '#e6f8fe', color: '#0f172a', border: '1px solid #d6f1fb', borderRadius: 10, padding: '10px 14px', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>Задать</button>
            </div>
            {pwMsg && <div style={{ color: pwErr ? '#B91C1C' : '#047857', fontSize: 13, marginTop: 8 }}>{pwMsg}</div>}
          </div>
        </div>
      </div>
    </div>
  )
}

// Цена по умолчанию по предмету/уровню (сетка Лидера): ОГЭ 1400, ЕГЭ 1600, иначе 1200.
function paidDefaultPrice(subject) {
  const s = String(subject || '')
  if (/ОГЭ/i.test(s)) return 1400
  if (/ЕГЭ/i.test(s)) return 1600
  return 1200
}

// «Записать на платное» (Роман 23.09.2026): сначала предмет — тот же список, что
// на пробном, — затем цена урока. По умолчанию подставляем цену ГРУППЫ для этого
// ученика (личная из карточки, иначе стандарт по уровню), но можно выбрать любую
// из списка. Дальше открывается обычное окно выбора преподавателя, без деления на
// Лидеров: пишем платный урок на выбранную сумму и фиксируем её в карточке.
const PAID_PRICE_OPTIONS = (() => { const a = []; for (let p = 500; p <= 2000; p += 100) a.push(p); return a })()

function PaidPickerModal({ studentId, clientName, grade, onClose, onContinue }) {
  const [subject, setSubject] = useState(TRIAL_PICKER_SUBJECTS[0])
  const [classes, setClasses] = useState(null)
  const [price, setPrice] = useState(paidDefaultPrice(TRIAL_PICKER_SUBJECTS[0]))

  useEffect(() => {
    let alive = true
    api.get(`/api/platform/support-clients/${studentId}/lesson-context`)
      .then(r => { if (alive) setClasses((r.data && r.data.classes) || []) })
      .catch(() => { if (alive) setClasses([]) })
    return () => { alive = false }
  }, [studentId])

  // Группу считаем ровно так же, как платформа (pickClassId): у девятиклассника
  // «Математика» — это группа «Математика ОГЭ», у 10–11 — ЕГЭ. Иначе в окне
  // показывалась бы цена базовой группы, а урок сел бы в ОГЭ/ЕГЭ с другой ценой.
  // «Русский язык» и «Английский язык» в МК названы без слова «язык».
  const norm = (x) => String(x || '').trim().toLowerCase().replace(/\s+язык\b/g, '')
  const gradeLevel = (() => {
    const g = String(grade || '').trim()
    if (/^ОГЭ$/i.test(g)) return 'ОГЭ'
    if (/^ЕГЭ$/i.test(g)) return 'ЕГЭ'
    const n = parseInt(g, 10)
    if (n === 9) return 'ОГЭ'
    if (n === 10 || n === 11) return 'ЕГЭ'
    return null
  })()
  const effSubject = /(ОГЭ|ЕГЭ)/i.test(subject) ? subject : (gradeLevel ? `${subject} ${gradeLevel}` : subject)
  const group = (classes || []).find(c => norm(c.name) === norm(effSubject)) || null
  const groupPrice = group ? group.price_rub : paidDefaultPrice(effSubject)
  // Цена группы меняется (выбрали другой предмет / подгрузились группы) — возвращаем
  // её в поле. Ручной выбор держится до следующей такой смены.
  useEffect(() => { setPrice(groupPrice) }, [groupPrice])

  return (
    <div className="overlay" onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal">
        <div className="mhead">
          <div className="ava">{(clientName || '?')[0]}</div>
          <div className="ttl">
            <b>{clientName}</b>
            <div className="sub">Запись на платный урок — предмет и цена</div>
          </div>
          <div className="x" onClick={onClose}>✕</div>
        </div>
        <div className="mbody">
          <div className="mfield">
            <label>Предмет</label>
            <select value={subject} onChange={e => setSubject(e.target.value)}>
              {TRIAL_PICKER_SUBJECTS.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div className="mfield">
            <label>Цена урока</label>
            <select value={price} onChange={e => setPrice(Number(e.target.value))}>
              {PAID_PRICE_OPTIONS.map(p => (
                <option key={p} value={p}>{p} ₽{p === groupPrice ? ' — цена группы' : ''}</option>
              ))}
            </select>
          </div>
          <div className="cl-hint" style={{ fontSize: 12.5, lineHeight: 1.5 }}>
            <div style={{ color: '#0F172A', fontWeight: 700 }}>
              Запишем по {price} ₽{price !== groupPrice ? ` — вместо цены группы ${groupPrice} ₽` : ''}
            </div>
            <div style={{ marginTop: 4 }}>
              {classes == null ? 'Смотрю цену группы…' : group
                ? `Группа «${group.name}» — ${group.price_rub} ₽ (${group.price_source === 'personal' ? 'личная цена ученика' : 'стандарт по уровню'})`
                : `Группы «${effSubject}» у ученика нет, цена по уровню — ${groupPrice} ₽`}
            </div>
            <div style={{ marginTop: 4 }}>Выбранная цена зафиксируется в карточке ученика и по выбранному преподавателю.</div>
          </div>
        </div>
        <div className="mfoot">
          <button className="mbtn quiet" onClick={onClose}>Отмена</button>
          <button className="mbtn primary" onClick={() => onContinue({ subject, price })}>Далее →</button>
        </div>
      </div>
    </div>
  )
}

// Третий шаг платной записи (Роман 23.09.2026): преподаватель и слот уже выбраны,
// осталось сказать, до какой даты ставить уроки в этот день недели. По умолчанию —
// конец учебного года, 31 мая 2027. Кол-во уроков считаем тут же, чтобы менеджер
// видел, что создаст.
const PAID_UNTIL_DEFAULT = '2027-05-31'
const PAID_DOW = ['воскресеньям', 'понедельникам', 'вторникам', 'средам', 'четвергам', 'пятницам', 'субботам']

function weeklyLessonCount(dateIso, untilIso) {
  if (!dateIso) return 0
  const a = new Date(dateIso + 'T00:00:00Z')
  if (isNaN(a.getTime())) return 0
  const b = untilIso ? new Date(untilIso + 'T00:00:00Z') : null
  if (!b || isNaN(b.getTime()) || b < a) return 1
  return Math.min(150, Math.floor((b - a) / (7 * 86400000)) + 1)
}

function PaidUntilModal({ slot, clientName, onClose, onConfirm }) {
  const [until, setUntil] = useState(PAID_UNTIL_DEFAULT)
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  const [done, setDone] = useState(null)      // сколько уроков создано — показываем в этом же окне
  const count = weeklyLessonCount(slot.date, until)
  const dow = PAID_DOW[new Date(slot.date + 'T00:00:00Z').getUTCDay()]

  const plural = (n) => (n % 10 === 1 && n % 100 !== 11) ? 'урок'
    : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) ? 'урока' : 'уроков'

  async function go() {
    if (busy || done != null || count < 1) return   // второй клик ничего не создаёт
    setBusy(true); setErr('')
    try {
      const r = await onConfirm(until)
      setDone({ created: Number(r && r.created) || 0, skipped: Number(r && r.skipped) || 0 })
      setBusy(false)
    } catch (e) { setErr(e.message || 'Не удалось создать уроки'); setBusy(false) }
  }

  return (
    <div className="overlay" onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal">
        <div className="mhead">
          <div className="ava">{(clientName || '?')[0]}</div>
          <div className="ttl">
            <b>{clientName}</b>
            <div className="sub">До какой даты проставить уроки?</div>
          </div>
          <div className="x" onClick={onClose}>✕</div>
        </div>
        <div className="mbody">
          {done != null ? (
            <div style={{ background: '#ECFDF5', border: '1px solid #A7F3D0', borderRadius: 14, padding: '14px 16px', fontSize: 13.5, lineHeight: 1.6 }}>
              <b style={{ color: '#047857', fontSize: 15 }}>✓ Выполнено — создано {done.created} {plural(done.created)}</b>
              {done.skipped > 0 && (
                <div style={{ marginTop: 4, color: '#B45309' }}>
                  {done.skipped} {plural(done.skipped)} пропущено — на эти дни у ученика уже стояли уроки.
                </div>
              )}
              <div style={{ marginTop: 6, color: '#065F46' }}>
                {slot.subject} по {slot.price} ₽, по {dow} в {slot.time}, преподаватель {slot.teacherName || '—'}.
                <br />С {fmtDateOnly(slot.date)} до {fmtDateOnly(until)}.
              </div>
              <div style={{ marginTop: 6, color: '#047857', fontSize: 12.5 }}>
                Уроки уезжают в МойКласс фоном — в расписании появятся в течение пары минут.
              </div>
            </div>
          ) : (<>
          <div className="cl-hint" style={{ fontSize: 12.5, lineHeight: 1.6, marginBottom: 10 }}>
            <div><b>{slot.subject}</b> · {slot.price} ₽ за урок</div>
            <div>Преподаватель: {slot.teacherName || '—'}</div>
            <div>Первый урок: {fmtDateOnly(slot.date)} в {slot.time}</div>
          </div>
          <div className="mfield">
            <label>Ставить уроки до</label>
            <input type="date" value={until} min={slot.date} onChange={e => setUntil(e.target.value)} />
          </div>
          <div style={{ fontSize: 13.5, fontWeight: 700, color: '#0F172A' }}>
            Будет создано {count} {plural(count)} — по {dow} в {slot.time}
          </div>
          {count >= 150 && <div style={{ fontSize: 12, color: '#B45309', marginTop: 4 }}>Больше 150 уроков за раз не ставим — сократите дату.</div>}
          {err && <div style={{ color: '#B91C1C', fontSize: 13, marginTop: 8 }}>{err}</div>}
          </>)}
        </div>
        <div className="mfoot">
          {done != null ? (
            <button className="mbtn primary" onClick={onClose}>Готово</button>
          ) : (<>
            <button className="mbtn quiet" onClick={onClose} disabled={busy}>Отмена</button>
            <button className="mbtn primary" onClick={go} disabled={busy || count < 1}>
              {busy ? 'Создаю…' : 'Создать платные уроки'}
            </button>
          </>)}
        </div>
      </div>
    </div>
  )
}

function TrialPickerModal({ clientName, onClose, onContinue }) {
  const [subject, setSubject] = useState(TRIAL_PICKER_SUBJECTS[0])

  return (
    <div className="overlay" onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal">
        <div className="mhead">
          <div className="ava">{(clientName || '?')[0]}</div>
          <div className="ttl">
            <b>{clientName}</b>
            <div className="sub">Перед записью — уточните предмет</div>
          </div>
          <div className="x" onClick={onClose}>✕</div>
        </div>
        <div className="mbody">
          <div className="mfield">
            <label>Предмет</label>
            <select value={subject} onChange={e => setSubject(e.target.value)}>
              {TRIAL_PICKER_SUBJECTS.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        </div>
        <div className="mfoot">
          <button className="mbtn quiet" onClick={onClose}>Отмена</button>
          <button className="mbtn primary" onClick={() => onContinue({ subject })}>Продолжить →</button>
        </div>
      </div>
    </div>
  )
}

// «Новый клиент» — сопроводитель заводит совсем нового человека (не с сайта, не
// существующий клиент платформы). Та же анкета 7/7, что и у звонильщика в «Добавить
// сделку» (см. CallerDashboard.js ALL_FIELDS/REQUIRED_KEYS) — Антон явно попросил
// одинаковые поля, держать в синхроне если там что-то поменяется.
const NC_CONTACT_FIELDS = [
  { key: 'phone',         label: 'Телефон',              kind: 'text',   required: false },
  { key: 'parentPhone',   label: 'Тел. родителя',        kind: 'text',   required: false },
  { key: 'parentName',    label: 'Имя родителя',         kind: 'text',   required: false },
  { key: 'sourceChannel', label: 'Откуда пришёл',        kind: 'select', required: true,
    options: ['Сайт','ВКонтакте','Рекомендация знакомых','Яндекс услуги','Обзвон старой базы','Блог','Школа блогинга','лингва','Другое'] },
  { key: 'goal',          label: 'Что хотите от репетитора', kind: 'select', required: true,
    options: ['Подтянуть оценки','Подготовка к ОГЭ','Подготовка к ЕГЭ','Помощь с ДЗ','Углублённые знания','Подготовка к олимпиаде'] },
  { key: 'city',          label: 'Город',                kind: 'text',   required: false },
]
const NC_CHILD_FIELDS = [
  { key: 'childName', label: 'Имя Фамилия ребёнка', kind: 'text',   required: true, placeholder: 'Иван Иванов' },
  { key: 'childPhone', label: 'Телефон ребёнка',    kind: 'text',   required: false },
  { key: 'classNum',  label: 'Класс',                kind: 'select', required: true,
    options: ['Дошкольник','1 класс','2 класс','3 класс','4 класс','5 класс','6 класс','7 класс','8 класс','9 класс','10 класс','11 класс','Колледж или Техникум'] },
  { key: 'subject',   label: 'Предмет',              kind: 'select', required: true,
    options: ['Математика','Математика ОГЭ','Математика ЕГЭ','Русский язык','Русский язык ОГЭ','Русский язык ЕГЭ','Английский язык','Английский язык ОГЭ','Английский язык ЕГЭ','Физика','Физика ОГЭ','Физика ЕГЭ','Химия','Химия ОГЭ','Химия ЕГЭ','Биология','Биология ОГЭ','Биология ЕГЭ','Информатика','Информатика ОГЭ','Информатика ЕГЭ','Обществознание','Обществознание ОГЭ','Обществознание ЕГЭ','История','История ОГЭ','История ЕГЭ','География','География ОГЭ','Окружающий мир','Немецкий','Китайский язык','Турецкий язык','Фин.грамостность','Психология','Блогинг','Дошкольник Математика'] },
  { key: 'scoreNow',  label: 'Оценка сейчас',        kind: 'select', required: true, options: ['2','3','4','5'] },
  { key: 'scorePrev', label: 'Оценка в прошлом году', kind: 'select', required: true, options: ['2','3','4','5'] },
]
const NC_ALL_FIELDS = [...NC_CONTACT_FIELDS, ...NC_CHILD_FIELDS]
const NC_REQUIRED_KEYS = NC_ALL_FIELDS.filter(f => f.required).map(f => f.key)
function ncIsNonEmpty(v) { return v != null && String(v).trim() !== '' }
function ncCountRequired(values) { return NC_REQUIRED_KEYS.reduce((n, k) => n + (ncIsNonEmpty(values[k]) ? 1 : 0), 0) }
// Названия незаполненных обязательных полей — для подсказки под кнопками
function ncMissingLabels(values) {
  return NC_ALL_FIELDS.filter(f => f.required && !ncIsNonEmpty(values[f.key])).map(f => f.label)
}

function NcField({ field, value, onChange }) {
  return (
    <div className="mfield">
      <label>{field.label}{field.required && <span style={{ color: '#EF4444' }}> *</span>}</label>
      {field.kind === 'text' && (
        <input type="text" value={value || ''} placeholder={field.placeholder || ''} onChange={e => onChange(e.target.value)} />
      )}
      {field.kind === 'select' && (
        <select value={value || ''} onChange={e => onChange(e.target.value)}>
          <option value="">— выберите —</option>
          {field.options.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
      )}
    </div>
  )
}

export function NewClientModal({ onClose, onOpenExisting, onContinue, onCreateOnly, initial }) {
  // initial — префилл из карточки обзвона («Перенести клиента»)
  const [values, setValues] = useState(initial || {})
  const [saving, setSaving] = useState(false)
  const [phoneCheck, setPhoneCheck] = useState(null) // null | 'loading' | {found:false} | {found:true, name, balance_rub, mkId}
  const [dismissedWarning, setDismissedWarning] = useState(false)

  const update = (k, v) => {
    setValues(prev => ({ ...prev, [k]: v }))
    if (k === 'phone') { setPhoneCheck(null); setDismissedWarning(false) }
  }

  useEffect(() => {
    const digits = String(values.phone || '').replace(/\D/g, '')
    if (digits.length < 10) { setPhoneCheck(null); return }
    let cancelled = false
    setPhoneCheck('loading')
    const t = setTimeout(() => {
      api.get('/api/platform/support-clients/lookup', { params: { phone: values.phone } })
        .then(r => { if (!cancelled) setPhoneCheck(r.data) })
        .catch(() => { if (!cancelled) setPhoneCheck(null) })
    }, 400)
    return () => { cancelled = true; clearTimeout(t) }
  }, [values.phone])

  const done = ncCountRequired(values)
  const total = NC_REQUIRED_KEYS.length
  const canContinue = done === total && ncIsNonEmpty(values.phone) && !saving

  const submit = () => {
    if (!canContinue) return
    setSaving(true)
    api.post('/api/platform/support-new-clients', values)
      .then(r => onContinue(r.data.id, values))
      .catch(e => alert('Не удалось сохранить анкету:\n' + (e.response?.data?.error || e.message)))
      .finally(() => setSaving(false))
  }

  // Создать ученика без пробного: сохраняем анкету и заводим ученика в МК без урока.
  const submitOnly = () => {
    if (!canContinue) return
    setSaving(true)
    api.post('/api/platform/support-new-clients', values)
      .then(r => api.post(`/api/platform/support-new-clients/${r.data.id}/create-only`, {}))
      .then(r => { if (onCreateOnly) onCreateOnly(r.data) })
      .catch(e => alert('Не удалось создать ученика:\n' + (e.response?.data?.error || e.message)))
      .finally(() => setSaving(false))
  }

  return (
    <div className="overlay" onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal wide">
        <div className="mhead">
          <div className="ava">+</div>
          <div className="ttl">
            <b>Новый клиент</b>
            <div className="sub">Заполни анкету — как у звонильщика, нужны все 7 обязательных полей</div>
          </div>
          <div className="x" onClick={onClose}>✕</div>
        </div>
        <div className="mbody">
          {phoneCheck === 'loading' && (
            <div className="mbanner" style={{ background: '#F8FAFC', color: '#64748B' }}>Проверяю телефон…</div>
          )}
          {phoneCheck && phoneCheck.found && !dismissedWarning && (
            <div className="mbanner" style={{ background: '#FFF7ED', color: '#B45309', border: '1px solid #FDE68A', flexWrap: 'wrap' }}>
              <span className="tag">Уже есть</span>
              <span style={{ flex: 1 }}>
                Клиент с таким телефоном уже есть: <b>{phoneCheck.name || '—'}</b>
                {phoneCheck.balance_rub != null && <> · баланс {phoneCheck.balance_rub}₽</>}
              </span>
              <button className="mbtn primary" style={{ background: '#B45309' }} onClick={() => onOpenExisting(phoneCheck.mkId)}>Открыть его</button>
              <button className="mbtn quiet" onClick={() => setDismissedWarning(true)}>Всё равно продолжить как новый</button>
            </div>
          )}
          <div className="anketa-grid">
            <div>
              <div className="anketa-col-title">Контакты и источник</div>
              {NC_CONTACT_FIELDS.map(f => <NcField key={f.key} field={f} value={values[f.key]} onChange={v => update(f.key, v)} />)}
            </div>
            <div>
              <div className="anketa-col-title">Анкета ребёнка</div>
              {NC_CHILD_FIELDS.map(f => <NcField key={f.key} field={f} value={values[f.key]} onChange={v => update(f.key, v)} />)}
            </div>
          </div>
        </div>
        <div className="mfoot">
          <span style={{ fontSize: 12, color: '#94A3B8', marginRight: 'auto' }}>
            Анкета: <b style={{ color: '#B45309' }}>{done}/{total}</b> — для записи на пробный нужно 7/7
          </span>
          <button className="mbtn quiet" onClick={onClose}>Отмена</button>
          {!canContinue && !saving && ncMissingLabels(values).length > 0 && (
            <div style={{ fontSize: 12.5, color: '#B45309', background: '#FFFBEB', border: '1px solid #FDE68A', borderRadius: 10, padding: '8px 10px', marginBottom: 10 }}>
              Заполните: {ncMissingLabels(values).join(', ')}
            </div>
          )}
          <button className="mbtn primary" disabled={!canContinue} style={{ border: '1.5px solid #0284C7', ...(!canContinue ? { opacity: 0.5, cursor: 'default' } : {}) }} onClick={submitOnly}>
            {saving ? '…' : 'Создать без пробного'}
          </button>
          <button className="mbtn primary" disabled={!canContinue} style={!canContinue ? { opacity: 0.5, cursor: 'default' } : {}} onClick={submit}>
            {saving ? 'Сохраняю…' : 'Продолжить →'}
          </button>
        </div>
      </div>
    </div>
  )
}

// «Перенести звонок» — мама/клиент попросили перезвонить в конкретное время.
// Задача не закрывается, просто прячется из очереди до срока (см. supportTasks.js
// snoozeTask). Тот же паттерн полей, что у звонильщика (CallerDashboard CallbackForm).
function SnoozeCallForm({ task, onSubmit, onClose }) {
  const [date, setDate] = useState('')
  const [time, setTime] = useState('')
  const [note, setNote] = useState('')
  return (
    <div style={{ background: '#F0F9FF', border: '1px solid #BAE6FD', borderRadius: 16, padding: 14, marginTop: 10 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#0369A1', marginBottom: 10 }}>
        📅 Перенести звонок на другое время
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        <label style={{ display: 'block' }}>
          <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em', color: '#0369A1AA', fontWeight: 600, marginBottom: 4 }}>Дата</div>
          <input type="date" value={date} onChange={e => setDate(e.target.value)}
            style={{ width: '100%', fontSize: 13, background: '#fff', border: '1px solid #BAE6FD', borderRadius: 8, padding: '8px 10px', outline: 'none' }} />
        </label>
        <label style={{ display: 'block' }}>
          <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em', color: '#0369A1AA', fontWeight: 600, marginBottom: 4 }}>Время</div>
          <input type="time" value={time} onChange={e => setTime(e.target.value)}
            style={{ width: '100%', fontSize: 13, background: '#fff', border: '1px solid #BAE6FD', borderRadius: 8, padding: '8px 10px', outline: 'none' }} />
        </label>
      </div>
      <label style={{ display: 'block', marginTop: 10 }}>
        <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em', color: '#0369A1AA', fontWeight: 600, marginBottom: 4 }}>Комментарий (необязательно)</div>
        <input value={note} onChange={e => setNote(e.target.value)} placeholder="напр. «просила до обеда»"
          style={{ width: '100%', fontSize: 13, background: '#fff', border: '1px solid #BAE6FD', borderRadius: 8, padding: '8px 10px', outline: 'none' }} />
      </label>
      <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
        <button
          style={{ fontSize: 13, fontWeight: 700, color: '#fff', background: '#38BDF8', border: 'none', borderRadius: 8, padding: '9px 16px', cursor: date && time ? 'pointer' : 'default', opacity: date && time ? 1 : 0.5 }}
          disabled={!date || !time}
          onClick={() => { if (date && time) onSubmit(task, date, time, note) }}>
          Перенести
        </button>
        <button style={{ fontSize: 13, color: '#0369A1AA', background: 'none', border: 'none', cursor: 'pointer' }} onClick={onClose}>Отмена</button>
      </div>
    </div>
  )
}

// «сегодня 14:20» / «вчера 11:05» / «28 июля 16:40» — как в ленте комментариев.
const COMMENT_MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
function fmtCommentDate(raw) {
  const s = String(raw || '').replace(' ', 'T')
  const d = new Date(s)
  if (isNaN(d.getTime())) return String(raw || '')
  const hh = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0')
  const today = new Date()
  const sameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
  if (sameDay(d, today)) return 'сегодня ' + hh
  const y = new Date(today.getTime() - 86400000)
  if (sameDay(d, y)) return 'вчера ' + hh
  return d.getDate() + ' ' + COMMENT_MONTHS[d.getMonth()] + ' ' + hh
}


// Панель чатов Telegram (справа) — зеркало MAX на /api/telegram/*. Самодостаточна.
function TelegramPanel({ chats, setChats, sel, setSel, onOpenClient, onOpenTutor, onOpenDeal }) {
  const [msgs, setMsgs] = useState([])
  const [reply, setReply] = useState('')
  const [sending, setSending] = useState(false)
  const [search, setSearch] = useState('')
  const scrollRef = useRef(null)
  const tgAtBottom = useRef(true)
  const tgPrevSel = useRef(null)
  useEffect(() => {
    if (!sel) { setMsgs([]); return }
    let a = true
    const load = () => api.get('/api/telegram/chats/' + sel + '/messages').then(r => { if (a) setMsgs(r.data || []) }).catch(() => {})
    load(); const t = setInterval(load, 10000)
    return () => { a = false; clearInterval(t) }
  }, [sel])
  useEffect(() => {
    const el = scrollRef.current; if (!el) return
    // Скроллим вниз только при открытии другого чата или если сопровод уже внизу —
    // иначе пуллинг дёргал ленту вниз, пока читаешь историю.
    const changed = tgPrevSel.current !== sel; tgPrevSel.current = sel
    if (!changed && !tgAtBottom.current) return
    const t = setTimeout(() => { el.scrollTop = el.scrollHeight; tgAtBottom.current = true }, 0)
    return () => clearTimeout(t)
  }, [msgs, sel])

  const send = () => {
    const text = reply.trim(); if (!text || !sel || sending) return
    setSending(true)
    api.post('/api/telegram/chats/' + sel + '/send', { text })
      .then(() => {
        setReply('')
        // Отправка = чат прочитан. Сервер ставит unread=0, но список чатов
        // опрашивается раз в 15с — гасим бейдж мгновенно локально и
        // перечитываем список (как делает кнопка «Ответ не требуется»).
        setChats(cs => cs.map(c => c.chat_id === sel ? { ...c, unread: 0 } : c))
        return Promise.all([
          api.get('/api/telegram/chats/' + sel + '/messages').then(r => setMsgs(r.data || [])),
          api.get('/api/telegram/chats').then(r => setChats(r.data || [])),
        ])
      })
      .catch(e => alert('Не удалось отправить: ' + ((e.response && e.response.data && e.response.data.error) || e.message)))
      .finally(() => setSending(false))
  }
  const noReply = () => {
    if (!sel || sending) return
    setSending(true)
    api.post('/api/telegram/chats/' + sel + '/no-reply')
      .then(() => Promise.all([
        api.get('/api/telegram/chats/' + sel + '/messages').then(r => setMsgs(r.data || [])),
        api.get('/api/telegram/chats').then(r => setChats(r.data || [])),
      ])).catch(() => {}).finally(() => setSending(false))
  }

  const q = (search || '').trim().toLowerCase()
  const bs = q ? chats.filter(c => ((c.user_name || '') + ' ' + (c.client_name || '') + ' ' + (c.last_text || '')).toLowerCase().includes(q)) : chats
  const list = [...bs].sort((a, b) => ((b.unread > 0) - (a.unread > 0)) || ((b.last_at || 0) - (a.last_at || 0)))
  const chat = sel ? (chats.find(c => c.chat_id === sel) || {}) : null
  // Вложения TG-сообщения. У входящих есть file_id → тянем через прокси
  // /api/telegram/file/<file_id>. Голосовые/аудио — сразу в <audio>-плеер
  // (не скачивать), картинки — превью, прочее — ссылка.
  const tgAtts = (m) => {
    if (!m.attachments) return null
    let a = []
    try { a = JSON.parse(m.attachments) } catch (e) { return null }
    return a.map((f, i) => {
      const src = f.file_id ? ('/api/telegram/file/' + f.file_id) : f.url
      if (f.type === 'voice' || f.type === 'audio') return src ? <audio key={i} controls preload="metadata" src={src} className="block w-[320px] max-w-full mb-1" /> : null
      if (f.type === 'image' || f.type === 'photo') return src ? <a key={i} href={src} target="_blank" rel="noopener" className="block mb-1"><img src={src} alt="вложение" className="max-w-full rounded-lg" style={{ maxHeight: 220 }} /></a> : null
      return <a key={i} href={src || '#'} target="_blank" rel="noopener" className={'flex items-center gap-2 mb-1 underline break-all ' + (m.direction === 'out' ? 'text-white' : 'text-sky-600')}>📎 {f.filename || 'Файл'}{f.size ? ' · ' + Math.round(f.size / 1024) + ' КБ' : ''}</a>
    })
  }
  return (
    <>
      <aside className="hidden lg:block w-[360px] shrink-0 border-l border-slate-200 bg-white sticky top-[56px] self-start overflow-y-auto" style={{ height: 'calc(100dvh - 56px)' }}>
        <div className="px-3 py-2 border-b border-slate-100 sticky top-0 bg-white z-10 flex items-center gap-2">
          <span className="font-semibold text-slate-800 text-[13px] shrink-0">Чаты Telegram <span className="text-slate-400 font-normal">({q ? list.length + '/' + chats.length : chats.length})</span></span>
          <div className="relative flex-1 min-w-0">
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Поиск…" className="w-full pl-2 pr-6 py-1 rounded-md border border-slate-200 text-[12px] focus:outline-none focus:ring-1 focus:ring-sky-300" />
            {q && <button onClick={() => setSearch('')} className="absolute right-1 top-1/2 -translate-y-1/2 text-slate-400 text-[13px]">✕</button>}
          </div>
        </div>
        {list.length === 0 && <div className="p-6 text-center text-slate-400 text-sm">{q ? 'Ничего не найдено' : 'Пока нет чатов'}</div>}
        {list.map(c => (
          <button key={c.chat_id} onClick={() => setSel(c.chat_id)} className={'w-full text-left px-3 py-2.5 flex gap-3 items-center border-b border-slate-50 hover:bg-slate-50 ' + (sel === c.chat_id ? 'bg-sky-50' : '')}>
            <span className="relative shrink-0">
              <span className="w-9 h-9 rounded-full bg-cyan-100 text-cyan-700 font-bold text-sm flex items-center justify-center">{(c.user_name || '?').trim()[0]}</span>
              {c.unread > 0 && <span className="absolute -top-1 -right-1 min-w-[16px] h-[16px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center ring-2 ring-white">{c.unread}</span>}
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center justify-between gap-2">
                <span className="flex items-center gap-1.5 min-w-0">
                  <span className={'truncate text-[14px] ' + (c.unread > 0 ? 'font-bold text-slate-900' : 'font-semibold text-slate-800')}>{c.user_name || 'Без имени'}</span>
                  {c.is_teacher ? <span className="shrink-0 text-[10px] font-semibold px-1.5 py-0.5 rounded-full bg-violet-100 text-violet-700">препод</span> : null}
                </span>
                <span className="text-[11px] text-slate-400 shrink-0 pr-1.5">{fmtChatTime(c.last_at)}</span>
              </span>
              <span className={'block text-[12px] truncate ' + (c.unread > 0 ? 'text-slate-700 font-medium' : 'text-slate-500')}>{c.last_text || ''}</span>
              {c.clients && c.clients.length > 0 ? <span className="block text-[11px] text-sky-600 truncate">{c.clients.map(k => k.client_name).join(', ')}</span>
                : c.client_name ? <span className={'block text-[11px] truncate ' + (c.is_teacher ? 'text-violet-600' : 'text-slate-500')}>{c.client_name}</span>
                : <span className="block text-[11px] text-amber-600">не привязан</span>}
            </span>
          </button>
        ))}
      </aside>
      {sel && chat && (
        <div className="fixed inset-0 z-50 flex items-stretch sm:items-center justify-center sm:p-4" onClick={() => setSel(null)}>
          <div className="absolute inset-0 bg-black/40" />
          <div className="relative bg-white w-full h-full sm:h-[80vh] sm:max-w-[560px] sm:rounded-2xl shadow-2xl flex flex-col overflow-hidden" onClick={e => e.stopPropagation()}>
            <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between gap-3">
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-slate-800 truncate flex items-center gap-2">✈️ {chat.user_name || 'Чат'}{chat.is_teacher ? <span className="shrink-0 text-[11px] font-semibold px-2 py-0.5 rounded-full bg-violet-100 text-violet-700">преподаватель</span> : null}</div>
                {(chat.clients && chat.clients.length > 0) || (chat.is_teacher && chat.teacher_mk_id) ? (
                  <div className="text-[12px] flex flex-wrap gap-x-2">
                    {(chat.clients || []).map(k => (<button key={k.client_mk_id} onClick={() => { setSel(null); onOpenClient && onOpenClient(k.client_mk_id) }} className="text-sky-600 hover:underline">{k.client_name} ↗</button>))}
                    {chat.is_teacher && chat.teacher_mk_id ? (<button onClick={() => { setSel(null); onOpenTutor && onOpenTutor(chat.teacher_mk_id) }} className="text-violet-600 hover:underline">{chat.teacher_name || 'препод'} ↗</button>) : null}
                  </div>
                ) : chat.client_name ? <div className="text-[12px] text-slate-500">{chat.client_name}</div> : <div className="text-[12px] text-amber-600">не привязан к клиенту</div>}
              </div>
              {onOpenDeal && chat.phone && <button onClick={() => { setSel(null); onOpenDeal(chat) }} className="shrink-0 text-[12px] font-semibold px-2.5 py-1 rounded-lg" style={{ background: '#FFFBEB', color: '#B45309', border: '1px solid #FDE68A' }} title="Открыть или создать сделку по телефону собеседника">Сделка ↗</button>}
              {chat.phone && <div className="text-[12px] text-slate-400 shrink-0">{chat.phone}</div>}
              <button onClick={() => setSel(null)} className="shrink-0 w-8 h-8 rounded-full hover:bg-slate-100 text-slate-500 text-xl leading-none">×</button>
            </div>
            <div ref={scrollRef} onScroll={e => { const el = e.currentTarget; tgAtBottom.current = el.scrollHeight - el.scrollTop - el.clientHeight < 120 }} className="flex-1 overflow-y-auto p-4 space-y-2 bg-slate-50">
              {msgs.length === 0 && <div className="text-center text-slate-400 text-sm">Сообщений нет</div>}
              {msgs.map((m, idx) => (
                m.direction === 'note' ? (
                  <div key={m.id || idx} className="flex justify-center"><div className="text-[11px] text-slate-500 bg-slate-100 rounded-full px-3 py-1">Ответ не требуется — {m.author || '?'} · {fmtChatTime(m.at)}</div></div>
                ) : (
                  <div key={m.id || idx} className={'flex ' + (m.direction === 'out' ? 'justify-end' : 'justify-start')}>
                    <div className={'max-w-[75%] px-3 py-2 rounded-2xl text-[14px] whitespace-pre-wrap break-words ' + (m.direction === 'out' ? 'bg-sky-500 text-white' : 'bg-white border border-slate-200 text-slate-800')}>
                      {tgAtts(m)}
                      {m.text}
                      <div className={'text-[10px] mt-1 ' + (m.direction === 'out' ? 'text-sky-100' : 'text-slate-400')}>{m.direction === 'out' && m.author ? m.author + ' · ' : ''}{fmtChatTime(m.at)}</div>
                    </div>
                  </div>
                )
              ))}
            </div>
            <div className="px-4 py-3 border-t border-slate-100">
              <div className="flex gap-2 items-center">
                <textarea value={reply} rows={1}
                  onChange={e => { setReply(e.target.value); e.target.style.height = 'auto'; e.target.style.height = Math.min(e.target.scrollHeight, 160) + 'px' }}
                  onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); e.target.style.height = 'auto'; send() } }}
                  placeholder="Написать сообщение… (Shift+Enter — новая строка)"
                  style={{ maxHeight: 160, overflowY: 'auto' }}
                  className="flex-1 px-3 py-2 rounded-lg border border-slate-200 text-sm leading-snug resize-none focus:outline-none focus:ring-2 focus:ring-sky-200" />
                <button onClick={send} disabled={sending || !reply.trim()} className="px-4 py-2 rounded-lg bg-sky-500 text-white text-sm font-semibold disabled:opacity-50">{sending ? '…' : 'Отправить'}</button>
              </div>
              <button onClick={noReply} disabled={sending} className="mt-2 text-[12px] text-slate-500 hover:text-slate-700 disabled:opacity-50">Ответ не требуется</button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

// mode="writer" — кабинет переписчика (Антон 07.09): те же чаты (Max, Кабинет, Telegram), в центре —
// сделка звонильщицы (DealWorkspace из CallerDashboard). Instagram убран. Без mode — сопроводитель как был.
// Карточка клиента: «кто/когда выполнил» (completed_at хранится в UTC сервера без TZ → нормализуем).
function CardCompletedLine({ by, at }) {
  // Автора стали записывать 20.10.2026; у задач, закрытых раньше, его неоткуда
  // взять (часть добрали из журнала аудита). Молчать нельзя — сопроводитель
  // видел «закрыта» и не понимал, кто закрыл (Роман 02.11.2026).
  if (!by && !at) return (
    <div style={{ marginTop: 6, paddingTop: 6, borderTop: '1px dashed #e5e7eb', fontSize: 12.5, fontWeight: 600, color: '#94a3b8' }}>
      ✓ Выполнена · кто закрыл — не записано
    </div>
  )
  const norm = at && !/[zZ+]/.test(at) ? at.replace(' ', 'T') + 'Z' : at
  return (
    <div style={{ marginTop: 6, paddingTop: 6, borderTop: '1px dashed #e5e7eb', fontSize: 12.5, fontWeight: 600, color: '#047857' }}>
      ✓ Выполнил(а): {by || '—'}{at ? ' · ' + fmtMskDateTime(norm) : ''}
    </div>
  )
}
// Карточка клиента: read-only чек-лист пробного (автозадача). Авто-пункты тянем из trial-status.
function CardTrialChecklistRO({ mkUserId, meta, checklist }) {
  const [auto, setAuto] = useState(null)
  const lid = (meta && meta.lessonId) || 0
  useEffect(() => {
    if (!mkUserId) { setAuto({}); return }
    api.get('/api/platform/trial-status', { params: { mkUserId, lessonId: lid } }).then(r => setAuto(r.data || {})).catch(() => setAuto({}))
  }, [mkUserId, lid])
  const cl = checklist || {}
  const ck = (on, label, note) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '3px 0', fontSize: 13 }}>
      <span style={{ width: 16, height: 16, borderRadius: 5, flex: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 800, background: on ? '#10B981' : '#fff', color: on ? '#fff' : 'transparent', border: on ? 'none' : '1.5px solid #CBD5E1' }}>{on ? '✓' : ''}</span>
      <span style={{ color: on ? '#334155' : '#94A3B8' }}>{label}</span>
      {note ? <span style={{ marginLeft: 'auto', fontSize: 11, color: '#94A3B8', fontWeight: 600 }}>{note}</span> : null}
    </div>
  )
  const kv = (k, v) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, fontSize: 12.5, padding: '2px 0' }}>
      <span style={{ color: '#94A3B8' }}>{k}</span><span style={{ fontWeight: 600, textAlign: 'right' }}>{v || '—'}</span>
    </div>
  )
  return (
    <div style={{ marginTop: 8, padding: '10px 12px', background: '#F8FAFC', border: '1px solid #EEF2F6', borderRadius: 12 }}>
      <div style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '.04em', color: '#94A3B8', fontWeight: 700, marginBottom: 7 }}>Чек-лист пробного</div>
      {kv('Преподаватель', meta && meta.teacherName)}
      {kv('Группа', (auto && auto.group) || (meta && meta.group))}
      <div style={{ height: 1, background: '#EEF2F6', margin: '6px 0' }} />
      {ck(!!(auto && auto.enteredLk === true), 'Зашёл в ЛК', auto ? (auto.enteredLk === true ? '' : 'нет') : 'проверяю')}
      {ck(!!(auto && auto.confirmed === true), 'Подтвердил присутствие', auto ? (auto.confirmed === true ? '' : 'нет') : 'проверяю')}
      {ck(!!cl.app, 'Консультация об установке приложения', !cl.app ? 'не проводилась' : '')}
      {ck(!!cl.lk, 'Консультация по ЛК', !cl.lk ? 'не проводилась' : '')}
      {ck(!!cl.pay, 'Консультация по оплате', !cl.pay ? 'не проводилась' : '')}
      {ck(!!cl.phone_confirm, 'Подтвердил присутствие по телефону', !cl.phone_confirm ? '—' : '')}
    </div>
  )
}
function TrialDoneChecklist({ task, onToggle, onOpenClient }) {
  const mk = task.meta && task.meta.mkUserId
  const cl = (task.meta && task.meta.checklist) || {}
  const teacher = (task.meta && task.meta.teacherName) || null
  const row = (key, label) => (
    <label key={key} style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '7px 0', cursor: 'pointer', fontSize: 13.5, color: '#334155' }}>
      <input type="checkbox" checked={!!cl[key]} onChange={e => onToggle(task, key, e.target.checked)} style={{ width: 17, height: 17, accentColor: '#10B981' }} />
      {label}
    </label>
  )
  return (
    <div className="panel" style={{ marginTop: 12 }}>
      <h3>Пробный прошёл — что сделать</h3>
      <div className="row"><span className="k">Клиент</span><span className="v">
        {mk ? <button onClick={() => onOpenClient && onOpenClient(mk)} style={{ background: 'none', border: 0, color: '#0284C7', cursor: 'pointer', padding: 0, font: 'inherit', fontWeight: 700 }}>{task.clientName || 'Клиент'} ↗</button> : (task.clientName || '—')}
      </span></div>
      <div className="row"><span className="k">Преподаватель пробного</span><span className="v" style={{ fontWeight: 700 }}>{teacher || '—'}</span></div>
      {[['call', 'Позвонить, узнать как дела'], ['tutor', 'Нужно ли сменить репетитора'], ['tech', 'Всё ли работало технически'], ['schedule', 'Установить клиенту расписание']].map(([k, l]) => row(k, l))}
    </div>
  )
}

function OwnTaskChecklist({ task, onToggle, onOpenClient }) {
  const [auto, setAuto] = useState(null)
  const mk = task.meta && task.meta.mkUserId
  const lid = (task.meta && task.meta.lessonId) || 0
  useEffect(() => {
    if (!mk) { setAuto({ enteredLk: null, confirmed: null }); return }
    api.get('/api/platform/trial-status', { params: { mkUserId: mk, lessonId: lid } })
      .then(r => setAuto(r.data || {})).catch(() => setAuto({}))
  }, [mk, lid])
  const cl = (task.meta && task.meta.checklist) || {}
  const teacher = (task.meta && task.meta.teacherName) || null
  const confirmByPhone = (value) => {
    onToggle(task, 'phone_confirm', value)
    if (value && mk && lid) {
      api.post('/api/platform/confirm-attendance', { mkUserId: mk, lessonId: lid })
        .then(() => api.get('/api/platform/trial-status', { params: { mkUserId: mk, lessonId: lid } }).then(r => setAuto(r.data || {})))
        .catch(e => alert('Не удалось подтвердить: ' + ((e.response && e.response.data && e.response.data.error) || e.message)))
    }
  }
  const autoRow = (label, val) => (
    <div className="row"><span className="k">{label}</span>
      <span className="v" style={{ color: val === true ? '#047857' : val === false ? '#B91C1C' : '#94A3B8' }}>
        {val === true ? '✓ да' : val === false ? '✗ нет' : '— проверяем'}
      </span></div>
  )
  return (
    <div className="panel" style={{ marginTop: 12 }}>
      <h3>Чек-лист пробного</h3>
      <div className="row"><span className="k">Клиент</span><span className="v">
        {mk ? <button onClick={() => onOpenClient && onOpenClient(mk)} style={{ background: 'none', border: 0, color: '#0284C7', cursor: 'pointer', padding: 0, font: 'inherit', fontWeight: 700 }}>{(auto && auto.name) || task.clientName || 'Клиент'} ↗</button> : ((auto && auto.name) || task.clientName || '—')}
        {auto && auto.phone ? <div style={{ fontSize: 12, color: '#64748B', marginTop: 2 }}>{auto.phone}</div> : null}
      </span></div>
      <div className="row"><span className="k">Преподаватель пробного</span><span className="v" style={{ fontWeight: 700 }}>{teacher || '—'}</span></div>
      <div className="row"><span className="k">Группа</span><span className="v">{(auto && auto.group) || '—'}</span></div>
      {autoRow('Зашёл в ЛК', auto ? auto.enteredLk : null)}
      {autoRow('Подтвердил присутствие', auto ? auto.confirmed : null)}
      {(task.meta && task.meta.lessonId) ? (
        <label style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '7px 0', cursor: 'pointer', fontSize: 13.5, color: '#334155' }}>
          <input type="checkbox" checked={!!cl.phone_confirm} onChange={e => confirmByPhone(e.target.checked)} style={{ width: 17, height: 17, accentColor: '#10B981' }} />
          Подтвердил присутствие по телефону
        </label>
      ) : null}
      {[['app', 'Консультация об установке приложения'], ['lk', 'Консультация по ЛК проведена'], ['pay', 'Консультация по оплате проведена']].map(([key, label]) => (
        <label key={key} style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '7px 0', cursor: 'pointer', fontSize: 13.5, color: '#334155' }}>
          <input type="checkbox" checked={!!cl[key]} onChange={e => onToggle(task, key, e.target.checked)} style={{ width: 17, height: 17, accentColor: '#10B981' }} />
          {label}
        </label>
      ))}
    </div>
  )
}

export default function SupportDashboard({ onLogout, mode }) {
  const isWriter = mode === 'writer'
  const isTutors = mode === 'tutors'   // менеджер по преподавателям (21.10): Созвоны + Чаты, без очереди задач сопровождения
  const dealRef = useRef(null)
  const name = localStorage.getItem('name') || (isWriter ? 'Переписчик' : isTutors ? 'Менеджер по преподавателям' : 'Сопроводитель')
  const initials = name.split(' ').map(s => s[0]).join('').substring(0, 2).toUpperCase()

  const [onShift, setOnShift] = useState(false)
  const [shiftSince, setShiftSince] = useState(null)
  const [shiftBusy, setShiftBusy] = useState(false)

  const [tasks, setTasks] = useState([])
  const [sel, setSel] = useState(0)
  const selIdRef = useRef(null)   // 06.10: id выбранной задачи — список обновляется раз в 4 с, номер места «уплывал» на другую задачу
  const [loading, setLoading] = useState(true)
  const [done, setDone] = useState(0)

  // Вкладка в шапке: 'tasks' (готово) | 'clients' (готово, чтение) | 'trials' (макет, пока заглушка)
  const [view, setView] = useState(() => {
    try { return new URLSearchParams(window.location.search).get('view') || (mode === 'writer' ? 'deals' : mode === 'tutors' ? 'otbor' : 'tasks') } catch (e) { return mode === 'writer' ? 'deals' : mode === 'tutors' ? 'otbor' : 'tasks' }
  })

  // Счётчик очереди «Отбор» на вкладке — чтобы про раздел не забывали.
  // Бэк кэширует доску 2 мин, так что запрос дешёвый.
  const [otborWaiting, setOtborWaiting] = useState(0)
  const [libOpen, setLibOpen] = useState(false)   // окно загрузки методичек
  useEffect(() => {
    api.get('/api/otbor/board').then(r => setOtborWaiting(r.data?.counts?.waiting || 0)).catch(() => {})
  }, [view])

  // ── MAX-чаты ──
  const [chats, setChats] = useState([])
  const [selChatId, setSelChatId] = useState(null)
  // Чат кабинета: переписки сопровождения с клиентом и преподавателем (05.08)
  const [chatSource, setChatSource] = useState('max')      // 'max' | 'cabinet'
  const [adminChats, setAdminChats] = useState([])
  const [adminSearch, setAdminSearch] = useState('')
  const [adminFilter, setAdminFilter] = useState('all')    // all | student | teacher
  const [adminSel, setAdminSel] = useState(null)           // {role, mkId, name}
  const [adminMsgs, setAdminMsgs] = useState([])
  const [adminDeact, setAdminDeact] = useState(null)       // снятие препода с сайта {open, last_cleared} — полоска над чатом (08.09)
  const [adminDeactBusy, setAdminDeactBusy] = useState(false)
  const [adminText, setAdminText] = useState('')
  const [adminBusy, setAdminBusy] = useState(false)
  const [tgChats, setTgChats] = useState([])
  const [tgSel, setTgSel] = useState(null)
  useEffect(() => {
    let alive = true
    const load = () => api.get('/api/telegram/chats').then(r => { if (alive) setTgChats(r.data || []) }).catch(() => {})
    load(); const t = setInterval(load, 15000)
    return () => { alive = false; clearInterval(t) }
  }, [])
  const [chatMessages, setChatMessages] = useState([])
  const maxScrollRef = useRef(null)
  const adminScrollRef = useRef(null)
  const maxFileRef = useRef(null)
  const maxAtBottom = useRef(true)
  const maxPrevSel = useRef(null)
  const adminAtBottom = useRef(true)
  const adminPrevSel = useRef(null)
  const adminFileRef = useRef(null)
  useEffect(() => {
    const el = maxScrollRef.current
    if (!el) return
    const changed = maxPrevSel.current !== selChatId; maxPrevSel.current = selChatId
    if (!changed && !maxAtBottom.current) return
    const t = setTimeout(() => { el.scrollTop = el.scrollHeight; maxAtBottom.current = true }, 0)
    return () => clearTimeout(t)
  }, [chatMessages, selChatId])
  const [maxReply, setMaxReply] = useState('')
  const [maxSending, setMaxSending] = useState(false)
  const [replyTo, setReplyTo] = useState(null)
  const [chatSearch, setChatSearch] = useState('')
  useEffect(() => {
    let alive = true
    const load = () => api.get('/api/max/chats').then(r => { if (alive) setChats(r.data || []) }).catch(() => {})
    load(); const t = setInterval(load, 15000)
    return () => { alive = false; clearInterval(t) }
  }, [])
  useEffect(() => {
    setReplyTo(null)
    if (!selChatId) { setChatMessages([]); return }
    let alive = true
    const load = () => api.get('/api/max/chats/' + selChatId + '/messages').then(r => { if (alive) setChatMessages(r.data || []) }).catch(() => {})
    load(); const t = setInterval(load, 10000)
    return () => { alive = false; clearInterval(t) }
  }, [selChatId])
  const chatsUnread = chats.reduce((n, c) => n + (c.unread || 0), 0)

  // «Мои клиенты» — реальные данные из МК платформы (routes/platform.js мост).
  // 15.07: раньше грузили ВЕСЬ список клиентов (до 500 сразу) — Антон попросил
  // убрать, база растёт, список станет только тяжелее. Теперь ищем ТОЛЬКО по
  // телефону, грузим одного конкретного клиента — тот же приём (/lookup),
  // что уже используем в «Новый клиент» для проверки дублей.
  const [clientPhone, setClientPhone] = useState(() => {
    try { return new URLSearchParams(window.location.search).get('phone') || '' } catch (e) { return '' }
  })
  const [clientSearchStatus, setClientSearchStatus] = useState(null) // null | 'searching' | 'not_found' | 'found'
  // Удаление абонемента: МК при удалении возвращает стоимость на баланс ученика
  const [delSubBusy, setDelSubBusy] = useState(null)
  const delSubscription = async (sub) => {
    const money = sub.price ? ` ${sub.price} ₽` : ''
    if (!window.confirm(`Удалить абонемент «${sub.subject}»?\n\nДеньги${money} вернутся на баланс ученика.`)) return
    setDelSubBusy(sub.id)
    try {
      const { data } = await api.delete(`/api/platform/support-clients/${selClientId}/subscriptions/${sub.id}`)
      if (!data.ok) throw new Error(data.error || 'не удалось')
      const r = await api.get('/api/platform/support-clients/' + selClientId)
      setClientDetail(r.data)
      alert(`Абонемент удалён. На баланс вернулось ${data.refunded ?? sub.price ?? 0} ₽`)
    } catch (e) {
      alert('Не удалось удалить абонемент: ' + (e.response?.data?.error || e.message))
    } finally {
      setDelSubBusy(null)
    }
  }

  const [selClientId, setSelClientId] = useState(() => {
    try { const v = new URLSearchParams(window.location.search).get('client'); return v ? Number(v) : null } catch (e) { return null }
  })
  const [searchResults, setSearchResults] = useState([])
  const [clientDetail, setClientDetail] = useState(null)
  const [clientTab, setClientTab] = useState('lessons')
  const [clientPayments, setClientPayments] = useState(null)
  const [clientPaymentsLoading, setClientPaymentsLoading] = useState(false)
  const [clientVisits, setClientVisits] = useState(null)
  const [clientVisitsLoading, setClientVisitsLoading] = useState(false)
  const [clientHomework, setClientHomework] = useState(null)
  const [clientHomeworkLoading, setClientHomeworkLoading] = useState(false)
  const [payVisit, setPayVisit] = useState(null)
  const [payingVisit, setPayingVisit] = useState(null)
  const [clientTasks, setClientTasks] = useState(null)
  const [clientTasksLoading, setClientTasksLoading] = useState(false)
  const [cardComments, setCardComments] = useState(null)
  const [addCommentOpen, setAddCommentOpen] = useState(false)
  const [newComment, setNewComment] = useState('')
  const [commentSaving, setCommentSaving] = useState(false)
  const [addTaskOpen, setAddTaskOpen] = useState(false)
  const [newTaskText, setNewTaskText] = useState('')
  const [newTaskDate, setNewTaskDate] = useState('')
  const [newTaskTime, setNewTaskTime] = useState('')
  const [myTasks, setMyTasks] = useState(null)
  const [editModal, setEditModal] = useState(null)
  const [refuseModal, setRefuseModal] = useState(null)
  const [clientDetailLoading, setClientDetailLoading] = useState(false)
  const [histWeek, setHistWeek] = useState(0) // неделя в «Истории уроков» (0=текущая)
  const [upcWeek, setUpcWeek] = useState(0)   // неделя в «Ближайшие уроки» (0=текущая)
  const [liveLesson, setLiveLesson] = useState(null) // live-урок текущего ученика (из signaling)
  const [roomSessions, setRoomSessions] = useState([]) // сессии комнаты ученика (для истории)
  const [rescheduleLesson, setRescheduleLesson] = useState(null) // {lesson_id, ...}
  const [taskReschedule, setTaskReschedule] = useState(null) // «↪ Перезаписать» из задачи: {task, studentId, lesson}
  const [changeTeacherLesson, setChangeTeacherLesson] = useState(null) // пробный: {booking_id, ...}
  const [addLessonsFor, setAddLessonsFor] = useState(null) // {studentId, name} — поставить обычные уроки
  const [paidPickerOpen, setPaidPickerOpen] = useState(false)   // «Записать на платное»: предмет + цена
  const [paidBookModal, setPaidBookModal] = useState(null)      // {subject, price, classNum} → выбор препода
  const [paidSlot, setPaidSlot] = useState(null)                // + препод и слот → «до какой даты»
  const [deleteLesson, setDeleteLesson] = useState(null) // {lesson_id, teacher_mk_id, date, begin_time, subject, teacher}
  const [trialPickerOpen, setTrialPickerOpen] = useState(false)
  const [trialBookModal, setTrialBookModal] = useState(null) // {subject, classNum}
  const [trialBookedMsg, setTrialBookedMsg] = useState(null)

  // «Новый клиент» — человека ещё нет на платформе, анкета 7/7 как у звонильщика
  const [newClientModalOpen, setNewClientModalOpen] = useState(false)
  // Префилл формы нового клиента — приходит с карточки обзвона («Перенести клиента»)
  const [newClientInitial, setNewClientInitial] = useState(null)
  const [newClientPending, setNewClientPending] = useState(null) // {id, subject, classNum, clientLabel}
  const [newClientMsg, setNewClientMsg] = useState(null)
  // Раздел «Репетиторы» (зеркало «Мои клиенты», но по преподавателю)
  const [tutorQuery, setTutorQuery] = useState('')
  const [tutorSearchStatus, setTutorSearchStatus] = useState(null)
  const [tutorResults, setTutorResults] = useState([])
  const [selTutorId, setSelTutorId] = useState(null)
  const [tutorDetail, setTutorDetail] = useState(null)
  const [tutorDetailLoading, setTutorDetailLoading] = useState(false)
  const [tutorTab, setTutorTab] = useState('lessons')
  const [tutorStudents, setTutorStudents] = useState(null)
  const [tutorStudentsLoading, setTutorStudentsLoading] = useState(false)
  const [tutorSlots, setTutorSlots] = useState(null)
  const [tutorSlotsLoading, setTutorSlotsLoading] = useState(false)
  const [tutorSlotsWeek, setTutorSlotsWeek] = useState(0)

  // Поиск учеников списком: частично по телефону/id/имени. Клик по строке
  // проваливается в карточку (setSelClientId). Минимум 2 символа.
  const searchClients = useCallback((q) => {
    const query = String(q || '').trim()
    if (query.length < 2) { setClientSearchStatus(null); setSearchResults([]); return }
    setClientSearchStatus('searching')
    api.get('/api/platform/support-clients/search', { params: { q: query } })
      .then(r => {
        const list = (r.data && r.data.results) || []
        setSearchResults(list)
        setClientSearchStatus(list.length ? 'found' : 'not_found')
      })
      .catch(() => { setSearchResults([]); setClientSearchStatus('not_found') })
  }, [])

  useEffect(() => {
    const t = setTimeout(() => searchClients(clientPhone), 300)
    return () => clearTimeout(t)
  }, [clientPhone, searchClients])

  // Держим вкладку и телефон в адресной строке, чтобы F5 не выкидывал из карточки
  // клиента на вкладку «Задачи». replaceState — без записи в историю (кнопка
  // «назад» не засоряется). Телефон пишем только когда он полный (>=10 цифр).
  useEffect(() => {
    try {
      const p = new URLSearchParams()
      if (view && view !== 'tasks') p.set('view', view)
      if (String(clientPhone || '').trim().length >= 2) p.set('phone', clientPhone)
      if (selClientId) p.set('client', String(selClientId))
      const qs = p.toString()
      window.history.replaceState(null, '', qs ? '?' + qs : window.location.pathname)
    } catch (e) { /* URL недоступен — не критично */ }
  }, [view, clientPhone, selClientId])

  const reloadClientDetail = useCallback(() => {
    if (!selClientId) return
    api.get('/api/platform/support-clients/' + selClientId)
      .then(r => setClientDetail(r.data))
      .catch(() => {})
  }, [selClientId])

  // Вернуть клиента в статус «Учится» (клик по красному бейджу «Отказ»).
  const handleStudying = useCallback(() => {
    if (!clientDetail) return
    if (!window.confirm('Вернуть клиента в статус «Учится»?')) return
    api.post('/api/platform/support-clients/' + clientDetail.id + '/studying', {})
      .then(() => reloadClientDetail())
      .catch(() => alert('Не удалось изменить статус'))
  }, [clientDetail, reloadClientDetail])

  const handleBookTrial = async (params) => {
    try {
      const { data } = await api.post(`/api/platform/support-clients/${selClientId}/book-trial`, {
        teacherMkId: params.teacherMkId,
        teacherName: params.teacherName,
        subject: params.subject,
        grade: trialBookModal?.classNum,
        level: params.level,          // явный ОГЭ/ЕГЭ — fallback, если класс не заполнен
        date: params.date,
        time: params.time,
        comment: params.comment || '',
        freeTrial: params.freeTrial === true,
      })
      setTrialBookModal(null)
      // 09.09.2026: SMS с кодом при записи менеджером больше не уходит — вместо неё кнопка
      // «Отправить SMS со ссылкой» рядом с сообщением (см. SmsLinkRow в LessonBookingBlock).
      setTrialBookedMsg({
        text: `Записан на пробный — ${params.subject}, ${params.date} ${params.time}, препод ${params.teacherName || '—'}`,
        bookingId: (data.booking && data.booking.id) || null,
        phone: (clientDetail && clientDetail.phone) || null,
      })
      reloadClientDetail()
    } catch (e) {
      alert('Не удалось записать:\n' + (e.response?.data?.error || e.message || 'unknown'))
    }
  }

  // «Записать на платное»: платный урок (не пробный) на выбранную сумму, группу и
  // преподавателя — независимо от того, Лидер он или нет. Платформа сама фиксирует
  // цену в карточке ученика и по этому преподавателю (book-paid).
  // Шаг 3: слот выбран, менеджер назвал дату окончания — ставим серию платных
  // уроков в этот день недели. Ошибку показываем в самом окне, оно не закрывается.
  const handleCreatePaid = async (until) => {
    if (!paidSlot) return
    const subject = paidSlot.subject
    const m = String(subject).match(/(ОГЭ|ЕГЭ)/i)
    let data
    try {
      const r = await api.post(`/api/platform/support-clients/${selClientId}/book-paid`, {
        teacherMkId: paidSlot.teacherMkId,
        subject,
        grade: paidSlot.classNum,
        level: m ? m[1].toUpperCase() : null,
        date: paidSlot.date,
        time: paidSlot.time,
        price_rub: paidSlot.price,
        until,
      })
      data = r.data
    } catch (e) {
      throw new Error(e.response?.data?.error || e.message || 'Платформа недоступна')
    }
    if (!data || !data.ok) throw new Error((data && data.error) || 'Платформа отклонила запись')
    const n = data.created || 1
    const word = (n % 10 === 1 && n % 100 !== 11) ? 'урок'
      : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) ? 'урока' : 'уроков'
    setTrialBookedMsg(`Создано ${n} платных ${word} — ${subject}, по ${paidSlot.price} ₽, `
      + `с ${paidSlot.date} ${paidSlot.time}, препод ${paidSlot.teacherName || '—'}`)
    reloadClientDetail()
    // Окно покажет «Выполнено — создано N уроков» и закроется по «Готово».
    return { created: n, skipped: data.skipped || 0 }
  }

  // Телефон из анкеты нового клиента уже есть на платформе — открываем существующего
  // вместо продолжения как «новый» (проверка в NewClientModal, см. /support-clients/lookup)
  const handleOpenExistingFromLookup = (mkId) => {
    setNewClientModalOpen(false)
    setSelClientId(mkId)
  }

  const handleContinueNewClient = (id, values) => {
    setNewClientModalOpen(false)
    setNewClientMsg(null)
    setNewClientPending({
      id,
      subject: values.subject,
      classNum: values.classNum,
      clientLabel: (values.childName || values.parentName || 'Новый клиент') + ' (новый)',
    })
  }

  const handleBookNewClient = async (params) => {
    try {
      const { data } = await api.post(`/api/platform/support-new-clients/${newClientPending.id}/book-trial`, {
        teacherMkId: params.teacherMkId,
        teacherName: params.teacherName,
        subject: params.subject,
        level: params.level,          // явный ОГЭ/ЕГЭ — fallback, если класс не заполнен
        date: params.date,
        time: params.time,
        comment: params.comment || '',
        freeTrial: params.freeTrial === true,
      })
      setNewClientPending(null)
      setNewClientMsg({
        text: `Новый клиент записан на пробный — ${params.subject}, ${params.date} ${params.time}, препод ${params.teacherName || '—'}`,
        bookingId: (data.booking && data.booking.id) || null,
        phone: (newClientPending && newClientPending.phone) || null,
      })
    } catch (e) {
      alert('Не удалось записать:\n' + (e.response?.data?.error || e.message || 'unknown'))
    }
  }

  useEffect(() => {
    if (!selClientId) return
    setClientDetailLoading(true)
    setClientDetail(null)
    setHistWeek(0)
    setUpcWeek(0)
    setCardComments(null)
    setAddCommentOpen(false)
    setClientTab('lessons')
    setClientPayments(null)
    setClientVisits(null)
    setClientHomework(null)
    setClientTasks(null)
    api.get('/api/platform/support-clients/' + selClientId)
      .then(r => setClientDetail(r.data))
      .catch(() => setClientDetail(null))
      .finally(() => setClientDetailLoading(false))
  }, [selClientId])

  // Опрос активных видео-уроков: если ученик сейчас на уроке — показываем «Урок идёт».
  useEffect(() => {
    const roomId = clientDetail && clientDetail.video_room_id
    if (!selClientId || !roomId) { setLiveLesson(null); return }
    let alive = true
    const check = () => {
      api.get('/api/platform/active-lessons').then(r => {
        if (!alive) return
        const list = r.data || []
        const room = list.find(x => x.roomId === roomId)
        setLiveLesson(room || null)
      }).catch(() => {})
    }
    check()
    const t = setInterval(check, 15000)
    return () => { alive = false; clearInterval(t) }
  }, [selClientId, clientDetail && clientDetail.video_room_id])

  // Сессии video-комнаты ученика (кто был и когда) — для «комн. X · учитель —
  // ученик» в истории и текущем уроке.
  useEffect(() => {
    const room = clientDetail && clientDetail.video_room_id
    if (!room) { setRoomSessions([]); return }
    let alive = true
    api.get('/api/platform/room-sessions/' + room)
      .then(r => { if (alive) setRoomSessions(r.data || []) })
      .catch(() => { if (alive) setRoomSessions([]) })
    return () => { alive = false }
  }, [selClientId, clientDetail && clientDetail.video_room_id])

  // Найти сессию комнаты, пересекающуюся со временем урока.
  const sessionForLesson = (l) => {
    if (!(clientDetail && clientDetail.video_room_id) || !l.date || !l.begin_time || !roomSessions.length) return null
    const start = new Date(l.date + 'T' + l.begin_time + ':00+03:00').getTime()
    const end = l.end_time ? new Date(l.date + 'T' + l.end_time + ':00+03:00').getTime() : start + 3600000
    let best = null, bestOv = 0
    for (const x of roomSessions) {
      const xe = x.endMs == null ? Date.now() : x.endMs
      const ov = Math.min(end, xe) - Math.max(start, x.startMs)
      if (ov > bestOv) { bestOv = ov; best = x }
    }
    return bestOv > 0 ? best : null
  }

  // Платежи ученика — грузим при открытии вкладки «Оплаты».
  useEffect(() => {
    if (!selClientId || clientTab !== 'payments' || clientPayments) return
    setClientPaymentsLoading(true)
    api.get('/api/platform/support-clients/' + selClientId + '/payments')
      .then(r => setClientPayments((r.data && r.data.payments) || []))
      .catch(() => setClientPayments([]))
      .finally(() => setClientPaymentsLoading(false))
  }, [selClientId, clientTab, clientPayments])
  useEffect(() => {
    if (!selClientId || clientTab !== 'visits' || clientVisits) return
    setClientVisitsLoading(true)
    api.get('/api/platform/support-clients/' + selClientId + '/visits')
      .then(r => setClientVisits(r.data || { visits: [], subscriptions: [], balance_rub: null }))
      .catch(() => setClientVisits({ visits: [], subscriptions: [], balance_rub: null }))
      .finally(() => setClientVisitsLoading(false))
  }, [selClientId, clientTab, clientVisits])
  // ДЗ ученика — грузим при открытии вкладки «ДЗ».
  useEffect(() => {
    if (!selClientId || clientTab !== 'homework' || clientHomework) return
    setClientHomeworkLoading(true)
    api.get('/api/platform/support-clients/' + selClientId + '/homework')
      .then(r => setClientHomework(r.data || { homeworks: [], summary: {} }))
      .catch(() => setClientHomework({ homeworks: [], summary: {} }))
      .finally(() => setClientHomeworkLoading(false))
  }, [selClientId, clientTab, clientHomework])
  useEffect(() => {
    if (!selClientId || clientTasks) return
    setClientTasksLoading(true)
    api.get('/api/platform/support-clients/' + selClientId + '/tasks')
      .then(r => setClientTasks(r.data || { tasks: [], support: [], own: [] }))
      .catch(() => setClientTasks({ tasks: [], support: [], own: [] }))
      .finally(() => setClientTasksLoading(false))
  }, [selClientId, clientTasks])
  // Комментарии карточки: что уже было с клиентом («звонила 3 раза, недоступен»).
  // Пишет один сопроводитель — видят все. Чужой не удалить, свой — час.
  useEffect(() => {
    if (!selClientId || cardComments) return
    api.get('/api/platform/support-clients/' + selClientId + '/comments')
      .then(r => setCardComments((r.data && r.data.comments) || []))
      .catch(() => setCardComments([]))
  }, [selClientId, cardComments])

  const addComment = () => {
    const text = String(newComment || '').trim()
    if (!selClientId || !text || commentSaving) return
    setCommentSaving(true)
    api.post('/api/platform/support-clients/' + selClientId + '/comments', { text })
      .then(() => { setNewComment(''); setAddCommentOpen(false); setCardComments(null) })
      .catch(() => {})
      .then(() => setCommentSaving(false))
  }

  const deleteComment = (id) => {
    if (!selClientId) return
    api.post('/api/platform/support-clients/' + selClientId + '/comments/' + id + '/delete')
      .then(() => setCardComments(null))
      .catch(() => {})
  }

  const addOwnTask = () => {
    const text = String(newTaskText || '').trim()
    if (!selClientId || !text) return
    // Дата + (опц.) время → 'YYYY-MM-DD HH:MM'. За 1 час до этого времени задача
    // упадёт в очередь. Без времени — только дата (падает в очередь с полуночи).
    const due = newTaskDate ? (newTaskTime ? newTaskDate + ' ' + newTaskTime : newTaskDate) : null
    api.post('/api/platform/support-clients/' + selClientId + '/own-tasks', { text, dueDate: due, clientName: (clientDetail && clientDetail.name) || null })
      .then(() => { setNewTaskText(''); setNewTaskDate(''); setNewTaskTime(''); setAddTaskOpen(false); setClientTasks(null); setMyTasks(null) })
      .catch(() => {})
  }
  const setCardTaskStatus = (source, key, status) => {
    if (!selClientId) return
    api.post('/api/platform/support-clients/' + selClientId + '/task-status', { source, key: String(key), status })
      .then(() => { setClientTasks(null); setMyTasks(null) })
      .catch(() => {})
  }
  const setMyTaskStatus = (mkUserId, id, status) => {
    api.post('/api/platform/support-clients/' + mkUserId + '/task-status', { source: 'own', key: String(id), status })
      .then(() => { setMyTasks(null); if (Number(selClientId) === Number(mkUserId)) setClientTasks(null) })
      .catch(() => {})
  }
  useEffect(() => {
    if (myTasks) return
    api.get('/api/platform/my-own-tasks')
      .then(r => setMyTasks((r.data && r.data.tasks) || []))
      .catch(() => setMyTasks([]))
  }, [myTasks])

  // ── Раздел «Репетиторы» ─────────────────────────────────────────────
  const searchTutors = useCallback((q) => {
    const query = String(q || '').trim()
    if (query.length < 2) { setTutorSearchStatus(null); setTutorResults([]); return }
    setTutorSearchStatus('searching')
    api.get('/api/platform/support-tutors/search', { params: { q: query } })
      .then(r => {
        const list = (r.data && r.data.results) || []
        setTutorResults(list)
        setTutorSearchStatus(list.length ? 'found' : 'not_found')
      })
      .catch(() => { setTutorResults([]); setTutorSearchStatus('not_found') })
  }, [])

  useEffect(() => {
    const t = setTimeout(() => searchTutors(tutorQuery), 300)
    return () => clearTimeout(t)
  }, [tutorQuery, searchTutors])

  useEffect(() => {
    if (!selTutorId) { setTutorDetail(null); return }
    setTutorDetailLoading(true); setTutorDetail(null); setTutorTab('lessons'); setTutorStudents(null); setTutorSlots(null); setTutorSlotsWeek(0)
    api.get('/api/platform/support-tutors/' + selTutorId)
      .then(r => setTutorDetail(r.data))
      .catch(() => setTutorDetail(null))
      .finally(() => setTutorDetailLoading(false))
  }, [selTutorId])

  useEffect(() => {
    if (!selTutorId || tutorTab !== 'students' || tutorStudents) return
    setTutorStudentsLoading(true)
    api.get('/api/platform/support-tutors/' + selTutorId + '/students')
      .then(r => setTutorStudents((r.data && r.data.students) || []))
      .catch(() => setTutorStudents([]))
      .finally(() => setTutorStudentsLoading(false))
  }, [selTutorId, tutorTab, tutorStudents])

  // Слоты репетитора на выбранную неделю (перезагружаем при листании недель).
  useEffect(() => {
    if (!selTutorId || tutorTab !== 'slots') return
    setTutorSlotsLoading(true)
    api.get('/api/platform/support-tutors/' + selTutorId + '/slots', { params: { week: tutorSlotsWeek } })
      .then(r => setTutorSlots(r.data))
      .catch(() => setTutorSlots(null))
      .finally(() => setTutorSlotsLoading(false))
  }, [selTutorId, tutorTab, tutorSlotsWeek])

  // «Пробные уроки» — реальные данные из bookings/tutor_offers платформы.
  const [trials, setTrials] = useState([])
  const [trialCounts, setTrialCounts] = useState({ today: 0, tomorrow: 0, week: 0 })
  const [trialsLoading, setTrialsLoading] = useState(false)
  const [trialsLoaded, setTrialsLoaded] = useState(false)
  const [trialPeriod, setTrialPeriod] = useState('today') // 'yesterday' | 'today' | 'tomorrow' | 'week'
  const [trialModal, setTrialModal] = useState(null) // { type: 'client'|'task', item }

  useEffect(() => {
    if (view !== 'trials' || trialsLoaded) return
    setTrialsLoading(true)
    api.get('/api/platform/support-trials', { params: { days: 1 } }) // +1 день назад — вкладка «Вчера»
      .then(r => {
        setTrials((r.data && r.data.items) || [])
        setTrialCounts((r.data && r.data.counts) || { today: 0, tomorrow: 0, week: 0 })
      })
      .catch(() => setTrials([]))
      .finally(() => { setTrialsLoading(false); setTrialsLoaded(true) })
  }, [view, trialsLoaded])

  // «⚠️ Расхождения» — баланс платформы (верно) vs МойКласс (может отставать).
  const [discrepancies, setDiscrepancies] = useState([])
  const [discLoading, setDiscLoading] = useState(false)
  const [discLoaded, setDiscLoaded] = useState(false)
  const [discBadge, setDiscBadge] = useState(null)
  const [discResolving, setDiscResolving] = useState(null)

  // Счётчик для красного бейджа в шапке — грузим один раз при заходе в кабинет,
  // не дожидаясь открытия самой вкладки.
  useEffect(() => {
    api.get('/api/platform/balance-discrepancies')
      .then(r => setDiscBadge((r.data && r.data.open_count) || 0))
      .catch(() => {})
  }, [])

  useEffect(() => {
    if (view !== 'discrepancies' || discLoaded) return
    setDiscLoading(true)
    api.get('/api/platform/balance-discrepancies')
      .then(r => {
        setDiscrepancies((r.data && r.data.items) || [])
        setDiscBadge((r.data && r.data.open_count) || 0)
      })
      .catch(() => setDiscrepancies([]))
      .finally(() => { setDiscLoading(false); setDiscLoaded(true) })
  }, [view, discLoaded])

  function resolveDiscrepancy(item) {
    setDiscResolving(item.mk_user_id)
    api.post('/api/platform/balance-discrepancies/' + item.mk_user_id + '/resolve', { diff: item.diff })
      .then(() => {
        setDiscrepancies(prev => prev.map(d => d.mk_user_id === item.mk_user_id ? { ...d, resolved: true } : d))
        setDiscBadge(prev => Math.max(0, (prev || 0) - 1))
      })
      .catch(() => {})
      .finally(() => setDiscResolving(null))
  }

  // «Объединить дубли» — кнопка у имени клиента. Ищем вторую карточку,
  // показываем, что произойдёт, и объединяем: деньги переносим сами, слияние
  // делает МойКласс (он свободный баланс при слиянии теряет — проверено 08.09).
  const [mergeOpen, setMergeOpen] = useState(false)
  const [mergeQuery, setMergeQuery] = useState('')
  const [mergeFound, setMergeFound] = useState([])
  const [mergePick, setMergePick] = useState(null)
  const [mergePreview, setMergePreview] = useState(null)
  const [mergeBusy, setMergeBusy] = useState(false)
  const [mergeError, setMergeError] = useState('')
  const [mergeDone, setMergeDone] = useState(null)

  function openMerge() {
    setMergeOpen(true); setMergeQuery(''); setMergeFound([]); setMergePick(null)
    setMergePreview(null); setMergeError(''); setMergeDone(null)
  }
  function searchMergeCandidates() {
    if (mergeQuery.trim().length < 3) return
    setMergeBusy(true); setMergeError('')
    api.get('/api/platform/clients/search', { params: { q: mergeQuery.trim(), exclude: selClientId, _: Date.now() } })
      .then(r => setMergeFound(r.data?.items || []))
      .catch(e => setMergeError(e.response?.data?.error || 'Поиск не удался'))
      .finally(() => setMergeBusy(false))
  }
  function pickMergeCandidate(c) {
    setMergePick(c); setMergePreview(null); setMergeError(''); setMergeBusy(true)
    api.get('/api/platform/clients/merge-preview', { params: { primary: selClientId, duplicate: c.mk_id } })
      .then(r => setMergePreview(r.data))
      .catch(e => setMergeError(e.response?.data?.error || 'Не удалось получить сводку'))
      .finally(() => setMergeBusy(false))
  }
  function runMerge() {
    if (!mergePick) return
    setMergeBusy(true); setMergeError('')
    api.post('/api/platform/clients/merge', {
      primary: selClientId, duplicate: mergePick.mk_id,
      primary_name: (clientDetail && clientDetail.name) || null,
    })
      .then(r => { setMergeDone(r.data); setClientDetail(null) })
      .catch(e => setMergeError(e.response?.data?.error || 'Объединение не удалось'))
      .finally(() => setMergeBusy(false))
  }

  // «🔁 Перенос клиента» — ищем человека в НАШЕЙ копии выгрузки старого МК
  // (мгновенно, без запросов в сам МК) и заводим карточку у нас.
  const [migPhone, setMigPhone] = useState('')
  const [migLoading, setMigLoading] = useState(false)
  const [migError, setMigError] = useState('')
  const [migFound, setMigFound] = useState(null)
  const [migRunning, setMigRunning] = useState(false)
  const [migResult, setMigResult] = useState(null)

  function searchMigration() {
    const phone = migPhone.trim()
    if (!phone) return
    setMigLoading(true); setMigError(''); setMigFound(null); setMigResult(null)
    api.get('/api/platform/old-mk/search', { params: { phone } })
      .then(r => {
        if (!r.data || !r.data.found) { setMigError('В старом МК такого телефона нет'); return }
        setMigFound(r.data)
      })
      .catch(e => setMigError(e.response?.data?.error || 'Не удалось выполнить поиск'))
      .finally(() => setMigLoading(false))
  }
  function runMigration() {
    if (!migFound) return
    setMigRunning(true); setMigError('')
    api.post('/api/platform/old-mk/create', { phone: migPhone.trim() })
      .then(r => {
        setMigResult(r.data)
        // Карточка заведена — сразу открываем её, дальше сопроводитель работает
        // с обычным клиентом (чаты к нему уже привязаны при создании).
        if (r.data && r.data.mk_id) {
          setSelChatId(null)
          setSelClientId(Number(r.data.mk_id))
          setClientDetail(null)
          setView('clients')
        }
      })
      .catch(e => setMigError(e.response?.data?.error || 'Не удалось создать карточку'))
      .finally(() => setMigRunning(false))
  }
  function resetMigration() {
    setMigPhone(''); setMigFound(null); setMigResult(null); setMigError('')
  }

  const todayIso = new Date().toISOString().slice(0, 10)
  const yesterdayIso = new Date(Date.now() - 86400000).toISOString().slice(0, 10)
  const tomorrowIso = new Date(Date.now() + 86400000).toISOString().slice(0, 10)
  const filteredTrials = trials.filter(t => {
    if (trialPeriod === 'yesterday') return t.date === yesterdayIso
    if (trialPeriod === 'today') return t.date === todayIso
    if (trialPeriod === 'tomorrow') return t.date === tomorrowIso
    return t.date !== yesterdayIso // week — 7 дней вперёд, вчера сюда не мешаем
  })
  const trialsByDay = {}
  filteredTrials.forEach(t => { (trialsByDay[t.date] = trialsByDay[t.date] || []).push(t) })
  const trialDayLabel = iso => {
    if (iso === todayIso) return 'Сегодня'
    if (iso === yesterdayIso) return 'Вчера'
    if (iso === tomorrowIso) return 'Завтра'
    const [y, m, d] = iso.split('-')
    return d + '.' + m
  }
  const yesterdayCount = trials.filter(t => t.date === yesterdayIso).length
  const yesterdayNeedsFollowup = trials.filter(t => t.date === yesterdayIso && t.needsFollowup).length
  const TRIAL_STATUS = {
    new: ['new', 'Новая запись'],
    planned: ['planned', 'Запланирован'],
    confirmed: ['confirmed', 'Подтверждён'],
    done: ['done', 'Проведён'],
    noshow: ['noshow', 'Не пришёл'],
  }

  function fmtBalance(rub) {
    const n = Number(rub) || 0
    const cls = n > 0 ? 'ok' : n < 0 ? 'bad' : 'zero'
    return { cls, text: n.toLocaleString('ru-RU') + ' ₽' }
  }
  function fmtLessonDate(iso, time) {
    if (!iso) return ''
    const [, m, d] = iso.split('-')
    return d + '.' + m + (time ? ' · ' + time : '')
  }
  // Дата + диапазон времени (10:00–10:55) и днём недели полностью снизу — для карточки клиента.
  function fmtLessonWhen(l) {
    if (!l || !l.date) return ''
    const [y, m, d] = l.date.split('-')
    const WD = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота']
    const wd = WD[new Date(Number(y), Number(m) - 1, Number(d)).getDay()]
    const time = l.begin_time ? (l.begin_time + (l.end_time ? '–' + l.end_time : '')) : ''
    return (
      <>
        <div>{d + '.' + m}{time ? ' · ' + time : ''}</div>
        <div style={{ fontWeight: 400, fontSize: 11, color: '#94a3b8', textTransform: 'capitalize' }}>{wd}</div>
      </>
    )
  }
  const STATUS_LABEL = { success: ['done', 'Проведён'], planned: ['planned', 'Запланирован'], missed: ['skip', 'Пропущен'] }

  // Срочная задача «вопрос в чате»: алерт-плашка + звук. seenIdsRef=null до первого ответа сервера.
  const [urgent, setUrgent] = useState(null)
  const seenIdsRef = useRef(null)
  const urgentRef = useRef(null)
  urgentRef.current = urgent

  const toggleOwnCheck = (task, key, value) => {
    if (!task || !task.meta) return
    api.post('/api/platform/support-clients/' + task.meta.mkUserId + '/own-tasks/' + task.meta.ownTaskId + '/check', { key, value })
      .then(() => loadTasks())
      .catch(e => alert('Не удалось сохранить: ' + ((e.response && e.response.data && e.response.data.error) || e.message)))
  }
  const loadTasks = useCallback(() => {
    if (isWriter || isTutors) return Promise.resolve([])   // у переписчика нет очереди задач сопровождения
    return api.get('/api/support-tasks')
      .then(r => {
        const list = Array.isArray(r.data) ? r.data : []
        // 06.10: держим ту же задачу по id (раньше карточка слетала на другую посреди звонка, окно «Перенести звонок» закрывалось)
        const keepId = selIdRef.current
        setTasks(list)
        if (keepId != null) { const ix = list.findIndex(t => t.id === keepId); if (ix >= 0) setSel(ix) }

        const seen = seenIdsRef.current
        if (seen === null) {
          // Первая загрузка: не сигналим по старым задачам, НО если висит непринятая
          // срочная (перезагрузка страницы / вышел на смену) — показываем алерт.
          seenIdsRef.current = new Set(list.flatMap(t => isPhoneLeft(t) ? [t.id, t.id + ':' + t.meta.phoneLeftAt] : [t.id]))
          const pending = list.find(t => t.type === 'chat' && t.assignedTo == null)
          if (pending) {
            setUrgent(pending); playUrgentBeep()
            // Срочная не ждёт в очереди — карточка открывается сама
            setSel(Math.max(0, list.findIndex(t => t.id === pending.id)))
          }
        } else {
          const fresh = list.find(t => t.type === 'chat' && (!seen.has(t.id) || (isPhoneLeft(t) && !seen.has(t.id + ':' + t.meta.phoneLeftAt))))
          list.forEach(t => { seen.add(t.id); if (isPhoneLeft(t)) seen.add(t.id + ':' + t.meta.phoneLeftAt) })
          if (fresh) {
            setUrgent(fresh); playUrgentBeep()
            // Срочная не ждёт в очереди — карточка открывается сама
            setSel(Math.max(0, list.findIndex(t => t.id === fresh.id)))
          }
          // Задачу забрал другой менеджер — она пропала из списка, убираем алерт.
          const u = urgentRef.current
          if (u && !list.some(t => t.id === u.id)) setUrgent(null)
        }
        return list
      })
      .catch(() => null)
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    api.get('/api/shift').then(r => { setOnShift(!!r.data.on); setShiftSince(r.data.since) }).catch(() => {})
    loadTasks()
    // 4 сек вместо 20: срочная задача из чата должна всплыть почти мгновенно
    const iv = setInterval(loadTasks, 4000)
    return () => clearInterval(iv)
  }, [loadTasks])

  // ─── Обзвон старой базы: лид из support-пачки, когда очередь задач пуста ───
  const [coldDeal, setColdDeal] = useState(null)
  const [coldBook, setColdBook] = useState(null)   // {subject, classNum} из анкеты — для окна записи
  const loadColdDeal = useCallback(() => {
    api.get('/api/deals').then(r => setColdDeal((Array.isArray(r.data) && r.data[0]) || null)).catch(() => setColdDeal(null))
  }, [])
  // Поллинг, а не разовый вызов (Антон 13.08, восстановлено 20.09 — коммит 018655d от 14.08
  // случайно вернул старую версию блока): созревший перезвон и новая порция базы появляются
  // на сервере в любой момент, а не только когда список задач становится пустым. Раньше
  // карточка запрашивалась ОДИН РАЗ при переходе tasks.length→0 — если контактов в тот
  // момент ещё не было, сопроводитель видел «Задач нет» до F5. ColdCallCard сбрасывает
  // форму только по deal.id, так что повторный запрос того же лида ввод не стирает.
  useEffect(() => {
    if (view === 'tasks' && onShift && !loading && tasks.length === 0) {
      loadColdDeal()
      const iv = setInterval(loadColdDeal, 15000)
      return () => clearInterval(iv)
    }
  }, [view, onShift, loading, tasks.length, loadColdDeal])
  const handleColdBook = async (payload) => {
    if (!coldDeal) return
    try {
      const r = await api.post('/api/platform/book', { leadId: coldDeal.id, ...payload })
      if (!r.data || r.data.ok === false) { alert((r.data && r.data.error) || 'Не удалось записать'); return }
      setColdBook(null)
      loadColdDeal()
    } catch (e) { alert((e.response && e.response.data && e.response.data.error) || 'Платформа недоступна') }
  }

  // Пока висит алерт — мигаем заголовком вкладки (видно даже из другой вкладки)
  useEffect(() => {
    if (!urgent) return
    const orig = document.title
    let flip = false
    const iv = setInterval(() => { flip = !flip; document.title = flip ? '🆘 СРОЧНАЯ ЗАДАЧА' : orig }, 900)
    return () => { clearInterval(iv); document.title = orig }
  }, [urgent])

  const claimUrgent = () => {
    if (!urgent) return
    const id = urgent.id
    api.post('/api/support-tasks/' + id + '/claim')
      .then(() => {
        setUrgent(null)
        return loadTasks().then(list => {
          if (!list) return
          const idx = list.findIndex(t => t.id === id)
          if (idx >= 0) setSel(idx)
        })
      })
      .catch(e => {
        setUrgent(null)
        if (e?.response?.status === 409) alert('Задачу уже взял другой менеджер.')
        loadTasks()
      })
  }

  const toggleShift = () => {
    if (shiftBusy) return
    const next = !onShift
    setShiftBusy(true)
    setOnShift(next)
    setShiftSince(next ? new Date().toISOString() : null)
    api.post('/api/shift', { on: next })
      .then(r => { setOnShift(!!r.data.on); setShiftSince(r.data.since); loadTasks() })
      .catch(() => { setOnShift(!next); alert('Не удалось изменить статус смены — обновите страницу и попробуйте снова.') })
      .finally(() => setShiftBusy(false))
  }

  // «↪ Перезаписать» из задачи «Первый урок: не подтвердил» (Антон 25.08): открываем то же
  // окно переноса, что и 📅 в карточке клиента, для урока из задачи; после успешного
  // переноса задача закрывается сама с итогом «перезаписал».
  const openTaskReschedule = (task) => {
    const uid = task.meta && task.meta.mkUserId, lid = task.meta && task.meta.lessonId
    if (!uid || !lid) { alert('В задаче нет данных об уроке — откройте карточку клиента и перенесите там.'); return }
    api.get('/api/platform/support-clients/' + uid)
      .then(r => {
        const l = (r.data.lessons || []).find(x => String(x.lesson_id) === String(lid))
        if (!l || (l.is_trial && !l.booking_id)) { alert('Урок не найден в карточке клиента — перенесите из карточки.'); return }
        setTaskReschedule({ task, studentId: uid, lesson: l })
      })
      .catch(() => alert('Платформа недоступна — попробуйте из карточки клиента.'))
  }

  const resolve = (task, outcome) => {
    // Своя задача из карточки (own_task) не живёт в JSON-очереди — закрываем её
    // через own task-status, чтобы пропала и из очереди, и из «Мои задачи».
    if (task.type === 'own_task' && task.meta && task.meta.ownTaskId) {
      api.post('/api/platform/support-clients/' + task.meta.mkUserId + '/task-status', { source: 'own', key: task.meta.ownTaskId, status: 'done' })
        .then(() => { setDone(d => d + 1); setSel(0); loadTasks() })
        .catch(() => alert('Не удалось закрыть задачу — обновите страницу.'))
      return
    }
    api.post('/api/support-tasks/' + task.id + '/resolve', { outcome })
      .then(() => { setDone(d => d + 1); setSel(0); loadTasks() })
      .catch(e => alert((e.response && [409, 502].includes(e.response.status) && e.response.data && e.response.data.error) || 'Не удалось закрыть задачу — обновите страницу.'))
  }

  // «Мама попросила перезвонить завтра до обеда» — переносим звонок на дату/время,
  // задача НЕ закрывается, просто уходит из очереди до срока (Антон 2026-07-20).
  const [snoozeOpen, setSnoozeOpen] = useState(false)
  // 06.10 «Допродать предмет»: «Взял новый предмет» → открываем клиента (selClientId) и показываем те же кнопки записи, что в «Мои клиенты»;
  // как только запись создана (trialBookedMsg) — задача закрывается сама.
  const [upsellBook, setUpsellBook] = useState(null)   // задача, по которой идёт запись
  const [upsellNo, setUpsellNo] = useState(null)       // { task, text } — «Не нужно» с причиной
  const startUpsellBook = (task) => { setTrialBookedMsg(null); setSelClientId(task.meta && task.meta.mkUserId); setUpsellBook(task) }
  useEffect(() => { setUpsellBook(null); setUpsellNo(null) }, [sel])
  useEffect(() => {
    if (!upsellBook || !trialBookedMsg) return
    const t = upsellBook, m = typeof trialBookedMsg === 'string' ? trialBookedMsg : (trialBookedMsg.text || '')
    setUpsellBook(null)
    resolve(t, 'взял новый предмет: ' + String(m).slice(0, 160))
  }, [trialBookedMsg])
  useEffect(() => { setSnoozeOpen(false) }, [sel])
  const snooze = (task, date, time, note) => {
    api.post('/api/support-tasks/' + task.id + '/snooze', { date, time, note })
      .then(() => { setSnoozeOpen(false); setSel(0); loadTasks() })
      .catch(() => alert('Не удалось перенести звонок — обновите страницу.'))
  }

  // Переписка для задачи «вопрос в чате»: тянем при открытой карточке, обновляем каждые 5с
  const curTask = tasks[sel] || tasks[0] || null
  const chatTaskId = curTask && curTask.type === 'chat' ? curTask.id : null
  const [chat, setChat] = useState(null)      // { messages: [...] } | null
  const [chatErr, setChatErr] = useState(false)
  const chatEndRef = useRef(null)

  const [chatText, setChatText] = useState('')
  const [chatSending, setChatSending] = useState(false)

  const loadChat = useCallback(() => {
    if (!chatTaskId) return Promise.resolve()
    return api.get('/api/support-tasks/' + chatTaskId + '/chat')
      .then(r => { setChat(r.data); setChatErr(false) })
      .catch(() => setChatErr(true))
  }, [chatTaskId])

  useEffect(() => {
    setChat(null); setChatErr(false); setChatText('')
    if (!chatTaskId) return
    loadChat()
    const iv = setInterval(loadChat, 5000)
    return () => clearInterval(iv)
  }, [chatTaskId, loadChat])

  const sendSupportMsg = () => {
    const text = chatText.trim()
    if (!text || chatSending || !chatTaskId) return
    setChatSending(true)
    api.post('/api/support-tasks/' + chatTaskId + '/chat/message', { text })
      .then(() => { setChatText(''); return loadChat() })
      .catch(() => alert('Не удалось отправить — попробуйте ещё раз.'))
      .finally(() => setChatSending(false))
  }

  // Автопрокрутка ленты вниз при новых сообщениях
  useEffect(() => {
    if (chatEndRef.current) chatEndRef.current.scrollIntoView({ block: 'nearest' })
  }, [chat])

  const shiftSub = onShift
    ? 'на смене' + (shiftSince ? ' с ' + new Date(shiftSince).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }) : '')
    : 'смена не начата'

  const cur = tasks[sel] || tasks[0] || null
  selIdRef.current = cur ? cur.id : null

  // 07.10 «Увод общения мимо платформы»: чат преподавателя с администратором прямо в карточке.
  // «Связался с преподавателем» доступна, только когда сопроводитель написал после появления задачи (проверяет и бэк).
  const [cvMsgs, setCvMsgs] = useState([])
  const [cvText, setCvText] = useState('')
  const [cvSending, setCvSending] = useState(false)
  const cvMk = cur && cur.type === 'contact_violation' && cur.meta ? cur.meta.teacherMkId : null
  const loadCv = () => { if (!cvMk) return; api.get('/api/platform/admin-chat/teacher/' + cvMk).then(r => { if (r.data && r.data.ok) setCvMsgs(r.data.messages || []) }).catch(() => {}) }
  useEffect(() => {
    setCvMsgs([]); setCvText('')
    if (!cvMk) return
    loadCv()
    const iv = setInterval(loadCv, 15000)
    return () => clearInterval(iv)
  }, [cvMk, cur && cur.id])
  const cvWrote = !!(cur && cur.createdAt && cvMsgs.some(m => m.from_side === 'admin' && new Date(String(m.created_at || '').replace(' ', 'T') + 'Z') >= new Date(cur.createdAt)))
  const cvLocked = (o) => !!(o && o.needWrote && cur && cur.type === 'contact_violation' && !cvWrote)
  const sendCv = () => {
    const text = cvText.trim()
    if (!text || !cvMk || cvSending) return
    setCvSending(true)
    api.post('/api/platform/admin-chat/teacher/' + cvMk, { text })
      .then(r => { if (r.data && r.data.ok) { setCvText(''); loadCv() } else alert((r.data && r.data.error) || 'Не отправилось') })
      .catch(e => alert((e.response && e.response.data && e.response.data.error) || 'Платформа недоступна'))
      .finally(() => setCvSending(false))
  }
  const cvRestore = (task) => {
    if (!window.confirm('Вернуть препода на сайт? Счётчик попыток обнулится.')) return
    api.post('/api/platform/teachers/' + task.meta.teacherMkId + '/deactivation/restore')
      .then(r => { if (!(r.data && r.data.ok)) throw new Error((r.data && r.data.error) || 'Не удалось вернуть'); resolve(task, 'вернул на сайт') })
      .catch(e => alert((e.response && e.response.data && e.response.data.error) || e.message || 'Платформа недоступна'))
  }

  // Ответ сопроводителя клиенту в MAX.
  const sendMaxReply = () => {
    const text = maxReply.trim()
    if (!text || !selChatId || maxSending) return
    setMaxSending(true)
    api.post('/api/max/chats/' + selChatId + '/send', { text, replyToMid: replyTo ? replyTo.mid : undefined, replyText: replyTo ? replyTo.text : undefined })
      .then(() => { setMaxReply(''); setReplyTo(null); return api.get('/api/max/chats/' + selChatId + '/messages').then(r => setChatMessages(r.data || [])) })
      .catch(() => alert('Не удалось отправить сообщение — попробуйте ещё раз.'))
      .finally(() => setMaxSending(false))
  }

  // Отправка файла клиенту в MAX (бэк заливает файл в MAX и шлёт вложением).
  const sendMaxFile = (file) => {
    if (!file || !selChatId || maxSending) return
    const fd = new FormData()
    fd.append('file', file)
    if (maxReply.trim()) fd.append('text', maxReply.trim())
    setMaxSending(true)
    api.post('/api/max/chats/' + selChatId + '/send-file', fd)
      .then(() => { setMaxReply(''); setReplyTo(null); return api.get('/api/max/chats/' + selChatId + '/messages').then(r => setChatMessages(r.data || [])) })
      .catch(e => alert('Не удалось отправить файл: ' + ((e.response && e.response.data && e.response.data.error) || e.message)))
      .finally(() => setMaxSending(false))
  }

  // «Ответ не требуется»: пометить чат прочитанным + зафиксировать кто, клиенту ничего не шлём.
  const markNoReply = () => {
    if (!selChatId || maxSending) return
    setMaxSending(true)
    api.post('/api/max/chats/' + selChatId + '/no-reply')
      .then(() => Promise.all([
        api.get('/api/max/chats/' + selChatId + '/messages').then(r => setChatMessages(r.data || [])),
        api.get('/api/max/chats').then(r => setChats(r.data || [])),
      ]))
      .catch(() => alert('Не удалось отметить — попробуйте ещё раз.'))
      .finally(() => setMaxSending(false))
  }

  // Удалить своё исходящее: отзывается у клиента, у нас остаётся «призраком».
  const deleteMaxMsg = (id) => {
    if (!window.confirm('Удалить это сообщение? Оно будет отозвано у клиента и останется здесь как «удалено».')) return
    api.delete('/api/max/messages/' + id)
      .then(() => api.get('/api/max/chats/' + selChatId + '/messages').then(r => setChatMessages(r.data || [])))
      .catch(() => alert('Не удалось удалить — попробуйте ещё раз.'))
  }

  // Открыть карточку преподавателя (его учеников) во вкладке «Репетиторы».
  const openTutor = (id) => {
    if (!id) return
    setSelChatId(null)
    setSelTutorId(id)
    setView('tutors')
    setTimeout(() => setTutorTab('students'), 60)
  }

  // Распознавание голосовых своим Whisper: текст под плеером по кнопке (как в MAX).
  const [voiceText, setVoiceText] = useState({})    // { [msgId]: текст }
  const [voiceBusy, setVoiceBusy] = useState({})     // { [msgId]: true }
  const transcribeVoice = (m) => {
    if (voiceBusy[m.id] || voiceText[m.id]) return
    setVoiceBusy(b => ({ ...b, [m.id]: true }))
    api.post('/api/max/messages/' + m.id + '/transcribe')
      .then(r => setVoiceText(v => ({ ...v, [m.id]: (r.data && r.data.text) || '—' })))
      .catch(e => setVoiceText(v => ({ ...v, [m.id]: '⚠ ' + ((e.response && e.response.data && e.response.data.error) || 'ошибка распознавания') })))
      .finally(() => setVoiceBusy(b => ({ ...b, [m.id]: false })))
  }

  // Вложения входящего сообщения (файлы/картинки от клиента) — кликабельно.
  const maxAtts = (m) => {
    if (!m.attachments) return null
    let a = []
    try { a = JSON.parse(m.attachments) } catch (e) { return null }
    return a.map((f, i) => {
      const isAudio = f.type === 'audio' || f.type === 'voice' || /\.(ogg|oga|mp3|m4a|wav|opus)(\?|$)/i.test(f.url || '')
      if (isAudio && f.url) {
        const t = voiceText[m.id] || m.transcription
        return (
          <div key={i} className="mb-1">
            <audio controls preload="metadata" src={f.url} className="block w-[320px] max-w-full" />
            {t
              ? <div className={'mt-1 text-[13px] leading-snug rounded-lg px-2.5 py-1.5 ' + (m.direction === 'out' ? 'bg-sky-400/40 text-white' : 'bg-slate-100 text-slate-700')}>{t}</div>
              : <button onClick={() => transcribeVoice(m)} disabled={voiceBusy[m.id]}
                  className={'mt-1 inline-flex items-center gap-1 text-[12px] disabled:opacity-50 ' + (m.direction === 'out' ? 'text-sky-100 hover:text-white' : 'text-sky-600 hover:text-sky-700')}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2M12 19v4"/></svg>
                  {voiceBusy[m.id] ? 'Распознаю…' : 'Распознать'}
                </button>}
          </div>
        )
      }
      return (f.type === 'image' || f.type === 'photo')
        ? <a key={i} href={f.url} target="_blank" rel="noopener" className="block mb-1"><img src={f.url} alt="вложение" className="max-w-full rounded-lg" style={{ maxHeight: 220 }} /></a>
        : <a key={i} href={f.url} target="_blank" rel="noopener" className={'flex items-center gap-2 mb-1 underline break-all ' + (m.direction === 'out' ? 'text-white' : 'text-sky-600')}>📎 {f.filename || 'Файл'}{f.size ? ' · ' + Math.round(f.size / 1024) + ' КБ' : ''}</a>
    })
  }

  // Список чатов MAX — общий для левого рейла (десктоп) и мобильного экрана. Клик открывает модалку диалога.
  // Список переписок кабинета — тянем, когда включён этот источник
  useEffect(() => {
    let alive = true
    const load = () => api.get('/api/platform/admin-chat/conversations')
      .then(r => { if (alive && r.data && r.data.ok) setAdminChats(r.data.items || []) })
      .catch(() => {})
    load()
    const t = setInterval(load, 15000)
    return () => { alive = false; clearInterval(t) }
  }, [])

  // Снят ли препод с сайта (полоска «Вернуть на сайт») — только для переписок с преподом
  useEffect(() => {
    if (!adminSel || adminSel.role !== 'teacher') { setAdminDeact(null); return }
    let alive = true
    api.get('/api/platform/teachers/' + adminSel.mkId + '/deactivation')
      .then(r => { if (alive && r.data && r.data.ok) setAdminDeact(r.data) })
      .catch(() => { if (alive) setAdminDeact(null) })
    return () => { alive = false }
  }, [adminSel])

  // Открытая переписка кабинета
  useEffect(() => {
    if (!adminSel) { setAdminMsgs([]); return }
    let alive = true
    const load = () => api.get('/api/platform/admin-chat/' + adminSel.role + '/' + adminSel.mkId)
      .then(r => { if (alive && r.data && r.data.ok) setAdminMsgs(r.data.messages || []) })
      .catch(() => {})
    load()
    const t = setInterval(load, 10000)
    return () => { alive = false; clearInterval(t) }
  }, [adminSel])

  useEffect(() => {
    const el = adminScrollRef.current
    if (!el) return
    const changed = adminPrevSel.current !== adminSel; adminPrevSel.current = adminSel
    if (!changed && !adminAtBottom.current) return
    const t = setTimeout(() => { el.scrollTop = el.scrollHeight; adminAtBottom.current = true }, 0)
    return () => clearTimeout(t)
  }, [adminMsgs, adminSel])

  // Файл в чат кабинета (картинка/PDF/аудио/видео до 50 МБ) + текст из поля, если набран.
  const sendAdminFile = (file) => {
    if (!file || !adminSel || adminBusy) return
    const fd = new FormData()
    fd.append('attachment', file)
    if ((adminText || '').trim()) fd.append('text', adminText.trim())
    setAdminBusy(true)
    api.post('/api/platform/admin-chat/' + adminSel.role + '/' + adminSel.mkId, fd)
      .then(r => {
        if (r.data && r.data.ok) { setAdminText(''); setAdminMsgs(m => [...m, r.data.message]) }
        else alert((r.data && r.data.error) || 'Не удалось отправить файл')
      })
      .catch(e => alert('Не удалось отправить файл: ' + ((e.response && e.response.data && e.response.data.error) || e.message)))
      .finally(() => setAdminBusy(false))
  }

  // Вложение сообщения кабинета: картинка — превью, аудио — плеер, остальное — ссылка (как в MAX).
  const adminAtt = (m, out) => {
    if (!m.attachment_path) return null
    const parts = String(m.attachment_path).split('/')
    const url = '/api/platform/admin-chat/attachments/' + String(parts[1] || '').replace(/^a/, '') + '/' + (parts[2] || '')
    const t = m.attachment_type || ''
    if (t.startsWith('image/')) return <a href={url} target="_blank" rel="noopener" className="block mb-1"><img src={url} alt="вложение" className="max-w-full rounded-lg" style={{ maxHeight: 220 }} /></a>
    if (t.startsWith('audio/')) return <audio controls preload="metadata" src={url} className="block w-[320px] max-w-full mb-1" />
    return <a href={url} target="_blank" rel="noopener" className={'flex items-center gap-2 mb-1 underline break-all ' + (out ? 'text-white' : 'text-sky-600')}>📎 {m.attachment_name || 'Файл'}{m.attachment_size ? ' · ' + Math.round(m.attachment_size / 1024) + ' КБ' : ''}</a>
  }

  // «Вернуть на сайт»: платформа закрывает снятие и пересчитывает ранг; преподу — сообщение в этот же чат
  // (тот же маршрут, что ручная отправка: пуш + автор = сопроводитель).
  const restoreTeacher = () => {
    if (!adminSel || adminSel.role !== 'teacher' || adminDeactBusy) return
    if (!window.confirm('Вернуть анкету преподавателя на сайт?')) return
    setAdminDeactBusy(true)
    api.post('/api/platform/teachers/' + adminSel.mkId + '/deactivation/restore')
      .then(r => {
        if (!(r.data && r.data.ok)) throw new Error((r.data && r.data.error) || 'Не удалось вернуть')
        setAdminDeact(r.data)
        const text = 'Вернули вашу анкету на сайт. Пожалуйста, отвечайте на предложения и подтверждайте уроки вовремя, иначе анкета снова уйдёт с сайта.'
        return api.post('/api/platform/admin-chat/teacher/' + adminSel.mkId, { text })
          .then(r2 => { if (r2.data && r2.data.ok) setAdminMsgs(m => [...m, r2.data.message]) })
      })
      .catch(e => alert((e.response && e.response.data && e.response.data.error) || e.message || 'Платформа недоступна'))
      .finally(() => setAdminDeactBusy(false))
  }

  // Ответ или «ответ не требуется» → переписка прочитана. Сразу гасим бейдж
  // в списке (сервер тоже пометит), непрочитанные уедут вниз при перезагрузке.
  const clearAdminUnread = () => {
    if (!adminSel) return
    setAdminChats(cs => cs.map(c =>
      (c.peer_role === adminSel.role && c.peer_mk_id === adminSel.mkId)
        ? { ...c, unread_for_admin: 0 } : c))
  }
  const markAdminNoReply = () => {
    if (!adminSel || adminBusy) return
    setAdminBusy(true)
    api.post('/api/platform/admin-chat/' + adminSel.role + '/' + adminSel.mkId + '/no-reply')
      .then(() => clearAdminUnread())
      .catch(e => alert('Не удалось: ' + ((e.response && e.response.data && e.response.data.error) || e.message)))
      .finally(() => setAdminBusy(false))
  }

  const sendAdminMsg = () => {
    const text = (adminText || '').trim()
    if (!text || !adminSel || adminBusy) return
    setAdminBusy(true)
    api.post('/api/platform/admin-chat/' + adminSel.role + '/' + adminSel.mkId, { text })
      .then(r => {
        if (r.data && r.data.ok) {
          setAdminText('')
          setAdminMsgs(m => [...m, r.data.message])
          clearAdminUnread()
        } else alert((r.data && r.data.error) || 'Не удалось отправить')
      })
      .catch(() => alert('Сеть недоступна'))
      .finally(() => setAdminBusy(false))
  }

  // Сервер пишет время в UTC (CURRENT_TIMESTAMP), а работаем мы по Москве —
  // переводим явно, иначе сообщение «в 17:13» вместо 20:13 (Антон 05.08).
  const fmtDeactWhen = (v) => { if (!v) return ''; const ms = new Date(String(v).replace(' ', 'T') + 'Z').getTime(); if (isNaN(ms)) return String(v); return fmtDayLabel(ms).toLowerCase() + ' в ' + new Date(ms).toLocaleTimeString('ru-RU', { timeZone: 'Europe/Moscow', hour: '2-digit', minute: '2-digit' }) }
  const fmtDeactDay = (iso) => { const p = String(iso || '').split('-'); if (p.length !== 3) return iso || ''; return fmtDayLabel(new Date(+p[0], +p[1] - 1, +p[2]).getTime()).toLowerCase() }
  // Полоска «Скрыт с сайта» по причине (платформа: deactivationInfo.open.reason/details/title). Старый бэк без reason = «не подтвердил урок».
  const deactStripText = (o) => {
    const d = o.details || {}
    const when = <>Скрыт с сайта <b className="text-slate-800">{fmtDeactWhen(o.created_at)}</b>: </>
    const lesson = (date, time, subject, grade) => <><b className="text-slate-800">{fmtDeactDay(date)}{time ? ', ' + time : ''}</b>{subject ? ' · ' + subject + (grade ? ', ' + grade + ' класс' : '') : ''}</>
    const slots = d.free_slots_7d != null ? <>. Свободных окошек на неделе: {d.free_slots_7d}</> : null
    switch (o.reason) {
      case 'no_show': return <>{when}не вышел на урок {d.date ? lesson(d.date, d.time, d.subject, d.grade) : null}{d.student ? ' · ученик ' + d.student + ' ждал в комнате' : ' · ученик ждал в комнате'}</>
      case 'sleeping': return <>{when}<b className="text-slate-800">не ответил на 3 предложения подряд</b>{d.last_ignored_at ? <>, последнее <b className="text-slate-800">{fmtDeactWhen(d.last_ignored_at)}</b></> : null}{slots}</>
      case 'no_lessons': return <>{when}<b className="text-slate-800">нет уроков 30 дней</b>{slots}</>
      case 'low_confirm': return <>{when}<b className="text-slate-800">подтвердил {d.confirmed || 0} из {d.offers || 0}</b> поставленных уроков{slots}</>
      case 'no_slots': return <>{when}<b className="text-slate-800">не открыл окошки на неделю</b>. Вернуть кнопкой нельзя, попросите открыть окошки в «Расписании», анкета вернётся сама</>
      default: return <>{when}не подтвердил урок{o.missed ? <> {lesson(o.missed.date, o.missed.time, o.missed.subject, o.missed.grade)}</> : null}</>
    }
  }
  const fmtAdminTime = (v) => {
    if (!v) return ''
    const d = new Date(String(v).replace(' ', 'T') + 'Z')
    if (isNaN(d)) return String(v)
    return d.toLocaleString('ru-RU', {
      timeZone: 'Europe/Moscow', day: '2-digit', month: '2-digit',
      hour: '2-digit', minute: '2-digit',
    })
  }

  const adminUnreadTotal = adminChats.reduce((n, c) => n + (c.unread_for_admin || 0), 0)
  const maxUnreadTotal = chats.reduce((n, c) => n + (c.unread || 0), 0)

  const renderChatList = () => {
    const q = (chatSearch || '').trim().toLowerCase()
    const base = q ? chats.filter(c => ((c.user_name || '') + ' ' + (c.client_name || '') + ' ' + (c.last_text || '')).toLowerCase().includes(q)) : chats
    // Непрочитанные — всегда вверху, дальше по свежести (last_at по убыванию)
    const list = [...base].sort((a, b) => ((b.unread > 0) - (a.unread > 0)) || ((b.last_at || 0) - (a.last_at || 0)))
    // Поиск по ФИО и по телефону — и у клиента, и у преподавателя.
    // Цифры сравниваем отдельно: в базе номера в разном виде (+7 (953)… и 9017…).
    const aq = (adminSearch || '').trim().toLowerCase()
    const aqDigits = aq.replace(/\D/g, '')
    const aList = [...adminChats]
      .sort((a, b) => ((b.unread_for_admin > 0) - (a.unread_for_admin > 0))
        || ((Date.parse(b.last_msg_at || '') || 0) - (Date.parse(a.last_msg_at || '') || 0)))
      .filter(c => adminFilter === 'all' || c.peer_role === adminFilter)
      .filter(c => {
        if (!aq) return true
        const name = (c.peer_name || '').toLowerCase()
        const phone = (c.peer_phone || '').replace(/\D/g, '')
        if (name.includes(aq)) return true
        if (aqDigits.length >= 3 && phone.includes(aqDigits)) return true
        // без цифр в запросе по mk_id не ищем: String(x).includes('') всегда true
        return aqDigits.length >= 3 && String(c.peer_mk_id).includes(aqDigits)
      })
    const srcTabs = (
      <div className="px-3 pt-2 pb-1 flex gap-1.5 sticky top-0 bg-white z-20">
        {[['max', 'Max (' + chats.length + ')'], ['cabinet', 'Кабинет (' + adminChats.length + ')']].map(([k, t]) => (
          <button key={k} onClick={() => { setChatSource(k); if (k === 'max') setAdminSel(null) }}
            className={'relative flex-1 text-[12.5px] font-semibold py-1.5 rounded-lg border ' +
              (chatSource === k ? 'bg-slate-900 border-slate-900 text-white' : 'bg-white border-slate-200 text-slate-500')}>
            {t}
            {k === 'cabinet' && adminUnreadTotal > 0 && (
              <span className="absolute -top-1.5 -right-1.5 min-w-[17px] h-[17px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center ring-2 ring-white">{adminUnreadTotal}</span>
            )}
            {k === 'max' && maxUnreadTotal > 0 && (
              <span className="absolute -top-1.5 -right-1.5 min-w-[17px] h-[17px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center ring-2 ring-white">{maxUnreadTotal}</span>
            )}
          </button>
        ))}
      </div>
    )
    if (chatSource === 'cabinet') return (
    <>
      {srcTabs}
      <div className="px-3 pb-2 relative">
        <input value={adminSearch} onChange={e => setAdminSearch(e.target.value)}
          placeholder="Поиск по ФИО или телефону…"
          className="w-full pl-2 pr-6 py-1.5 rounded-md border border-slate-200 text-[12px] focus:outline-none focus:ring-1 focus:ring-sky-300" />
        {adminSearch && <button onClick={() => setAdminSearch('')} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 text-[13px]">✕</button>}
      </div>
      {aList.length === 0 && <div className="p-6 text-center text-slate-400 text-sm">Пока никто не писал</div>}
      {aList.map(c => (
        <button key={c.id} onClick={() => setAdminSel({ role: c.peer_role, mkId: c.peer_mk_id, name: c.peer_name || ((c.peer_role === 'teacher' ? 'Препод ' : 'Клиент ') + c.peer_mk_id) })}
          className={'w-full text-left px-3 py-2.5 flex gap-3 items-center border-b border-slate-50 hover:bg-slate-50 ' +
            (adminSel && adminSel.mkId === c.peer_mk_id && adminSel.role === c.peer_role ? 'bg-sky-50' : '')}>
          <span className="relative shrink-0">
            <span className={'w-9 h-9 rounded-full font-bold text-sm flex items-center justify-center ' +
              (c.peer_role === 'teacher' ? 'bg-violet-100 text-violet-700' : 'bg-sky-100 text-sky-600')}>
              {c.peer_role === 'teacher' ? 'П' : 'К'}</span>
            {c.unread_for_admin > 0 && <span className="absolute -top-1 -right-1 min-w-[16px] h-[16px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center ring-2 ring-white">{c.unread_for_admin}</span>}
          </span>
          <span className="min-w-0 flex-1">
            <span className="flex items-center gap-1.5 min-w-0">
              <span className={'truncate text-[14px] ' + (c.unread_for_admin > 0 ? 'font-bold text-slate-900' : 'font-semibold text-slate-800')}>
                {c.peer_name || ((c.peer_role === 'teacher' ? 'Препод ' : 'Клиент ') + c.peer_mk_id)}</span>
              <span className={'shrink-0 text-[10px] font-semibold px-1.5 py-0.5 rounded-full ' +
                (c.peer_role === 'teacher' ? 'bg-violet-100 text-violet-700' : 'bg-sky-100 text-sky-700')}>
                {c.peer_role === 'teacher' ? 'препод' : 'клиент'}</span>
            </span>
            <span className="block truncate text-[12.5px] text-slate-500 mt-0.5">{c.last_msg_text || ''}</span>
          </span>
        </button>
      ))}
    </>
    )
    return (
    <>
      {srcTabs}
      <div className="px-3 py-2 border-b border-slate-100 sticky top-0 bg-white z-10 flex items-center gap-2">
        <span className="font-semibold text-slate-800 text-[13px] shrink-0">Чаты Мах <span className="text-slate-400 font-normal">({q ? list.length + '/' + chats.length : chats.length})</span></span>
        <div className="relative flex-1 min-w-0">
          <input value={chatSearch} onChange={e => setChatSearch(e.target.value)} placeholder="Поиск по имени или тексту…" className="w-full pl-2 pr-6 py-1 rounded-md border border-slate-200 text-[12px] focus:outline-none focus:ring-1 focus:ring-sky-300" />
          {q && <button onClick={() => setChatSearch('')} className="absolute right-1 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 text-[13px]">✕</button>}
        </div>
      </div>
      {list.length === 0 && <div className="p-6 text-center text-slate-400 text-sm">{q ? 'Ничего не найдено' : 'Пока нет чатов'}</div>}
      {list.map(c => (
        <button key={c.chat_id} onClick={() => setSelChatId(c.chat_id)}
          className={'w-full text-left px-3 py-2.5 flex gap-3 items-center border-b border-slate-50 hover:bg-slate-50 ' + (selChatId === c.chat_id ? 'bg-sky-50' : '')}>
          <span className="relative shrink-0">
            <span className="w-9 h-9 rounded-full bg-sky-100 text-sky-600 font-bold text-sm flex items-center justify-center">{(c.user_name || '?').trim()[0]}</span>
            {c.unread > 0 && <span className="absolute -top-1 -right-1 min-w-[16px] h-[16px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center ring-2 ring-white">{c.unread}</span>}
          </span>
          <span className="min-w-0 flex-1">
            <span className="flex items-center justify-between gap-2">
              <span className="flex items-center gap-1.5 min-w-0">
                <span className={'truncate text-[14px] ' + (c.unread > 0 ? 'font-bold text-slate-900' : 'font-semibold text-slate-800')}>{c.user_name || 'Без имени'}</span>
                {c.is_teacher ? <span className="shrink-0 text-[10px] font-semibold px-1.5 py-0.5 rounded-full bg-violet-100 text-violet-700">препод</span> : null}
              </span>
              <span className="text-[11px] text-slate-400 shrink-0 pr-1.5">{fmtChatTime(c.last_at)}</span>
            </span>
            <span className={'block text-[12px] truncate ' + (c.unread > 0 ? 'text-slate-700 font-medium' : 'text-slate-500')}>{c.last_text || ''}</span>
            {c.clients && c.clients.length > 0 ? <span className="block text-[11px] text-sky-600 truncate">{c.clients.map(k => k.client_name).join(', ')}</span>
              : c.client_name ? <span className={'block text-[11px] truncate ' + (c.is_teacher ? 'text-violet-600' : 'text-slate-500')}>{c.client_name}</span>
              : <span className="block text-[11px] text-amber-600">не привязан</span>}
          </span>
        </button>
      ))}
    </>
    )
  }

  // Всплывающее окно с перепиской выбранного клиента.
  // Переписчик: сделка из чата — закрыть окно, показать «Сделки», найти/создать по телефону собеседника
  const openDealFromChat = (chat) => {
    setSelChatId(null); setTgSel(null); setView('deals')
    if (dealRef.current) dealRef.current.openByPhone(chat.phone, { phone: chat.phone || '', parentName: chat.user_name || '' })
  }
  const chatModal = selChatId ? (() => {
    const chat = chats.find(c => c.chat_id === selChatId) || {}
    return (
      <div className="fixed inset-0 z-50 flex items-stretch sm:items-center justify-center sm:p-4" onClick={() => setSelChatId(null)}>
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative bg-white w-full h-full sm:h-[80vh] sm:max-w-[560px] sm:rounded-2xl shadow-2xl flex flex-col overflow-hidden" onClick={e => e.stopPropagation()}>
          <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between gap-3">
            <div className="min-w-0 flex-1">
              <div className="font-semibold text-slate-800 truncate flex items-center gap-2">{chat.user_name || 'Чат'}{chat.is_teacher ? <span className="shrink-0 text-[11px] font-semibold px-2 py-0.5 rounded-full bg-violet-100 text-violet-700">преподаватель</span> : null}</div>
              {(chat.clients && chat.clients.length > 0) || (chat.is_teacher && chat.teacher_mk_id) ? (
                <div className="text-[12px] flex flex-wrap gap-x-2">
                  {(chat.clients || []).map(k => (
                    <button key={k.client_mk_id} onClick={() => { setSelChatId(null); setSelClientId(k.client_mk_id); setClientDetail(null); setView('clients') }} className="text-sky-600 hover:underline">{k.client_name} ↗</button>
                  ))}
                  {chat.is_teacher && chat.teacher_mk_id ? (
                    <button onClick={() => openTutor(chat.teacher_mk_id)} className="text-violet-600 hover:underline">{chat.teacher_name || 'препод'} ↗</button>
                  ) : null}
                </div>
              ) : chat.client_name ? (
                <div className="text-[12px] text-slate-500">{chat.client_name}</div>
              ) : <div className="text-[12px] text-amber-600">не привязан к клиенту</div>}
            </div>
            {isWriter && chat.phone && <button onClick={() => openDealFromChat(chat)} className="shrink-0 text-[12px] font-semibold px-2.5 py-1 rounded-lg" style={{ background: '#FFFBEB', color: '#B45309', border: '1px solid #FDE68A' }} title="Открыть или создать сделку по телефону собеседника">Сделка ↗</button>}
            {chat.phone && <div className="text-[12px] text-slate-400 shrink-0">{chat.phone}</div>}
            <button onClick={() => setSelChatId(null)} className="shrink-0 w-8 h-8 rounded-full hover:bg-slate-100 text-slate-500 text-xl leading-none" title="Закрыть">×</button>
          </div>
          <div ref={maxScrollRef} onScroll={e => { const el = e.currentTarget; maxAtBottom.current = el.scrollHeight - el.scrollTop - el.clientHeight < 120 }} className="flex-1 overflow-y-auto p-4 space-y-2 bg-slate-50">
            {chatMessages.length === 0 && <div className="text-center text-slate-400 text-sm">Сообщений нет</div>}
            {chatMessages.map((m, idx) => {
              const showDay = idx === 0 || dayKey(m.at) !== dayKey(chatMessages[idx - 1].at)
              return (
              <Fragment key={m.id || idx}>
                {showDay && <div className="flex justify-center my-1"><span className="text-[11px] text-slate-500 bg-slate-100 rounded-full px-3 py-1">{fmtDayLabel(m.at)}</span></div>}
              {m.direction === 'note' ? (
                <div key={m.id} className="flex justify-center">
                  <div className="text-[11px] text-slate-500 bg-slate-100 rounded-full px-3 py-1">Ответ не требуется — {m.author || '?'} · {fmtChatTime(m.at)}</div>
                </div>
              ) : (
                <div key={m.id} className={'group flex items-end gap-1 ' + (m.direction === 'out' ? 'justify-end' : 'justify-start')}>
                  {m.direction === 'out' && !m.deleted && (
                    <button onClick={() => deleteMaxMsg(m.id)} title="Удалить сообщение" className="opacity-0 group-hover:opacity-100 shrink-0 text-slate-400 hover:text-rose-500 text-[13px] px-1">🗑</button>
                  )}
                  {m.deleted ? (
                    <div className="max-w-[75%] px-3 py-2 rounded-2xl text-[13px] italic bg-slate-100 text-slate-400 border border-slate-200">
                      Сообщение удалено{m.deleted_by ? ' · ' + m.deleted_by : ''}
                    </div>
                  ) : (
                    <div className={'max-w-[75%] px-3 py-2 rounded-2xl text-[14px] whitespace-pre-wrap break-words ' + (m.direction === 'out' ? 'bg-sky-500 text-white' : 'bg-white border border-slate-200 text-slate-800')}>
                      {m.reply_text && <div className={'mb-1 pl-2 border-l-2 text-[12px] truncate ' + (m.direction === 'out' ? 'border-sky-200 text-sky-100' : 'border-slate-300 text-slate-400')}>{m.reply_text}</div>}
                      {maxAtts(m)}{m.text}
                      <div className={'text-[10px] mt-1 ' + (m.direction === 'out' ? 'text-sky-100' : 'text-slate-400')}>{m.direction === 'out' && m.author ? m.author + ' · ' : ''}{fmtChatTime(m.at)}{m.direction === 'out' ? (m.mid ? ' ✓' : '') : ''}</div>
                    </div>
                  )}
                  {m.direction === 'in' && !m.deleted && (
                    <button onClick={() => setReplyTo({ mid: m.mid, text: (m.text || '(вложение)').slice(0, 120) })} title="Ответить с цитатой" className="opacity-0 group-hover:opacity-100 shrink-0 text-slate-400 hover:text-sky-600 text-[13px] px-1">↩</button>
                  )}
                </div>
              )}
              </Fragment>
              )
            })}
          </div>
          <div className="px-4 py-3 border-t border-slate-100">
            {replyTo && (
              <div className="mb-2 flex items-start gap-2 text-[12px] bg-slate-50 border-l-2 border-sky-400 pl-2 pr-1 py-1 rounded">
                <div className="flex-1 min-w-0"><div className="text-slate-400">Ответ на:</div><div className="truncate text-slate-600">{replyTo.text}</div></div>
                <button onClick={() => setReplyTo(null)} className="text-slate-400 hover:text-slate-600 shrink-0">✕</button>
              </div>
            )}
            <div className="flex gap-2 items-center">
              <input ref={maxFileRef} type="file" className="hidden" onChange={e => { const f = e.target.files && e.target.files[0]; if (f) sendMaxFile(f); e.target.value = '' }} />
              <button onClick={() => maxFileRef.current && maxFileRef.current.click()} disabled={maxSending} title="Прикрепить файл" className="px-2 py-2 rounded-lg text-slate-500 hover:text-sky-600 hover:bg-slate-100 disabled:opacity-50"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21.44 11.05l-9.19 9.19a5 5 0 0 1-7.07-7.07l9.19-9.19a3.5 3.5 0 0 1 4.95 4.95l-9.2 9.19a1.5 1.5 0 0 1-2.12-2.12l8.49-8.49"/></svg></button>
              <textarea value={maxReply} rows={1}
                  onChange={e => { setMaxReply(e.target.value); e.target.style.height = 'auto'; e.target.style.height = Math.min(e.target.scrollHeight, 160) + 'px' }}
                  onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); e.target.style.height = 'auto'; sendMaxReply() } }}
                  placeholder="Написать сообщение… (Shift+Enter — новая строка)"
                  style={{ maxHeight: 160, overflowY: 'auto' }}
                  className="flex-1 px-3 py-2 rounded-lg border border-slate-200 text-sm leading-snug resize-none focus:outline-none focus:ring-2 focus:ring-sky-200" />
              <button onClick={sendMaxReply} disabled={maxSending || !maxReply.trim()} className="px-4 py-2 rounded-lg bg-sky-500 text-white text-sm font-semibold disabled:opacity-50">{maxSending ? '…' : 'Отправить'}</button>
            </div>
            <button onClick={markNoReply} disabled={maxSending} className="mt-2 text-[12px] text-slate-500 hover:text-slate-700 disabled:opacity-50">Ответ не требуется</button>
          </div>
        </div>
      </div>
    )
  })() : null

  const adminChatModal = adminSel ? (
    <div className="fixed inset-0 z-50 flex items-stretch sm:items-center justify-center sm:p-4" onClick={() => setAdminSel(null)}>
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative bg-white w-full h-full sm:h-[80vh] sm:max-w-[560px] sm:rounded-2xl shadow-2xl flex flex-col overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="px-4 py-3 border-b border-slate-100 flex items-center gap-3">
          <span className={'w-9 h-9 rounded-full font-bold text-sm flex items-center justify-center shrink-0 ' + (adminSel.role === 'teacher' ? 'bg-violet-100 text-violet-700' : 'bg-sky-100 text-sky-600')}>{adminSel.role === 'teacher' ? 'П' : 'К'}</span>
          <div className="min-w-0 flex-1">
            <div className="font-semibold text-slate-800 truncate flex items-center gap-2">{adminSel.name}<span className={'shrink-0 text-[11px] font-semibold px-2 py-0.5 rounded-full ' + (adminSel.role === 'teacher' ? 'bg-violet-100 text-violet-700' : 'bg-sky-100 text-sky-700')}>{adminSel.role === 'teacher' ? 'преподаватель' : 'клиент'}</span></div>
            {adminSel.role === 'teacher'
              ? <button onClick={() => openTutor(adminSel.mkId)} className="text-[12px] text-violet-600 hover:underline">Открыть карточку преподавателя ↗</button>
              : <button onClick={() => { setAdminSel(null); setSelClientId(adminSel.mkId); setClientDetail(null); setView('clients') }} className="text-[12px] text-sky-600 hover:underline">Открыть карточку клиента ↗</button>}
          </div>
          <button onClick={() => setAdminSel(null)} className="shrink-0 w-8 h-8 rounded-full hover:bg-slate-100 text-slate-500 text-xl leading-none" title="Закрыть">×</button>
        </div>
        {adminSel.role === 'teacher' && adminDeact && adminDeact.open && (
          // 16.09: причина любая (макет _unhide-preview.html); «нет окошек» — серая, без кнопки
          <div className={'px-4 py-2.5 border-b flex items-center gap-3 text-[13px] leading-snug ' + (adminDeact.open.restorable === false ? 'bg-slate-50 border-slate-200 text-slate-600' : 'bg-sky-50 border-sky-100 text-sky-900')}>
            <div>{deactStripText(adminDeact.open)}</div>
            {adminDeact.open.restorable !== false && <button onClick={restoreTeacher} disabled={adminDeactBusy} className="ml-auto shrink-0 px-3 py-2 rounded-lg bg-sky-500 hover:bg-sky-600 text-white text-[13px] font-semibold disabled:opacity-50">{adminDeactBusy ? '…' : 'Вернуть на сайт'}</button>}
          </div>
        )}
        {adminSel.role === 'teacher' && adminDeact && !adminDeact.open && adminDeact.last_cleared && (
          <div className="px-4 py-2.5 bg-emerald-50 border-b border-emerald-100 text-[13px] text-emerald-800 leading-snug">Анкета возвращена на сайт <b>{fmtDeactWhen(adminDeact.last_cleared.cleared_at)}</b> ({adminDeact.last_cleared.cleared_by}). Показываем 30 дней как новичка, дальше по обычным правилам.</div>
        )}
        <div ref={adminScrollRef} onScroll={e => { const el = e.currentTarget; adminAtBottom.current = el.scrollHeight - el.scrollTop - el.clientHeight < 120 }} className="flex-1 overflow-y-auto p-4 space-y-2 bg-slate-50">
          <div className="flex justify-center"><span className="text-[11px] text-slate-500 bg-slate-100 rounded-full px-3 py-1">Человек видит эту переписку в своём кабинете</span></div>
          {adminMsgs.map((m, idx) => {
            const cms = m.created_at ? new Date(String(m.created_at).replace(' ', 'T') + 'Z').getTime() : 0
            const pms = idx > 0 && adminMsgs[idx - 1].created_at ? new Date(String(adminMsgs[idx - 1].created_at).replace(' ', 'T') + 'Z').getTime() : 0
            const showDay = idx === 0 || dayKey(cms) !== dayKey(pms)
            const out = m.from_side === 'admin'
            return (
              <Fragment key={m.id || idx}>
                {showDay && <div className="flex justify-center my-1"><span className="text-[11px] text-slate-500 bg-slate-100 rounded-full px-3 py-1">{fmtDayLabel(cms)}</span></div>}
                <div className={'flex ' + (out ? 'justify-end' : 'justify-start')}>
                  <div className={'max-w-[75%] px-3 py-2 rounded-2xl text-[14px] whitespace-pre-wrap break-words ' + (out ? 'bg-sky-500 text-white' : 'bg-white border border-slate-200 text-slate-800')}>
                    {adminAtt(m, out)}{m.text}
                    <div className={'text-[10px] mt-1 ' + (out ? 'text-sky-100' : 'text-slate-400')}>{out ? (m.author_name || 'Сопровождение') + ' · ' : ''}{fmtAdminTime(m.created_at)}</div>
                  </div>
                </div>
              </Fragment>
            )
          })}
        </div>
        <div className="px-4 py-3 border-t border-slate-100">
          <div className="flex gap-2 items-center">
            <input ref={adminFileRef} type="file" accept="image/*,application/pdf,audio/*,video/*" className="hidden" onChange={e => { const f = e.target.files && e.target.files[0]; if (f) sendAdminFile(f); e.target.value = '' }} />
            <button onClick={() => adminFileRef.current && adminFileRef.current.click()} disabled={adminBusy} title="Прикрепить файл" className="px-2 py-2 rounded-lg text-slate-500 hover:text-sky-600 hover:bg-slate-100 disabled:opacity-50"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21.44 11.05l-9.19 9.19a5 5 0 0 1-7.07-7.07l9.19-9.19a3.5 3.5 0 0 1 4.95 4.95l-9.2 9.19a1.5 1.5 0 0 1-2.12-2.12l8.49-8.49"/></svg></button>
            <input value={adminText} onChange={e => setAdminText(e.target.value)} onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendAdminMsg() } }} placeholder={adminSel.role === 'teacher' ? 'Написать преподавателю…' : 'Написать клиенту…'} className="flex-1 px-3 py-2 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-sky-200" />
            <button onClick={sendAdminMsg} disabled={adminBusy || !adminText.trim()} className="px-4 py-2 rounded-lg bg-sky-500 text-white text-sm font-semibold disabled:opacity-50">{adminBusy ? '…' : 'Отправить'}</button>
          </div>
          <button onClick={markAdminNoReply} disabled={adminBusy} className="mt-2 text-[12px] text-slate-500 hover:text-slate-700 disabled:opacity-50">Ответ не требуется</button>
        </div>
      </div>
    </div>
  ) : null

  return (
    <div className="min-h-screen" style={{ background: '#F2F2F7' }}>
      <style>{TASK_CSS}</style>
      <style>{`.crm-nav{gap:2px}.crm-nav>button,.crm-nav>a{padding:4px 7px;font-size:12px;white-space:nowrap;line-height:1.25}`}</style>

      <header className="sticky top-0 z-30 bg-white/85 backdrop-blur border-b border-slate-200" style={{ height: 56 }}>
        <div className="h-full px-3 flex items-center gap-2">
          <div className="flex items-center gap-2.5 shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 64 64" style={{ flexShrink: 0 }}><rect width="64" height="64" rx="16" fill="#3bc8f5"/><text x="50%" y="47" fontFamily="Arial, sans-serif" fontSize="38" fontWeight="bold" fill="#ffffff" textAnchor="middle">К</text></svg>
            <div className="text-[14px] font-semibold tracking-tight">Котангенс CRM</div>
          </div>
          <span className="text-[12px] font-medium px-2.5 py-1 rounded-full shrink-0 whitespace-nowrap"
                style={{ background: '#E0F2FE', color: '#0369A1', border: '1px solid #BAE6FD' }}>
            {isWriter ? 'Переписка' : isTutors ? 'Преподаватели' : 'Сопровождение'}
          </span>
{isWriter ? (
          <nav className="hidden lg:flex items-center gap-0.5 ml-2 text-[12px] crm-nav">
            <button onClick={() => setView('deals')} className={'px-3 py-1.5 rounded-lg ' + (view === 'deals' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}>Сделки</button>
            <button onClick={() => setView('clients')} className={'px-3 py-1.5 rounded-lg ' + (view === 'clients' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}>Мои клиенты</button>
            <button onClick={() => setView('tutors')} className={'px-3 py-1.5 rounded-lg ' + (view === 'tutors' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}>Репетиторы</button>
<a href="/teachers" className="px-3 py-1.5 rounded-lg text-slate-500 hover:text-slate-800" style={{ textDecoration: 'none' }}>Все преподаватели</a>
            <button onClick={() => setView('trials')} className={'px-3 py-1.5 rounded-lg ' + (view === 'trials' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}>Мои пробные</button>
            <button onClick={() => setView('promo')} className={'px-3 py-1.5 rounded-lg ' + (view === 'promo' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}>Промокоды</button>
            <button onClick={() => { setView('deals'); if (dealRef.current) dealRef.current.openAdd() }}
              className="ml-2 px-3.5 py-1.5 rounded-lg text-white text-[13px] font-bold" style={{ background: '#38BDF8' }}>+ Добавить сделку</button>
          </nav>
          ) : isTutors ? (
          <nav className="hidden lg:flex items-center gap-0.5 ml-2 text-[12px] crm-nav">
            <button
              onClick={() => setView('anketi')}
              className={'px-3 py-1.5 rounded-lg flex items-center gap-1.5 ' + (view === 'anketi' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}
            >Анкеты</button>
            <button
              onClick={() => setView('otbor')}
              className={'px-3 py-1.5 rounded-lg flex items-center gap-1.5 ' + (view === 'otbor' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}
            >Созвоны{otborWaiting > 0 && <span className="disc-navbadge">{otborWaiting}</span>}</button>
            <button
              onClick={() => setView('badreviews')}
              className={'px-3 py-1.5 rounded-lg flex items-center gap-1.5 ' + (view === 'badreviews' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}
            >Задачи</button>
            <button
              onClick={() => setView('chats')}
              className={'px-3 py-1.5 rounded-lg flex items-center gap-1.5 ' + (view === 'chats' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}
            >💬 Чаты{(chatsUnread + adminUnreadTotal) > 0 && <span className="disc-navbadge">{chatsUnread + adminUnreadTotal}</span>}</button>
            <button
              onClick={() => setLibOpen(true)}
              title="Загрузить учебник или методичку в библиотеку платформы"
              className="px-3 py-1.5 rounded-lg flex items-center gap-1.5 text-slate-500 hover:text-slate-800"
            >📚 Методички</button>
          </nav>
          ) : (
          <nav className="hidden lg:flex items-center gap-0.5 ml-2 text-[12px] crm-nav">
            <button
              onClick={() => setView('tasks')}
              className={'px-3 py-1.5 rounded-lg ' + (view === 'tasks' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}
            >Задачи</button>
            <button
              onClick={() => setView('clients')}
              className={'px-3 py-1.5 rounded-lg ' + (view === 'clients' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}
            >Мои клиенты</button>
            <button
              onClick={() => setView('chats')}
              className={'px-3 py-1.5 rounded-lg flex items-center gap-1.5 ' + (view === 'chats' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}
            >💬 Чаты{(chatsUnread + adminUnreadTotal) > 0 && <span className="disc-navbadge">{chatsUnread + adminUnreadTotal}</span>}</button>
            <button
              onClick={() => setView('tutors')}
              className={'px-3 py-1.5 rounded-lg ' + (view === 'tutors' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}
            >Репетиторы</button>
<a href="/teachers" className="px-3 py-1.5 rounded-lg text-slate-500 hover:text-slate-800" style={{ textDecoration: 'none' }}>Все преподаватели</a>
            <button
              onClick={() => setView('otbor')}
              className={'px-3 py-1.5 rounded-lg flex items-center gap-1.5 ' + (view === 'otbor' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}
            >Отбор{otborWaiting > 0 && <span className="disc-navbadge">{otborWaiting}</span>}</button>
            <button
              onClick={() => setView('trials')}
              className={'px-3 py-1.5 rounded-lg ' + (view === 'trials' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}
            >Пробные уроки</button>
            <button
              onClick={() => { setView('migration'); resetMigration() }}
              className={'px-3 py-1.5 rounded-lg ' + (view === 'migration' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800')}
            >🔁 Перенос клиента</button>
          </nav>
          )}
          <div className="flex items-center gap-2.5 ml-auto shrink-0">
            <button onClick={toggleShift} disabled={shiftBusy} title={onShift ? 'Снять смену' : 'Начать смену'}
              className="flex items-center gap-2 pl-2.5 pr-3 py-1.5 rounded-full text-[13px] font-semibold disabled:opacity-60"
              style={onShift ? { background: '#ECFDF5', color: '#047857', border: '1px solid #A7F3D0' }
                             : { background: '#F1F5F9', color: '#94A3B8', border: '1px solid #E2E8F0' }}>
              <span className="relative inline-block w-8 h-[18px] rounded-full" style={{ background: onShift ? '#10B981' : '#CBD5E1' }}>
                <span className="absolute top-0.5 w-3.5 h-3.5 rounded-full bg-white shadow" style={{ left: onShift ? 14 : 2 }} />
              </span>
              {onShift ? 'На смене' : 'Не на смене'}
            </button>
            <div className="text-right leading-tight hidden sm:block">
              <div className="text-[13px] font-medium text-slate-800">{name}</div>
              <div className="text-[11px] text-slate-500">{shiftSub}</div>
            </div>
            <div className="w-8 h-8 rounded-full bg-slate-200 text-slate-600 flex items-center justify-center text-[12px] font-semibold">{initials}</div>
            <button onClick={onLogout} className="text-[12px] text-slate-500 hover:text-slate-800 px-2 py-1.5 rounded-lg hover:bg-slate-100">Выйти</button>
          </div>
        </div>
      </header>

      <div className="lg:flex lg:items-start">
        {!['otbor', 'anketi', 'badreviews'].includes(view) && (
        <aside className="hidden lg:block w-[360px] shrink-0 border-r border-slate-200 bg-white sticky top-[56px] self-start overflow-y-auto" style={{ height: 'calc(100dvh - 56px)' }}>
          {renderChatList()}

        </aside>
        )}
        <div className="flex-1 min-w-0">

      {/* Мобильное меню вкладок — десктопное .nav в шапке скрыто на узких экранах */}
      {isWriter ? (
      <nav className="lg:hidden sticky top-[56px] z-20 bg-white border-b border-slate-200 flex gap-1 px-3 py-2 overflow-x-auto whitespace-nowrap text-[13px]">
        <button onClick={() => setView('deals')} className={'shrink-0 px-3 py-1.5 rounded-lg ' + (view === 'deals' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>Сделки</button>
        <button onClick={() => setView('clients')} className={'shrink-0 px-3 py-1.5 rounded-lg ' + (view === 'clients' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>Мои клиенты</button>
        <button onClick={() => setView('tutors')} className={'shrink-0 px-3 py-1.5 rounded-lg ' + (view === 'tutors' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>Репетиторы</button>
<a href="/teachers" className="shrink-0 px-3 py-1.5 rounded-lg text-slate-500" style={{ textDecoration: 'none' }}>Все преподаватели</a>
        <button onClick={() => setView('trials')} className={'shrink-0 px-3 py-1.5 rounded-lg ' + (view === 'trials' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>Мои пробные</button>
        <button onClick={() => setView('promo')} className={'shrink-0 px-3 py-1.5 rounded-lg ' + (view === 'promo' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>Промокоды</button>
        <button onClick={() => { setView('deals'); if (dealRef.current) dealRef.current.openAdd() }} className="shrink-0 px-3 py-1.5 rounded-lg text-white font-bold" style={{ background: '#38BDF8' }}>+ Сделка</button>
      </nav>
      ) : isTutors ? (
      <nav className="lg:hidden sticky top-[56px] z-20 bg-white border-b border-slate-200 flex gap-1 px-3 py-2 overflow-x-auto whitespace-nowrap text-[13px]">
        <button onClick={() => setView('anketi')} className={'shrink-0 px-3 py-1.5 rounded-lg inline-flex items-center gap-1.5 ' + (view === 'anketi' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>Анкеты</button>
        <button onClick={() => setView('otbor')} className={'shrink-0 px-3 py-1.5 rounded-lg inline-flex items-center gap-1.5 ' + (view === 'otbor' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>Созвоны{otborWaiting > 0 && <span className="disc-navbadge">{otborWaiting}</span>}</button>
        <button onClick={() => setView('badreviews')} className={'shrink-0 px-3 py-1.5 rounded-lg inline-flex items-center gap-1.5 ' + (view === 'badreviews' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>Задачи</button>
        <button onClick={() => setView('chats')} className={'shrink-0 px-3 py-1.5 rounded-lg inline-flex items-center gap-1.5 ' + (view === 'chats' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>💬 Чаты{(chatsUnread + adminUnreadTotal) > 0 && <span className="disc-navbadge">{chatsUnread + adminUnreadTotal}</span>}</button>
      </nav>
      ) : (
      <nav className="lg:hidden sticky top-[56px] z-20 bg-white border-b border-slate-200 flex gap-1 px-3 py-2 overflow-x-auto whitespace-nowrap text-[13px]">
        <button onClick={() => setView('tasks')} className={'shrink-0 px-3 py-1.5 rounded-lg ' + (view === 'tasks' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>Задачи</button>
        <button onClick={() => setView('clients')} className={'shrink-0 px-3 py-1.5 rounded-lg ' + (view === 'clients' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>Мои клиенты</button>
        <button onClick={() => setView('chats')} className={'shrink-0 px-3 py-1.5 rounded-lg inline-flex items-center gap-1.5 ' + (view === 'chats' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>💬 Чаты{(chatsUnread + adminUnreadTotal) > 0 && <span className="disc-navbadge">{chatsUnread + adminUnreadTotal}</span>}</button>
        <button onClick={() => setView('tutors')} className={'shrink-0 px-3 py-1.5 rounded-lg ' + (view === 'tutors' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>Репетиторы</button>
<a href="/teachers" className="shrink-0 px-3 py-1.5 rounded-lg text-slate-500" style={{ textDecoration: 'none' }}>Все преподаватели</a>
        <button onClick={() => setView('otbor')} className={'shrink-0 px-3 py-1.5 rounded-lg inline-flex items-center gap-1.5 ' + (view === 'otbor' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>Отбор{otborWaiting > 0 && <span className="disc-navbadge">{otborWaiting}</span>}</button>
        <button onClick={() => setView('trials')} className={'shrink-0 px-3 py-1.5 rounded-lg ' + (view === 'trials' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>Пробные</button>
        <button onClick={() => { setView('migration'); resetMigration() }} className={'shrink-0 px-3 py-1.5 rounded-lg ' + (view === 'migration' ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500')}>🔁 Перенос</button>
      </nav>
      )}

      {urgent && (
        <div className="sop-urgent">
          <span>🆘 Срочная задача — {urgent.meta && urgent.meta.guestId ? 'пишет гость' : 'вопрос в чате'}</span>
          <span className="who">
            {urgent.clientName || 'Клиент'}{urgent.teacher ? ' ↔ ' + urgent.teacher : ''}
          </span>
          <button onClick={claimUrgent}>Взять в работу</button>
        </div>
      )}

      {view === 'clients' && (
        <div className="sopwrap" style={{ gridTemplateColumns: '1fr', maxWidth: 760, margin: '0 auto', padding: '22px 16px 40px' }}>
          <div className="card" style={{ marginBottom: 16 }}>
            <div className="cl-phonesearch">
              <input
                placeholder="Телефон, ID или имя клиента…"
                value={clientPhone}
                onChange={e => { setClientPhone(e.target.value); if (selClientId) { setSelClientId(null); setClientDetail(null) } }}
              />
              <button className="cl-newbtn" style={{ margin: 0, width: 'auto', padding: '0 18px' }} onClick={() => searchClients(clientPhone)}>
                Найти
              </button>
              <button className="cl-newbtn" style={{ margin: 0, width: 'auto', padding: '0 18px', background: '#fff', color: '#38BDF8', border: '1.5px solid #38BDF8' }}
                onClick={() => { setNewClientMsg(null); setNewClientModalOpen(true) }}>
                ➕ Новый клиент
              </button>
            </div>
            {newClientMsg && (
              <div className="mbanner" style={{ margin: '0 16px 14px', background: '#ECFDF5', color: '#047857', border: '1px solid #A7F3D0' }}>
                ✓ {typeof newClientMsg === 'string' ? newClientMsg : newClientMsg.text}
                {typeof newClientMsg !== 'string' && (
                  <div style={{ marginLeft: -32 }}><SmsLinkRow bookingId={newClientMsg.bookingId} phone={newClientMsg.phone} /></div>
                )}
              </div>
            )}
          </div>

          {!selClientId && clientSearchStatus == null && <div className="card cl-hint" style={{ padding: 32 }}>Введите телефон, ID или имя, чтобы найти клиента</div>}
          {!selClientId && clientSearchStatus === 'searching' && <div className="card cl-hint" style={{ padding: 32 }}>Ищу…</div>}
          {!selClientId && clientSearchStatus === 'not_found' && <div className="card cl-hint" style={{ padding: 32 }}>Ничего не найдено</div>}

          {!selClientId && clientSearchStatus === 'found' && searchResults.length > 0 && (
            <div className="card" style={{ padding: 8 }}>
              {searchResults.map(r => (
                <button key={r.mkId} onClick={() => setSelClientId(r.mkId)}
                  style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left', background: 'none', border: 0, borderRadius: 12, padding: '11px 12px', cursor: 'pointer', fontFamily: 'inherit' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f4f7fa'}
                  onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                  <div style={{ width: 34, height: 34, borderRadius: '50%', background: '#e2e8f0', color: '#475569', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, flexShrink: 0 }}>{(r.name || '?')[0]}</div>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.name || '—'}</div>
                    <div style={{ fontSize: 12.5, color: '#64748b' }}>{r.phone || '—'} · ID {r.mkId}</div>
                  </div>
                </button>
              ))}
            </div>
          )}

          {selClientId && (
            <div className="card cl-col">
              <button onClick={() => { setSelClientId(null); setClientDetail(null) }}
                style={{ alignSelf: 'flex-start', background: 'none', border: 0, color: '#38BDF8', cursor: 'pointer', fontSize: 13.5, fontWeight: 600, padding: '10px 12px 0', fontFamily: 'inherit' }}>
                ← К результатам поиска
              </button>
              {clientDetailLoading && <div className="cl-hint" style={{ padding: 24 }}>Загружаю карточку…</div>}
              {!clientDetailLoading && clientDetail && (
                <>
                  <div className="chead">
                    <div className="ava">{(clientDetail.name || '?')[0]}</div>
                    <div className="ttl">
                      <b>{clientDetail.name} <button title="Редактировать клиента" onClick={() => setEditModal(clientDetail)} style={{ background: 'none', border: 0, cursor: 'pointer', fontSize: 15, padding: 2, verticalAlign: 'middle', opacity: .7 }}>✏️</button><button title="Объединить дубли — свести вторую карточку этого клиента в эту" onClick={openMerge} style={{ background: 'none', border: 0, cursor: 'pointer', fontSize: 15, padding: 2, verticalAlign: 'middle', opacity: .7 }}>🧬</button>{clientDetail.debt_lessons > 0 && <span title={'Долг по посещениям: ' + clientDetail.debt_lessons + ' неоплаченных урок(ов)'} style={{ animation: 'sopPulse 1s infinite', color: '#fff', fontSize: 11, fontWeight: 800, borderRadius: 999, padding: '2px 10px', marginLeft: 8, verticalAlign: 'middle' }}>Долг</span>}{clientDetail.from_old_mk && <span style={{ background: '#EDE9FE', color: '#6D28D9', fontSize: 11, fontWeight: 700, borderRadius: 999, padding: '3px 10px', marginLeft: 8, verticalAlign: 'middle' }}>клиент из старого МК</span>}</b>
                      <div className="sub">{clientDetail.phone || '—'}{clientDetail.grade ? ` · ${clientDetail.grade} класс` : ''}{clientDetail.from_site && <span style={{ background: '#2563EB', color: '#fff', fontSize: 10, fontWeight: 700, borderRadius: 999, padding: '1px 7px', marginLeft: 8, verticalAlign: 'middle' }}>саморег</span>}{!clientDetail.from_site && clientDetail.created_by && <span style={{ background: '#EEF2F7', color: '#475569', fontSize: 10, fontWeight: 600, borderRadius: 999, padding: '1px 8px', marginLeft: 8, verticalAlign: 'middle' }}>внёс: {clientDetail.created_by}</span>}</div>
                      {clientDetail.parent && <div style={{ marginTop: 3, fontSize: 12.5, color: '#475569', fontWeight: 600 }}><span style={{ color: '#94A3B8', fontWeight: 400 }}>Родитель:</span> {clientDetail.parent}</div>}
                      {/* Анкета звонильщика. Он спрашивает маму, класс, город и цель —
                          раньше всё это оставалось в сделке, и сопровождение открывало
                          пустую карточку (жалоба 26.10.2026). Ничего не копируем: карточка
                          находит анкету по телефону и показывает рядом. */}
                      {(() => {
                        const lc = clientDetail.lead_card
                        const pl = clientDetail.phone_location
                        if (!lc && !pl) return null
                        const bits = []
                        if (lc) {
                          if (lc.parent_name) bits.push('мама: ' + lc.parent_name)
                          if (lc.child_name) bits.push('ребёнок: ' + lc.child_name)
                          if (lc.class_num) bits.push(String(lc.class_num).match(/^\d/) ? lc.class_num + ' класс' : lc.class_num)
                          if (lc.city) bits.push(lc.city)
                          if (lc.subject) bits.push(lc.subject)
                          if (lc.goal) bits.push('цель: ' + lc.goal)
                        }
                        let local = null
                        if (pl && pl.timezone) {
                          try {
                            local = new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit', timeZone: pl.timezone }).format(new Date())
                          } catch (e) { local = null }
                        }
                        return (
                          <div style={{ marginTop: 4, fontSize: 12.5, color: '#475569', lineHeight: 1.5 }}>
                            {bits.length > 0 && (
                              <div>
                                <span style={{ color: '#94A3B8' }}>Из анкеты:</span> {bits.join(' · ')}
                                {lc && lc.manager_name && <span style={{ color: '#94A3B8' }}> · заполнил {lc.manager_name}</span>}
                              </div>
                            )}
                            {pl && pl.city && (
                              <div>
                                <span style={{ color: '#94A3B8' }}>По номеру:</span> {pl.city}
                                {local && <span> · у клиента сейчас <b>{local}</b></span>}
                              </div>
                            )}
                            {lc && lc.comment && (
                              <div style={{ color: '#64748B' }}><span style={{ color: '#94A3B8' }}>Комментарий звонильщика:</span> {lc.comment}</div>
                            )}
                          </div>
                        )
                      })()}
                      {(() => {
                        const mc = chats.find(c => (c.clients && c.clients.some(k => Number(k.client_mk_id) === Number(clientDetail.id))) || Number(c.client_mk_id) === Number(clientDetail.id))
                        return mc ? <button onClick={() => setSelChatId(mc.chat_id)} title="Открыть чат MAX" style={{ background: 'none', border: 0, padding: 0, cursor: 'pointer', color: '#0284C7', fontSize: 11.5, fontWeight: 500 }}>MAX: {mc.user_name || 'аккаунт'} ↗</button> : null
                      })()}
                      {(() => {
                        const tc = tgChats.find(c => (c.clients && c.clients.some(k => Number(k.client_mk_id) === Number(clientDetail.id))) || Number(c.client_mk_id) === Number(clientDetail.id))
                        return tc ? <button onClick={() => setTgSel(tc.chat_id)} title="Открыть чат Telegram" style={{ background: 'none', border: 0, padding: 0, cursor: 'pointer', color: '#0891B2', fontSize: 11.5, fontWeight: 500, marginLeft: 10 }}>✈️ Telegram: {tc.user_name || 'аккаунт'} ↗</button> : null
                      })()}
                      {/* Чат кабинета (admin-chat) — есть у ЛЮБОГО ученика, не зависит от MAX/TG-привязки.
                          Ученику сообщение падает в личный кабинет + пуш (notifyPeer, role=student). */}
                      <button onClick={() => setAdminSel({ role: 'student', mkId: Number(clientDetail.id), name: clientDetail.name })} title="Написать ученику в личный кабинет (придёт в кабинет + пуш)" style={{ background: 'none', border: 0, padding: 0, cursor: 'pointer', color: '#7C3AED', fontSize: 11.5, fontWeight: 500, marginLeft: 10 }}>💬 ЛК: {clientDetail.name} ↗</button>
                      <div style={{ marginTop: 3, fontSize: 11.5, color: '#94a3b8', lineHeight: 1.5 }}>
                        Активность в ЛК: {clientDetail.last_login_at ? fmtLkActivity(clientDetail.last_login_at) : 'не входил'}
                        {' · '}в МК с {clientDetail.created_at ? fmtDateOnly(clientDetail.created_at) : '—'}
                      </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8, marginLeft: 'auto' }}>
                      {(() => {
                        const refused = clientDetail.client_status && clientDetail.client_status.status === 'refused'
                        return (
                          <select
                            value={refused ? 'refused' : 'studying'}
                            onChange={e => { const v = e.target.value; if (v === 'refused' && !refused) setRefuseModal(clientDetail); else if (v === 'studying' && refused) handleStudying() }}
                            title={(clientDetail.client_status && clientDetail.client_status.reason) ? 'Причина отказа: ' + clientDetail.client_status.reason : 'Статус клиента'}
                            style={{ cursor: 'pointer', fontWeight: 700, fontSize: 13.5, borderRadius: 9, padding: '5px 10px', textAlign: 'center', background: refused ? '#FEE2E2' : '#DCFCE7', color: refused ? '#DC2626' : '#16A34A', border: refused ? '1px solid #FCA5A5' : '1px solid #86EFAC', outline: 'none' }}>
                            <option value="studying">Учится</option>
                            <option value="refused">Отказ</option>
                          </select>
                        )
                      })()}
                      <button className="mbtn primary" onClick={() => { setTrialBookedMsg(null); setTrialPickerOpen(true) }} style={{ fontSize: 12, padding: '7px 12px', width: 172, textAlign: 'center' }}>
                        Записать на пробный
                      </button>
                      <button className="mbtn primary" onClick={() => { setTrialBookedMsg(null); setPaidPickerOpen(true) }} style={{ fontSize: 12, padding: '7px 12px', width: 172, textAlign: 'center' }}>
                        Записать на платное
                      </button>
                    </div>
                  </div>
                  <div className="body" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    {trialBookedMsg && (
                      <div className="panel" style={{ gridColumn: '1 / -1', background: '#ECFDF5', border: '1px solid #A7F3D0', color: '#047857', fontWeight: 600, fontSize: 13.5 }}>
                        ✓ {typeof trialBookedMsg === 'string' ? trialBookedMsg : trialBookedMsg.text}
                        {typeof trialBookedMsg !== 'string' && (
                          <div style={{ marginLeft: -32 }}><SmsLinkRow bookingId={trialBookedMsg.bookingId} phone={trialBookedMsg.phone} /></div>
                        )}
                      </div>
                    )}
                    <div className="panel">
                      <h3>Баланс <span style={{ marginLeft: 'auto', float: 'right', fontSize: 18, fontWeight: 800, color: Number(clientDetail.balance_rub) < 0 ? '#B91C1C' : '#047857' }}>
                        {fmtBalance(clientDetail.balance_rub).text}
                      </span></h3>
                      {clientDetail.subscription_lessons_left != null && (() => {
                        const n = clientDetail.subscription_lessons_left
                        const w = (n % 10 === 1 && n % 100 !== 11) ? 'урок' : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) ? 'урока' : 'уроков'
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, fontSize: 13, color: '#475569' }}>
                            <span>В абонементах</span>
                            <span style={{ fontWeight: 700, color: n > 0 ? '#047857' : '#94A3B8' }}>{n} {w}</span>
                          </div>
                        )
                      })()}
                    </div>
                    <div className="panel">
                      {(() => {
                        const own = (clientTasks && clientTasks.own) || []
                        const mkt = (clientTasks && clientTasks.tasks) || []
                        const all = [
                          ...own.map(t => ({ text: t.text, status: t.status, at: t.created_at })),
                          ...mkt.map(t => ({ text: t.body, status: t.local_status || 'active', at: t.beginDate || t.createdAt })),
                        ].filter(t => t.status !== 'deleted')
                        all.sort((a, b) => new Date(b.at || 0) - new Date(a.at || 0))
                        const last = all[0]
                        return (
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <div style={{ minWidth: 0, flex: 1 }}>
                              <div style={{ fontSize: 11, color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.03em' }}>Последняя задача</div>
                              <div style={{ fontSize: 13.5, color: last ? '#334155' : '#94a3b8', marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', opacity: last && last.status === 'done' ? 0.5 : 1 }}>{last ? last.text : 'Задач нет'}</div>
                            </div>
                            <button className="mbtn primary" onClick={() => setAddTaskOpen(v => !v)} style={{ flexShrink: 0, fontSize: 13, padding: '7px 12px' }}>+ Задача</button>
                          </div>
                        )
                      })()}
                      {addTaskOpen && (
                        <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
                          <input value={newTaskText} onChange={e => setNewTaskText(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') addOwnTask() }} placeholder="Текст задачи…" autoFocus style={{ flex: '1 1 160px', border: '1px solid #cbd5e1', borderRadius: 9, padding: '8px 11px', fontSize: 13.5, outline: 'none', fontFamily: 'inherit' }} />
                          <input type="date" value={newTaskDate} onChange={e => setNewTaskDate(e.target.value)} title="Дата выполнения" style={{ flexShrink: 0, border: '1px solid #cbd5e1', borderRadius: 9, padding: '7px 10px', fontSize: 13.5, outline: 'none', fontFamily: 'inherit', color: '#334155' }} />
                          <input type="time" value={newTaskTime} onChange={e => setNewTaskTime(e.target.value)} title="Время (за 1 час до — упадёт в очередь)" style={{ flexShrink: 0, border: '1px solid #cbd5e1', borderRadius: 9, padding: '7px 10px', fontSize: 13.5, outline: 'none', fontFamily: 'inherit', color: '#334155' }} />
                          <button onClick={addOwnTask} style={{ flexShrink: 0, fontSize: 13, border: 0, background: '#0284C7', color: '#fff', borderRadius: 9, padding: '8px 14px', fontWeight: 600, cursor: 'pointer' }}>Добавить</button>
                        </div>
                      )}
                    </div>
                    <div style={{ background: '#F8FAFC', border: '1px solid #EEF2F6', borderRadius: 14, padding: 16, marginBottom: 14 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div style={{ minWidth: 0, flex: 1 }}>
                          <div style={{ fontSize: 11, color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.03em' }}>Последний комментарий</div>
                          <div style={{ fontSize: 13.5, color: (cardComments && cardComments.length) ? '#334155' : '#94a3b8', marginTop: 2, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', lineHeight: 1.45 }}>
                            {cardComments === null ? 'Загрузка…'
                              : cardComments.length ? (cardComments[0].text + ' — ' + (cardComments[0].author || 'без имени') + ', ' + fmtCommentDate(cardComments[0].created_at))
                              : 'Комментариев нет'}
                          </div>
                        </div>
                        <button className="mbtn primary" onClick={() => setAddCommentOpen(v => !v)} style={{ flexShrink: 0, fontSize: 13, padding: '7px 12px' }}>{addCommentOpen ? 'Отмена' : '+ Комментарий'}</button>
                      </div>
                      {addCommentOpen && (
                        <div style={{ display: 'flex', gap: 8, marginTop: 11, flexWrap: 'wrap' }}>
                          <textarea value={newComment} onChange={e => setNewComment(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) addComment() }}
                            placeholder="Например: дозвонилась, мама просила перезвонить после 18:00" autoFocus
                            style={{ flex: '1 1 240px', minHeight: 66, resize: 'vertical', border: '1px solid #cbd5e1', borderRadius: 9, padding: '8px 11px', fontSize: 13.5, outline: 'none', fontFamily: 'inherit', color: '#0f172a' }} />
                          <button onClick={addComment} disabled={commentSaving || !String(newComment).trim()}
                            style={{ flexShrink: 0, alignSelf: 'flex-start', fontSize: 13, border: 0, background: (commentSaving || !String(newComment).trim()) ? '#CBD5E1' : '#0284C7', color: '#fff', borderRadius: 9, padding: '8px 14px', fontWeight: 600, cursor: 'pointer' }}>{commentSaving ? 'Сохраняем…' : 'Сохранить'}</button>
                        </div>
                      )}
                    </div>
                    {/* Вкладки прижаты (меньше шрифт и отступы) и переносятся на вторую
                        строку: в один ряд девять штук не влезали, «Абонементы» обрезались
                        (Роман 02.11.2026). */}
                    <div style={{ display: 'flex', gap: 0, flexWrap: 'wrap', borderBottom: '1px solid #e2e8f0' }}>
                      {[['lessons', 'Уроки'], ['visits', 'Посещения'], ['homework', 'ДЗ'], ['payments', 'Оплаты'], ['calls', 'Звонки'], ['tasks', 'Задачи'], ['comments', 'Комментарии'], ['subjects', 'Предметы'], ['subscriptions', 'Абонементы']].map(([k, label]) => (
                        <button key={k} onClick={() => setClientTab(k)} style={{ background: 'none', border: 0, borderBottom: clientTab === k ? '2px solid #0284C7' : '2px solid transparent', color: clientTab === k ? '#0f172a' : '#64748b', fontWeight: clientTab === k ? 600 : 500, fontSize: 12.5, padding: '7px 7px', cursor: 'pointer', fontFamily: 'inherit', marginBottom: -1, whiteSpace: 'nowrap' }}>{label}</button>
                      ))}
                    </div>
                    {/* Звонки клиенту: касания менеджеров. Пока заглушка — данные (кто звонил
                        и когда) подключим из Билайна/leads, как в кабинете РОПа. */}
                    {clientTab === 'calls' && (
                      <div className="panel">
                        <h3>Звонки</h3>
                        <div className="cl-hint">
                          Здесь будут звонки менеджеров этому клиенту — кто звонил, когда и сколько длился разговор.
                          Пока не подключено.
                        </div>
                      </div>
                    )}
                    {clientTab === 'comments' && (
                    <div className="panel">
                      <h3>Комментарии</h3>
                      {cardComments === null && <div className="cl-hint">Загрузка…</div>}
                      {cardComments !== null && cardComments.length === 0 && <div className="cl-hint">Комментариев пока нет. Напишите первый — коллеги увидят, что с клиентом уже работали.</div>}
                      {(cardComments || []).map(c => (
                        <div key={c.id} style={{ display: 'flex', gap: 11, padding: '12px 0', borderBottom: '1px solid #EEF2F6' }}>
                          <div style={{ width: 28, height: 28, borderRadius: '50%', flex: 'none', background: '#E0F2FE', color: '#0369A1', fontSize: 12, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{String(c.author || '?').trim().slice(0, 1).toUpperCase()}</div>
                          <div style={{ minWidth: 0, flex: 1 }}>
                            <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
                              <span style={{ fontSize: 13, fontWeight: 600, color: '#0f172a' }}>{c.author || 'без имени'}</span>
                              <span style={{ fontSize: 11.5, color: '#94a3b8' }}>{fmtCommentDate(c.created_at)}</span>
                              {c.can_delete && <button onClick={() => deleteComment(c.id)} style={{ fontSize: 11.5, border: 0, background: 'none', color: '#94a3b8', cursor: 'pointer', padding: 0, fontFamily: 'inherit' }}>удалить</button>}
                            </div>
                            <div style={{ fontSize: 13.5, lineHeight: 1.5, color: '#475569', marginTop: 3, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', wordBreak: 'break-word' }}>{c.text}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                    )}
                    {clientTab === 'subscriptions' && (
                    <div className="panel">
                      <h3>Абонементы</h3>
                      {(!clientDetail.subscriptions || clientDetail.subscriptions.length === 0) && <div className="cl-hint">Абонементов нет</div>}
                      {(clientDetail.subscriptions || []).map((s, i) => (
                        <div className="cl-litem" key={i}>
                          <div className="cl-meta">
                            <div style={{ fontWeight: 600 }}>{s.subject}</div>
                            <div style={{ fontSize: 11.5, color: '#64748b' }}>{s.used} из {s.total} · осталось {s.left} · {s.price}₽{s.sell_date ? ' · продан ' + s.sell_date : ''}{s.end_date ? ' · до ' + s.end_date : ''}</div>
                            {s.spent_on && (
                              <div style={{ fontSize: 11.5, color: '#0d8bb7', marginTop: 2 }}>Потрачен на: {s.spent_on}</div>
                            )}
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ fontSize: 10, fontWeight: 700, borderRadius: 999, padding: '2px 8px', whiteSpace: 'nowrap', background: (s.active && !s.refunded) ? '#DCFCE7' : '#F1F5F9', color: (s.active && !s.refunded) ? '#127A45' : '#64748B' }}>{s.refunded ? 'возвращён' : (s.active ? 'активен' : (s.expired ? 'истёк' : 'израсходован'))}</span>
                            {s.id && s.left > 0 && !s.refunded ? (
                              <button title="Удалить абонемент — деньги вернутся на баланс"
                                disabled={delSubBusy === s.id}
                                onClick={() => delSubscription(s)}
                                style={{ border: '1px solid #FECACA', background: '#fff', color: '#DC2626', borderRadius: 8, padding: '3px 9px', fontSize: 11.5, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                {delSubBusy === s.id ? '…' : 'Удалить'}
                              </button>
                            ) : null}
                          </div>
                        </div>
                      ))}
                    </div>
                    )}
                    {clientTab === 'subjects' && (
                    <div className="panel">
                      <h3>Предметы</h3>
                      {(clientDetail.joins || []).filter(j => j.subject).length === 0 && <div className="row"><span className="k">—</span></div>}
                      {(clientDetail.joins || []).filter(j => j.subject).map((j, i) => (
                        <div className="row" key={i}><span className="k">{j.subject}</span><span className="v">{j.visits} посещений</span></div>
                      ))}
                    </div>
                    )}
                    {clientTab === 'lessons' && (<>
                    <div className="panel" style={{ gridColumn: '1 / -1' }}>
                      <h3>Ближайшие уроки</h3>
                      {/* Кнопка «Поставить уроки» убрана по просьбе Романа 31.08.2026
                          (была: массовое создание платных уроков без пробного, Антон 29.07).
                          Модалка AddLessonsModal жива и вызывается из других мест. */}
                      {(() => {
                        const MON = ['янв','фев','мар','апр','май','июн','июл','авг','сен','окт','ноя','дек']
                        const pad = n => String(n).padStart(2, "0")
                        const isoOf = dt => dt.getUTCFullYear() + "-" + pad(dt.getUTCMonth() + 1) + "-" + pad(dt.getUTCDate())
                        const now = new Date()
                        const todayUTC = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()))
                        const dow = (todayUTC.getUTCDay() + 6) % 7 // 0=Пн
                        const mon = new Date(todayUTC.getTime() - dow * 86400000 + upcWeek * 7 * 86400000)
                        const sun = new Date(mon.getTime() + 6 * 86400000)
                        const monISO = isoOf(mon), sunISO = isoOf(sun)
                        const rangeLabel = mon.getUTCDate() + " " + MON[mon.getUTCMonth()] + " – " + sun.getUTCDate() + " " + MON[sun.getUTCMonth()]
                        const weekLessons = (clientDetail.lessons || [])
                          .filter(l => l.status === 'planned' || l.status === 'deleted')
                          .filter(l => l.date && l.date >= monISO && l.date <= sunISO)
                          .sort((a, b) => (a.date + (a.begin_time || '')).localeCompare(b.date + (b.begin_time || '')))
                        const arrow = { width: 30, height: 30, borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#0f172a', fontSize: 17, cursor: 'pointer', fontFamily: 'inherit', lineHeight: 1 }
                        return (
                          <>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '2px 0 12px', flexWrap: 'wrap' }}>
                              <div style={{ flex: 1, minWidth: 0 }}></div>
                              <button style={arrow} onClick={() => setUpcWeek(w => w - 1)}>‹</button>
                              <div style={{ minWidth: 160, textAlign: 'center', fontWeight: 700, fontSize: 13 }}>{rangeLabel}{upcWeek === 0 && <span style={{ color: '#38BDF8' }}> · текущая</span>}</div>
                              <button style={arrow} onClick={() => setUpcWeek(w => w + 1)}>›</button>
                              <div style={{ flex: 1, minWidth: 0 }}></div>
                            </div>
                      <div className="cl-llist">
                        {weekLessons.length === 0 && <div className="cl-hint">На этой неделе занятий нет</div>}
                        {weekLessons.map((l, i) => (
                          l.status === 'deleted' ? (
                            <div className="cl-litem" key={i} style={{ opacity: .55, background: '#f8fafc', flexDirection: 'column', alignItems: 'stretch', gap: 4 }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                <div className="cl-dt" style={{ textDecoration: 'line-through' }}>{fmtLessonWhen(l)}</div>
                                <div className="cl-meta" style={{ textDecoration: 'line-through' }}>{l.subject || 'Урок'}{l.teacher ? ' · ' + l.teacher : ''}</div>
                              </div>
                              <div style={{ fontSize: 12, color: '#94a3b8', paddingLeft: 110 }}>
                                🗑 Удалён: {l.deleted_by || 'сопроводитель'} — {l.deleted_reason || '—'}
                              </div>
                            </div>
                          ) : (
                            <div className="cl-litem" key={i}>
                              <div className="cl-dt">{fmtLessonWhen(l)}</div>
                              <div className="cl-meta">
                                <div>{l.subject || 'Предмет не указан'}{l.teacher ? ' · ' + l.teacher : ''}</div>
                                {/* Бейджи — ПОД ФИО учителя: в одну строку с предметом и преподом
                                    они не умещались и ломали строку (Роман 02.11.2026). */}
                                <div style={{ display: 'flex', gap: 4, alignItems: 'center', flexWrap: 'wrap', marginTop: 3 }}>
                                  {/* Тип урока и его цена — у КАЖДОГО урока (Роман 02.11.2026).
                                      Пробный (урок из брони) — жёлтым, обычный «платное» — голубым,
                                      тем же цветом, что и бейдж цены. Цена пробного заморожена в
                                      брони, у обычного — из карточки цен (та же, что в ЛК и в списании). */}
                                  {(l.is_trial || l.from_booking)
                                    ? <span style={{ background: '#FEF3C7', color: '#B45309', fontSize: 9.5, fontWeight: 700, borderRadius: 999, padding: '0 6px', whiteSpace: 'nowrap' }}>пробный</span>
                                    : <span style={{ background: '#E0F2FE', color: '#0369A1', fontSize: 9.5, fontWeight: 700, borderRadius: 999, padding: '0 6px', whiteSpace: 'nowrap' }}>платное</span>}
                                  {(l.lesson_free || l.lesson_price != null) && (
                                    <span
                                      title={(l.is_trial || l.from_booking) ? 'Цена этого пробного — из брони' : 'Цена этого урока — из карточки ученика'}
                                      style={{ background: l.lesson_free ? '#DCFCE7' : '#E0F2FE', color: l.lesson_free ? '#127A45' : '#0369A1', fontSize: 9.5, fontWeight: 700, borderRadius: 999, padding: '0 6px', whiteSpace: 'nowrap' }}
                                    >{l.lesson_free ? 'бесплатный' : l.lesson_price + ' ₽'}</span>
                                  )}
                                  {l.confirm_status === 'confirmed' && <span style={{ background: '#DCFCE7', color: '#127A45', fontSize: 9.5, fontWeight: 700, borderRadius: 999, padding: '0 6px', whiteSpace: 'nowrap' }} title="Ученик подтвердил присутствие">✓ подтвердил</span>}
                                  {l.confirm_status === 'asked' && <span style={{ background: '#FEE2E2', color: '#B91C1C', fontSize: 9.5, fontWeight: 700, borderRadius: 999, padding: '0 6px', whiteSpace: 'nowrap' }} title="Напоминание ушло, ученик пока не подтвердил">не подтвердил</span>}
                                  {l.confirm_status === 'declined' && <span style={{ background: '#B91C1C', color: '#fff', fontSize: 9.5, fontWeight: 700, borderRadius: 999, padding: '0 6px', whiteSpace: 'nowrap' }} title="Ученик нажал «Не приду» в пуше">✕ не придёт</span>}
                                </div>
                                {liveLesson && l.date && l.begin_time && (new Date(l.date + 'T' + l.begin_time + ':00+03:00').getTime() <= Date.now() && Date.now() < (l.end_time ? new Date(l.date + 'T' + l.end_time + ':00+03:00').getTime() : new Date(l.date + 'T' + l.begin_time + ':00+03:00').getTime() + 3600000)) && (
                                  <div style={{ fontSize: 9.5, color: '#64748b', whiteSpace: 'nowrap' }}>в комнате: {(liveLesson.teachers || []).join(', ')} — {(liveLesson.students || []).join(', ')}</div>
                                )}
                                {liveLesson && l.date && l.begin_time && (new Date(l.date + 'T' + l.begin_time + ':00+03:00').getTime() <= Date.now() && Date.now() < (l.end_time ? new Date(l.date + 'T' + l.end_time + ':00+03:00').getTime() : new Date(l.date + 'T' + l.begin_time + ':00+03:00').getTime() + 3600000)) && (
                                  <span style={{ fontSize: 10, fontWeight: 700, color: '#DC2626', whiteSpace: 'nowrap' }}>Урок идёт · комн. {liveLesson.roomId}</span>
                                )}
                              </div>
                              {l.lesson_id && (
                                <>
                                  {(!l.is_trial || l.booking_id) && <button className="iconbtn" title="Перенести урок" onClick={() => setRescheduleLesson(l)}>📅</button>}
                                  {l.is_trial && l.booking_id && <button className="iconbtn" title="Сменить преподавателя" onClick={() => setChangeTeacherLesson(l)}>👤</button>}
                                  <button className="iconbtn" title="Удалить урок" onClick={() => setDeleteLesson(l)}>🗑</button>
                                </>
                              )}
                            </div>
                          )
                        ))}
                      </div>
                          </>
                        )
                      })()}
                    </div>
                    <div className="panel" style={{ gridColumn: '1 / -1' }}>
                      <h3>История уроков</h3>
                      {(() => {
                        const MON = ['янв','фев','мар','апр','май','июн','июл','авг','сен','окт','ноя','дек']
                        const pad = n => String(n).padStart(2, "0")
                        const isoOf = dt => dt.getUTCFullYear() + "-" + pad(dt.getUTCMonth() + 1) + "-" + pad(dt.getUTCDate())
                        const now = new Date()
                        const todayUTC = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()))
                        const dow = (todayUTC.getUTCDay() + 6) % 7 // 0=Пн
                        const mon = new Date(todayUTC.getTime() - dow * 86400000 + histWeek * 7 * 86400000)
                        const sun = new Date(mon.getTime() + 6 * 86400000)
                        const monISO = isoOf(mon), sunISO = isoOf(sun)
                        const rangeLabel = mon.getUTCDate() + " " + MON[mon.getUTCMonth()] + " – " + sun.getUTCDate() + " " + MON[sun.getUTCMonth()]
                        const weekLessons = (clientDetail.lessons || [])
                          .filter(l => l.date && l.date >= monISO && l.date <= sunISO)
                          .filter(l => { const es = l.end_time || l.begin_time; const em = new Date(l.date + 'T' + (es || '23:59') + ':00+03:00').getTime(); return em < Date.now() })
                          .sort((a, b) => (a.date + (a.begin_time || '')).localeCompare(b.date + (b.begin_time || '')))
                        const arrow = { width: 30, height: 30, borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#0f172a', fontSize: 17, cursor: 'pointer', fontFamily: 'inherit', lineHeight: 1 }
                        const debtCount = (clientDetail.lessons || []).filter(l => l.status === 'success' && !l.is_trial && !l.paid).length
                        const debtPlu = (n) => { const a = n % 10, b = n % 100; return (a === 1 && b !== 11) ? 'занятие' : (a >= 2 && a <= 4 && (b < 10 || b >= 20)) ? 'занятия' : 'занятий' }
                        return (
                          <>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '2px 0 12px', flexWrap: 'wrap' }}>
                              <div style={{ flex: 1, minWidth: 0 }}></div>
                              <button style={arrow} onClick={() => setHistWeek(w => w - 1)}>‹</button>
                              <div style={{ minWidth: 160, textAlign: 'center', fontWeight: 700, fontSize: 13 }}>{rangeLabel}{histWeek === 0 && <span style={{ color: '#38BDF8' }}> · текущая</span>}</div>
                              <button style={arrow} onClick={() => setHistWeek(w => w + 1)}>›</button>
                              <div style={{ flex: 1, minWidth: 0, display: 'flex', justifyContent: 'flex-end' }}>
                                {debtCount > 0 && <span style={{ background: '#DC2626', color: '#fff', borderRadius: 8, padding: '6px 12px', fontSize: 12.5, fontWeight: 800, whiteSpace: 'nowrap' }}>{debtCount + ' ' + debtPlu(debtCount) + ' в долг'}</span>}
                              </div>
                            </div>
                            <div className="cl-llist">
                              {weekLessons.length === 0 && <div className="cl-hint">На этой неделе уроков нет</div>}
                              {weekLessons.map((l, i) => {
                                const st = l.status === 'success'
                                  ? (l.is_trial ? ['done', 'Проведён'] : (l.paid ? ['done', 'Проведён · Оплачен'] : ['skip', 'Проведён · Долг']))
                                  : l.status === 'deleted' ? ['skip', 'Отменён'] : (STATUS_LABEL[l.status] || STATUS_LABEL.missed)
                                return (
                                  <div className="cl-litem" key={i}>
                                    <div className="cl-dt">{fmtLessonWhen(l)}</div>
                                    <div className="cl-meta">
                                      <div>{l.subject || 'Предмет не указан'}{l.teacher ? ' · ' + l.teacher : ''}</div>
                                      {(() => { const se = sessionForLesson(l); return se ? (<div style={{ fontSize: 9.5, color: '#64748b', whiteSpace: 'nowrap' }}>комн. {clientDetail.video_room_id} · {(se.teachers || []).join(', ')} — {(se.students || []).join(', ')}</div>) : null })()}
                                      {/* Бейджи — под ФИО учителя, не в одну строку с ним (Роман 02.11.2026) */}
                                      <div style={{ display: 'flex', gap: 4, alignItems: 'center', flexWrap: 'wrap', marginTop: 3 }}>
                                        {(l.is_trial || l.from_booking)
                                          ? <span style={{ background: '#FEF3C7', color: '#B45309', fontSize: 9.5, fontWeight: 700, borderRadius: 999, padding: '0 6px', whiteSpace: 'nowrap' }}>пробный</span>
                                          : <span style={{ background: '#E0F2FE', color: '#0369A1', fontSize: 9.5, fontWeight: 700, borderRadius: 999, padding: '0 6px', whiteSpace: 'nowrap' }}>платное</span>}
                                        {(l.lesson_free || l.lesson_price != null) && (
                                          <span
                                            title={(l.is_trial || l.from_booking) ? 'Цена этого пробного — из брони' : 'Цена этого урока — из карточки ученика'}
                                            style={{ background: l.lesson_free ? '#DCFCE7' : '#E0F2FE', color: l.lesson_free ? '#127A45' : '#0369A1', fontSize: 9.5, fontWeight: 700, borderRadius: 999, padding: '0 6px', whiteSpace: 'nowrap' }}
                                          >{l.lesson_free ? 'бесплатный' : l.lesson_price + ' ₽'}</span>
                                        )}
                                      </div>
                                    </div>
                                    <span className={'cl-st ' + st[0]}>{st[1]}</span>
                                  </div>
                                )
                              })}
                            </div>
                          </>
                        )
                      })()}
                    </div>
                    </>)}
                    {clientTab === 'tasks' && (() => {
                      const sup = (clientTasks && clientTasks.support) || []
                      const mkt = (clientTasks && clientTasks.tasks) || []
                      const own = (clientTasks && clientTasks.own) || []
                      const stStyle = (st) => ({ opacity: st === 'active' ? 1 : 0.5, textDecoration: st === 'deleted' ? 'line-through' : 'none' })
                      const Btns = ({ source, k, st }) => (
                        <div style={{ display: 'flex', gap: 6, marginTop: 5 }}>
                          <button onClick={() => setCardTaskStatus(source, k, st === 'done' ? 'active' : 'done')} style={{ fontSize: 11, border: '1px solid #cbd5e1', background: st === 'done' ? '#e2e8f0' : '#fff', color: '#475569', borderRadius: 8, padding: '2px 9px', cursor: 'pointer', fontFamily: 'inherit' }}>Выполнена</button>
                          <button onClick={() => setCardTaskStatus(source, k, st === 'deleted' ? 'active' : 'deleted')} style={{ fontSize: 11, border: '1px solid #fecaca', background: st === 'deleted' ? '#f1f5f9' : '#fff', color: '#b91c1c', borderRadius: 8, padding: '2px 9px', cursor: 'pointer', fontFamily: 'inherit' }}>Удалить</button>
                        </div>
                      )
                      return (
                      <div className="panel">
                        <h3>Задачи</h3>
                        {clientTasksLoading && <div className="cl-hint">Загружаю…</div>}
                        {!clientTasksLoading && sup.length === 0 && mkt.length === 0 && own.length === 0 && <div className="cl-hint">Задач нет</div>}
                        {own.map((t) => {
                          let pm = null, pc = {}
                          try { pm = t.meta ? JSON.parse(t.meta) : null } catch (e) {}
                          try { pc = t.checklist ? JSON.parse(t.checklist) : {} } catch (e) {}
                          const isTrial = !!(pm && pm.kind === 'trial_today')
                          return (
                          <div key={'o' + t.id} style={{ padding: '9px 0', borderBottom: '1px solid #f1f5f9', ...stStyle(t.status) }}>
                            <div style={{ fontSize: 13.5, color: '#334155', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{isTrial ? <span style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.03em', background: '#EEF2FF', color: '#4338CA', border: '1px solid #C7D2FE', borderRadius: 6, padding: '1px 6px', marginRight: 6 }}>Автозадача</span> : '📝 '}{t.text}</div>
                            <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>своя · {t.due_date ? 'до ' + fmtDue(t.due_date) : 'без срока'}{t.created_by ? ' · ' + t.created_by : ''} {isDueOverdue(t.due_date) && t.status !== 'done' && <span style={{ background: '#FEE2E2', color: '#B91C1C', fontSize: 10, fontWeight: 700, borderRadius: 999, padding: '1px 7px', marginLeft: 4 }}>просрочена</span>}</div>
                            {isTrial && <CardTrialChecklistRO mkUserId={selClientId} meta={pm} checklist={pc} />}
                            {t.status === 'done' && <CardCompletedLine by={t.completed_by} at={t.completed_at} />}
                            <Btns source="own" k={t.id} st={t.status} />
                          </div>
                          )
                        })}
                        {mkt.map((t) => (
                          <div key={'m' + t.id} style={{ padding: '9px 0', borderBottom: '1px solid #f1f5f9', ...stStyle(t.local_status || 'active') }}>
                            <div style={{ fontSize: 13.5, color: '#334155', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{t.body || '(без текста)'}</div>
                            <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>МК · {fmtDateOnly(t.beginDate || t.createdAt)}</div>
                            {(t.local_status === 'done') && <CardCompletedLine by={t.completed_by} at={t.completed_at} />}
                            <Btns source="mk" k={t.id} st={t.local_status || 'active'} />
                          </div>
                        ))}
                        {sup.map((t, i) => (
                          <div key={'s' + i} style={{ display: 'flex', gap: 10, padding: '9px 0', borderBottom: '1px solid #f1f5f9', alignItems: 'flex-start' }}>
                            <span style={{ fontSize: 15, lineHeight: '20px' }}>{t.status === 'done' ? '✅' : '🔴'}</span>
                            <div style={{ minWidth: 0, flex: 1 }}>
                              <div style={{ fontSize: 13.5, color: '#334155', fontWeight: 600 }}>{t.title || t.type || 'Задача'}</div>
                              <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>{[t.subject, t.teacher].filter(Boolean).join(' · ') || 'сопровождение'} · {fmtDateOnly(t.createdAt)}{t.status === 'done' ? (t.outcome ? ' · ' + t.outcome : ' · закрыта') : ' · активна'}</div>
                              {t.status === 'done' && (
                                <div style={{ fontSize: 12.5, fontWeight: 600, color: t.resolvedByName ? '#047857' : '#94a3b8', marginTop: 2 }}>
                                  ✓ Закрыл(а): {t.resolvedByName || 'не записано'}{t.resolvedAt ? ' · ' + fmtMskDateTime(t.resolvedAt) : ''}
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                      )
                    })()}
                    {clientTab === 'visits' && (
                      <div className="panel">
                        <h3>Посещения</h3>
                        {clientVisitsLoading && <div className="cl-hint">Загружаю…</div>}
                        {!clientVisitsLoading && clientVisits && (<>
                          {(clientVisits.visits || []).length === 0 && <div className="cl-hint">Проведённых уроков нет</div>}
                          <div className="cl-llist">
                            {(clientVisits.visits || []).map((v, i) => (
                              <div className="cl-litem" key={i}>
                                <div className="cl-dt">{fmtLessonWhen(v)}</div>
                                <div className="cl-meta"><div>{v.subject || 'Урок'}{v.teacher ? ' · ' + v.teacher : ''}</div></div>
                                {v.is_trial ? <span className="cl-st" style={{ background: '#FEF3C7', color: '#B45309' }}>пробный</span>
                                  : v.paid ? <span className="cl-st done">оплачен</span>
                                  : <span className="cl-st" style={{ background: '#FEE2E2', color: '#B91C1C' }}>долг{v.price ? ' · ' + v.price + '₽' : ''}</span>}
                                {!v.paid && !v.is_trial && v.lesson_record_id && <button className="iconbtn" title="Закрыть долг" onClick={() => setPayVisit(v)}>🖉</button>}
                              </div>
                            ))}
                          </div>
                        </>)}
                      </div>
                    )}
                    {payVisit && (
                      <div onClick={() => !payingVisit && setPayVisit(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 60, padding: 16 }}>
                        <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 16, padding: 20, width: 420, maxWidth: '100%', boxShadow: '0 20px 50px rgba(0,0,0,.2)' }}>
                          <h3 style={{ margin: '0 0 4px', fontSize: 17 }}>Закрыть долг</h3>
                          <div style={{ fontSize: 13.5, color: '#334155' }}>{payVisit.subject || 'Урок'} · {payVisit.date} {payVisit.begin_time}</div>
                          <div style={{ fontSize: 20, fontWeight: 800, color: '#0f172a', margin: '6px 0 14px' }}>{payVisit.price ? payVisit.price + ' ₽' : 'цена не задана'}</div>
                          {(() => {
                            const bal = clientVisits && clientVisits.balance_rub != null ? Number(clientVisits.balance_rub) : null
                            const price = Number(payVisit.price || 0)
                            const enough = bal != null && price > 0 && bal >= price
                            return (
                              <div style={{ marginBottom: 14 }}>
                                <div style={{ fontSize: 12.5, color: '#64748b', marginBottom: 6 }}>Баланс: <b style={{ color: enough ? '#047857' : '#B91C1C' }}>{bal != null ? bal.toLocaleString('ru') + ' ₽' : '—'}</b></div>
                                <button disabled={!enough || !!payingVisit} onClick={() => {
                                  setPayingVisit(payVisit.lesson_id)
                                  api.post('/api/platform/support-clients/' + selClientId + '/visits/pay-balance', { lesson_id: payVisit.lesson_id, price: payVisit.price })
                                    .then(r => { if (r.data && r.data.ok) { const lid = payVisit.lesson_id; setPayVisit(null); setClientVisits(cv => cv ? { ...cv, balance_rub: (r.data.balance != null ? r.data.balance : cv.balance_rub), visits: (cv.visits || []).map(x => x.lesson_id === lid ? { ...x, paid: true } : x) } : cv) } else alert('Не удалось: ' + ((r.data && r.data.error) || 'ошибка')) })
                                    .catch(e => alert('Ошибка: ' + ((e.response && e.response.data && e.response.data.error) || e.message)))
                                    .finally(() => setPayingVisit(null))
                                }} style={{ width: '100%', padding: '11px', borderRadius: 10, border: 0, background: (!enough || payingVisit) ? '#CBD5E1' : '#0284C7', color: '#fff', fontWeight: 700, fontSize: 14, cursor: (!enough || payingVisit) ? 'default' : 'pointer' }}>
                                  {payingVisit ? 'Оплачиваем…' : 'Оплатить с баланса'}
                                </button>
                                {!enough && bal != null && <div style={{ fontSize: 11.5, color: '#B91C1C', marginTop: 5 }}>На балансе недостаточно — пополните.</div>}
                              </div>
                            )
                          })()}
                          <button onClick={() => !payingVisit && setPayVisit(null)} style={{ marginTop: 14, width: '100%', padding: '9px', borderRadius: 10, border: '1px solid #E2E8F0', background: '#fff', color: '#475569', fontWeight: 600, cursor: 'pointer' }}>Закрыть</button>
                        </div>
                      </div>
                    )}
                    {clientTab === 'homework' && (
                      <div className="panel">
                        <h3>Домашние задания</h3>
                        {clientHomeworkLoading && <div className="cl-hint">Загружаю…</div>}
                        {!clientHomeworkLoading && clientHomework && (() => {
                          const hws = clientHomework.homeworks || []
                          const sm = clientHomework.summary || {}
                          const ST = {
                            assigned: { t: 'Задано', bg: '#EFF6FF', c: '#1D4ED8' },
                            in_progress: { t: 'В работе', bg: '#FFF7ED', c: '#B45309' },
                            submitted: { t: 'Сдано', bg: '#F5F3FF', c: '#6D28D9' },
                            checked: { t: 'Проверено', bg: '#ECFDF5', c: '#047857' },
                          }
                          const fmtTime = (s) => { s = Number(s) || 0; if (s < 60) return s + ' сек'; const m = Math.floor(s / 60); return m < 60 ? m + ' мин' : Math.floor(m / 60) + ' ч ' + (m % 60) + ' мин' }
                          const fmtDate = (d) => { if (!d) return ''; try { return new Date(d.replace(' ', 'T')).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' }) } catch { return d.slice(0, 10) } }
                          // средняя оценка по проверенным ДЗ (grade — число)
                          const grades = hws.map(h => Number(h.grade)).filter(g => Number.isFinite(g) && g > 0)
                          const avgGrade = grades.length ? (grades.reduce((a, b) => a + b, 0) / grades.length) : null
                          if (hws.length === 0) return <div className="cl-hint">Домашних заданий пока нет</div>
                          return (
                            <>
                              <div style={{ display: 'flex', gap: 8, margin: '0 0 12px', flexWrap: 'wrap', alignItems: 'center' }}>
                                {avgGrade != null && <span style={{ fontSize: 12.5, fontWeight: 800, color: '#854D0E', background: '#FEF9C3', border: '1px solid #FDE68A', borderRadius: 999, padding: '4px 14px' }} title={'Средняя оценка по ' + grades.length + ' проверенным ДЗ'}>Средняя оценка: {avgGrade.toFixed(1)}</span>}
                                <span style={{ fontSize: 12, fontWeight: 700, color: '#334155', background: '#F1F5F9', borderRadius: 999, padding: '4px 12px' }}>Всего: {sm.total ?? hws.length}</span>
                                {(sm.active ?? 0) > 0 && <span style={{ fontSize: 12, fontWeight: 700, color: '#B45309', background: '#FFF7ED', borderRadius: 999, padding: '4px 12px' }}>В работе: {sm.active}</span>}
                                {(sm.checked ?? 0) > 0 && <span style={{ fontSize: 12, fontWeight: 700, color: '#047857', background: '#ECFDF5', borderRadius: 999, padding: '4px 12px' }}>Проверено: {sm.checked}</span>}
                              </div>
                              <div className="cl-llist">
                                {hws.map((h, i) => {
                                  const st = ST[h.status] || { t: h.status, bg: '#F1F5F9', c: '#64748b' }
                                  const pct = Number(h.percent) || 0
                                  return (
                                    <div key={i} style={{ padding: '11px 0', borderBottom: '1px solid #f1f5f9' }}>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 5 }}>
                                        <div style={{ fontSize: 13.5, fontWeight: 600, color: '#0f172a', flex: 1, minWidth: 0 }}>{h.title || 'Домашнее задание'}</div>
                                        {h.grade != null && String(h.grade) !== '' && <span style={{ flexShrink: 0, background: '#FEF9C3', color: '#854D0E', fontSize: 12, fontWeight: 800, borderRadius: 8, padding: '2px 9px' }} title="Оценка за домашнее задание">Оценка: {h.grade}</span>}
                                        <span style={{ flexShrink: 0, background: st.bg, color: st.c, fontSize: 10.5, fontWeight: 700, borderRadius: 999, padding: '2px 9px', whiteSpace: 'nowrap' }}>{st.t}</span>
                                      </div>
                                      <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 6 }}>
                                        {h.teacher_name || 'Преподаватель'} · {fmtDate(h.created_at)}
                                        {(Number(h.time_spent_sec) || 0) > 0 && <> · затрачено: {fmtTime(h.time_spent_sec)}</>}
                                      </div>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <div style={{ flex: 1, height: 7, borderRadius: 999, background: '#e2e8f0', overflow: 'hidden' }}>
                                          <div style={{ width: pct + '%', height: '100%', borderRadius: 999, background: pct >= 100 ? '#22c55e' : '#38BDF8', transition: 'width .3s' }} />
                                        </div>
                                        <span style={{ fontSize: 11.5, fontWeight: 700, color: '#475569', whiteSpace: 'nowrap' }}>{h.done_tasks}/{h.total_tasks} · {pct}%</span>
                                      </div>
                                    </div>
                                  )
                                })}
                              </div>
                            </>
                          )
                        })()}
                      </div>
                    )}
                    {clientTab === 'payments' && (
                      <div className="panel">
                        <h3>Оплаты</h3>
                        {clientPaymentsLoading && <div className="cl-hint">Загружаю…</div>}
                        {!clientPaymentsLoading && (!clientPayments || clientPayments.length === 0) && <div className="cl-hint">Платежей нет</div>}
                        {!clientPaymentsLoading && clientPayments && clientPayments.map((pmt, i) => {
                          const isIn = Number(pmt.summa) >= 0
                          return (
                            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 10, padding: '8px 0', borderBottom: '1px solid #f1f5f9' }}>
                              <div style={{ minWidth: 0 }}>
                                <div style={{ fontSize: 13, color: '#334155' }}>{fmtDateOnly(pmt.date)}</div>
                                <div style={{ fontSize: 12, color: '#94a3b8' }}>{pmt.user_subscription_id ? ('Покупка абонемента №' + pmt.user_subscription_id) : pmt.comment === 'На баланс' ? 'Пополнение (через МойКласс)' : (pmt.comment && pmt.comment.indexOf('Авто-пополнение баланса (платформа)') === 0) ? 'Авто-пополнение баланса с привязанной карты' : (pmt.comment && pmt.comment.indexOf('Пополнение баланса (платформа)') === 0) ? 'Пополнение баланса (картой)' : (pmt.comment || (isIn ? 'Поступление' : 'Списание'))}</div>
                              </div>
                              <div style={{ fontWeight: 700, whiteSpace: 'nowrap', color: isIn ? '#047857' : '#B91C1C' }}>{isIn ? '+' : ''}{Number(pmt.summa).toLocaleString('ru')} ₽</div>
                            </div>
                          )
                        })}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )}

      {deleteLesson && (
        <DeleteLessonModal
          lesson={deleteLesson}
          allLessons={clientDetail && clientDetail.lessons}
          studentId={selClientId}
          onClose={() => setDeleteLesson(null)}
          onDeleted={() => { api.get('/api/platform/support-clients/' + selClientId).then(r => setClientDetail(r.data)).catch(() => {}) }}
        />
      )}
      {refuseModal && (
        <RefuseModal
          client={refuseModal}
          onClose={() => setRefuseModal(null)}
          onDone={() => { const t = refuseModal && refuseModal.fromTask; if (t) resolve(t, 'отказ'); else reloadClientDetail() }}
        />
      )}
      {rescheduleLesson && (
        <RescheduleLessonModal
          studentId={selClientId}
          lesson={rescheduleLesson}
          onClose={() => setRescheduleLesson(null)}
          onDone={() => { setRescheduleLesson(null); reloadClientDetail() }}
        />
      )}
      {addLessonsFor && (
        <AddLessonsModal
          studentId={addLessonsFor.studentId}
          clientName={addLessonsFor.name}
          paid={addLessonsFor.paid}
          grade={(clientDetail && clientDetail.grade) || addLessonsFor.grade}
          onClose={() => setAddLessonsFor(null)}
          onDone={() => { setAddLessonsFor(null); reloadClientDetail() }}
        />
      )}
      {changeTeacherLesson && (
        <ChangeTrialTeacherModal
          studentId={selClientId}
          lesson={changeTeacherLesson}
          onClose={() => setChangeTeacherLesson(null)}
          onDone={() => { setChangeTeacherLesson(null); reloadClientDetail() }}
        />
      )}

      {libOpen && <LibraryUploadModal onClose={() => setLibOpen(false)} />}
      {editModal && (
        <EditClientModal
          client={editModal}
          onClose={() => setEditModal(null)}
          onSaved={() => { api.get('/api/platform/support-clients/' + selClientId).then(r => setClientDetail(r.data)).catch(() => {}) }}
        />
      )}
      {paidPickerOpen && (
        <PaidPickerModal
          studentId={selClientId}
          clientName={clientDetail?.name}
          grade={clientDetail?.grade}
          onClose={() => setPaidPickerOpen(false)}
          onContinue={({ subject, price }) => {
            setPaidPickerOpen(false)
            setPaidBookModal({ subject, price, classNum: clientDetail?.grade || null })
          }}
        />
      )}

      {paidBookModal && (
        <TrialSignupModal showAllTeachers
          open={!!paidBookModal}
          onClose={() => setPaidBookModal(null)}
          title="Запись на платный урок"
          priceBadge={`Урок по ${paidBookModal.price} ₽`}
          submitLabel="Далее →"
          clientLabel={`${clientDetail?.name || ''} · ${paidBookModal.subject}`}
          initial={{ subject: paidBookModal.subject, classNum: paidBookModal.classNum, priceOverride: paidBookModal.price }}   // цена → окно фильтрует группу: 600 = платформенные, 1200 = Лидеры (28.09)
          onSubmit={(params) => {
            setPaidSlot({
              ...paidBookModal,
              teacherMkId: params.teacherMkId,
              teacherName: params.teacherName,
              date: params.date,
              time: params.time,
            })
            setPaidBookModal(null)
          }}
        />
      )}

      {paidSlot && (
        <PaidUntilModal
          slot={paidSlot}
          clientName={clientDetail?.name}
          onClose={() => setPaidSlot(null)}
          onConfirm={handleCreatePaid}
        />
      )}

      {trialPickerOpen && (
        <TrialPickerModal
          clientName={clientDetail?.name}
          onClose={() => setTrialPickerOpen(false)}
          onContinue={({ subject }) => { setTrialPickerOpen(false); setTrialBookModal({ subject, classNum: clientDetail?.grade || null }) }}
        />
      )}

      {trialBookModal && (
        <TrialSignupModal showAllTeachers freeTrialOption
          open={!!trialBookModal}
          onClose={() => setTrialBookModal(null)}
          clientLabel={`${clientDetail?.name || ''} · ${trialBookModal.subject}`}
          initial={{ subject: trialBookModal.subject, classNum: trialBookModal.classNum }}
          onSubmit={handleBookTrial}
        />
      )}

      {coldBook && coldDeal && (
        <TrialSignupModal showAllTeachers
          open={!!coldBook}
          onClose={() => setColdBook(null)}
          clientLabel={(coldDeal.parentName || coldDeal.name || '') + (coldBook.subject ? ' · ' + coldBook.subject : '')}
          initial={{ subject: coldBook.subject, classNum: coldBook.classNum }}
          onSubmit={handleColdBook}
        />
      )}

      {newClientModalOpen && (
        <NewClientModal
          initial={newClientInitial}
          onClose={() => { setNewClientModalOpen(false); setNewClientInitial(null) }}
          onOpenExisting={handleOpenExistingFromLookup}
          onContinue={handleContinueNewClient}
          onCreateOnly={(d) => { setNewClientModalOpen(false); setNewClientMsg('Ученик создан без пробного' + (d && d.clientName ? ' — ' + d.clientName : '')); }}
        />
      )}

      {newClientPending && (
        <TrialSignupModal showAllTeachers freeTrialOption
          open={!!newClientPending}
          onClose={() => setNewClientPending(null)}
          clientLabel={newClientPending.clientLabel}
          initial={{ subject: newClientPending.subject, classNum: newClientPending.classNum }}
          onSubmit={handleBookNewClient}
        />
      )}

      {view === 'tutors' && (
        <div className="sopwrap" style={{ gridTemplateColumns: '1fr', maxWidth: 760, margin: '0 auto', padding: '22px 16px 40px' }}>
          <div className="card" style={{ marginBottom: 16 }}>
            <div className="cl-phonesearch">
              <input
                placeholder="Телефон, ID или имя преподавателя…"
                value={tutorQuery}
                onChange={e => { setTutorQuery(e.target.value); if (selTutorId) { setSelTutorId(null); setTutorDetail(null) } }}
              />
              <button className="cl-newbtn" style={{ margin: 0, width: 'auto', padding: '0 18px' }} onClick={() => searchTutors(tutorQuery)}>Найти</button>
            </div>
          </div>

          {!selTutorId && tutorSearchStatus == null && <div className="card cl-hint" style={{ padding: 32 }}>Введите телефон, ID или имя, чтобы найти преподавателя</div>}
          {!selTutorId && tutorSearchStatus === 'searching' && <div className="card cl-hint" style={{ padding: 32 }}>Ищу…</div>}
          {!selTutorId && tutorSearchStatus === 'not_found' && <div className="card cl-hint" style={{ padding: 32 }}>Ничего не найдено</div>}

          {!selTutorId && tutorSearchStatus === 'found' && tutorResults.length > 0 && (
            <div className="card" style={{ padding: 8 }}>
              {tutorResults.map(r => (
                <button key={r.mkId} onClick={() => setSelTutorId(r.mkId)}
                  style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left', background: 'none', border: 0, borderRadius: 12, padding: '11px 12px', cursor: 'pointer', fontFamily: 'inherit' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f4f7fa'}
                  onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                  <div style={{ width: 34, height: 34, borderRadius: '50%', background: '#e2e8f0', color: '#475569', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, flexShrink: 0 }}>{(r.name || '?')[0]}</div>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.name || '—'}</div>
                    <div style={{ fontSize: 12.5, color: '#64748b' }}>{r.phone || '—'} · ID {r.mkId}</div>
                  </div>
                </button>
              ))}
            </div>
          )}

          {selTutorId && (
            <div className="card cl-col">
              <button onClick={() => { setSelTutorId(null); setTutorDetail(null) }}
                style={{ alignSelf: 'flex-start', background: 'none', border: 0, color: '#38BDF8', cursor: 'pointer', fontSize: 13.5, fontWeight: 600, padding: '10px 12px 0', fontFamily: 'inherit' }}>
                ← К результатам поиска
              </button>
              {tutorDetailLoading && <div className="cl-hint" style={{ padding: 24 }}>Загружаю карточку…</div>}
              {!tutorDetailLoading && tutorDetail && (
                <>
                  <div className="chead">
                    <div className="ava">{(tutorDetail.name || '?')[0]}</div>
                    <div className="ttl">
                      <b>{tutorDetail.name}</b>
                      <div className="sub">{tutorDetail.phone || '—'}</div>
                      {/* Чат кабинета преподавателя (admin-chat role=teacher): сообщение в ЛК препода + пуш. */}
                      <button onClick={() => setAdminSel({ role: 'teacher', mkId: Number(tutorDetail.id), name: tutorDetail.name })} title="Написать преподавателю в личный кабинет (придёт в кабинет + пуш)" style={{ background: 'none', border: 0, padding: 0, cursor: 'pointer', color: '#7C3AED', fontSize: 11.5, fontWeight: 500 }}>💬 ЛК: {tutorDetail.name} ↗</button>
                      <div style={{ marginTop: 3, fontSize: 11.5, color: '#94a3b8', lineHeight: 1.5 }}>
                        Активность в ЛК: {tutorDetail.last_login_at ? fmtLkActivity(tutorDetail.last_login_at) : 'не входил'}
                        {' · '}в МК с {tutorDetail.created_at ? fmtDateOnly(tutorDetail.created_at) : '—'}
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 6, padding: '0 16px', borderBottom: '1px solid #eef2f7' }}>
                    <button onClick={() => setTutorTab('lessons')}
                      style={{ background: 'none', border: 0, borderBottom: tutorTab === 'lessons' ? '2px solid #38BDF8' : '2px solid transparent', color: tutorTab === 'lessons' ? '#0f172a' : '#64748b', fontWeight: 600, fontSize: 13.5, padding: '10px 8px', cursor: 'pointer', fontFamily: 'inherit' }}>
                      Ближайшие занятия
                    </button>
                    <button onClick={() => setTutorTab('students')}
                      style={{ background: 'none', border: 0, borderBottom: tutorTab === 'students' ? '2px solid #38BDF8' : '2px solid transparent', color: tutorTab === 'students' ? '#0f172a' : '#64748b', fontWeight: 600, fontSize: 13.5, padding: '10px 8px', cursor: 'pointer', fontFamily: 'inherit' }}>
                      Ученики
                    </button>
                    <button onClick={() => setTutorTab('slots')}
                      style={{ background: 'none', border: 0, borderBottom: tutorTab === 'slots' ? '2px solid #38BDF8' : '2px solid transparent', color: tutorTab === 'slots' ? '#0f172a' : '#64748b', fontWeight: 600, fontSize: 13.5, padding: '10px 8px', cursor: 'pointer', fontFamily: 'inherit' }}>
                      Слоты
                    </button>
                  </div>
                  <div className="body" style={{ display: 'block' }}>
                    {tutorTab === 'lessons' && (
                      <div className="panel">
                        <h3>Ближайшие занятия</h3>
                        <div className="cl-llist">
                          {(tutorDetail.lessons || []).length === 0 && <div className="cl-hint">Нет запланированных занятий</div>}
                          {(tutorDetail.lessons || []).map((l, i) => {
                            const start = l.begin_time || l.time
                            const tr = start ? (start + (l.end_time ? '–' + l.end_time : '')) : ''
                            return (
                            <div className="cl-litem" key={i} style={{ flexDirection: 'column', alignItems: 'stretch', gap: 2 }}>
                              <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <div style={{ fontWeight: 600 }}>{l.subject || 'Урок'}</div>
                                <div style={{ marginLeft: 'auto', color: '#64748b', fontSize: 13 }}>{fmtDateOnly(l.date)}</div>
                              </div>
                              <div style={{ fontSize: 12.5, color: '#64748b' }}>{tr}{l.student_name ? (tr ? ' · ' : '') + l.student_name : ''}</div>
                            </div>
                            )
                          })}
                        </div>
                      </div>
                    )}
                    {tutorTab === 'students' && (
                      <div className="panel">
                        <h3>Ученики</h3>
                        {tutorStudentsLoading && <div className="cl-hint">Загружаю…</div>}
                        {!tutorStudentsLoading && tutorStudents && (() => {
                          const active = tutorStudents.filter(s => s.active)
                          const finished = tutorStudents.filter(s => !s.active)
                          const renderStud = (s) => (
                            <div className="cl-litem" key={s.id}
                              onClick={() => { setSelClientId(s.id); setClientDetail(null); setView('clients') }}
                              onMouseEnter={e => e.currentTarget.style.background = '#f4f7fa'}
                              onMouseLeave={e => e.currentTarget.style.background = ''}
                              title="Открыть карточку ученика"
                              style={{ flexDirection: 'column', alignItems: 'stretch', gap: 2, cursor: 'pointer' }}>
                              <div style={{ fontWeight: 600 }}>{s.name}{s.grade ? ' · ' + s.grade + ' кл' : ''} <span style={{ color: '#cbd5e1', fontWeight: 400 }}>›</span></div>
                              <div style={{ fontSize: 12.5, color: '#64748b' }}>{s.phone || '—'}{s.next_lesson ? ' · след. ' + fmtDateOnly(s.next_lesson.date) + (s.next_lesson.time ? ' ' + s.next_lesson.time : '') : ''}</div>
                            </div>
                          )
                          return (
                            <>
                              {tutorStudents.length === 0 && <div className="cl-hint">Нет учеников</div>}
                              {active.length > 0 && <div style={{ fontSize: 12, fontWeight: 700, color: '#047857', margin: '4px 0 6px' }}>Занимается ({active.length})</div>}
                              <div className="cl-llist">{active.map(renderStud)}</div>
                              {finished.length > 0 && <div style={{ fontSize: 12, fontWeight: 700, color: '#94a3b8', margin: '12px 0 6px' }}>Закончил ({finished.length})</div>}
                              <div className="cl-llist">{finished.map(renderStud)}</div>
                            </>
                          )
                        })()}
                      </div>
                    )}
                    {tutorTab === 'slots' && (
                      <div className="panel">
                        <h3>Слоты</h3>
                        {(() => {
                          const d = tutorSlots
                          const WD = ['Пн','Вт','Ср','Чт','Пт','Сб','Вс']
                          const MON = ['янв','фев','мар','апр','май','июн','июл','авг','сен','окт','ноя','дек']
                          const pad = (n) => String(n).padStart(2, '0')
                          const fmtMin = (t) => pad(Math.floor(t/60)) + ':' + pad(t%60)
                          const minOfHHMM = (v) => { const a = String(v).split(':'); return (Number(a[0])||0)*60 + (Number(a[1])||0) }
                          const parseISO = (iso) => { const a = iso.split('-'); return new Date(Date.UTC(Number(a[0]), Number(a[1])-1, Number(a[2]))) }
                          const isoOf = (dt) => dt.toISOString().slice(0,10)
                          const arrowBtn = { width:32, height:32, borderRadius:8, border:'1px solid #e2e8f0', background:'#fff', color:'#0f172a', fontSize:18, cursor:'pointer', fontFamily:'inherit', lineHeight:1 }
                          const nowD = new Date()
                          const todayIso = isoOf(new Date(Date.UTC(nowD.getFullYear(), nowD.getMonth(), nowD.getDate())))
                          const base = d && d.week_start ? parseISO(d.week_start) : null
                          const rangeLabel = base ? (base.getUTCDate() + ' ' + MON[base.getUTCMonth()] + ' – ' + new Date(base.getTime()+6*86400000).getUTCDate() + ' ' + MON[new Date(base.getTime()+6*86400000).getUTCMonth()]) : ''
                          const header = (
                            <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:12, margin:'2px 0 10px' }}>
                              <button style={arrowBtn} onClick={() => setTutorSlotsWeek(w => w - 1)}>‹</button>
                              <div style={{ minWidth:170, textAlign:'center', fontWeight:700, fontSize:13.5 }}>{rangeLabel || '—'}{tutorSlotsWeek === 0 && <span style={{ color:'#38BDF8' }}> · текущая</span>}{tutorSlotsLoading && <span style={{ color:'#94a3b8' }}> · …</span>}</div>
                              <button style={arrowBtn} onClick={() => setTutorSlotsWeek(w => w + 1)}>›</button>
                            </div>
                          )
                          if (!d || !base) return tutorSlotsLoading ? <div className="cl-hint">Загружаю…</div> : <><div className="cl-hint">Не удалось загрузить слоты</div></>
                          const days = []
                          for (let i=0;i<7;i++){ const dt = new Date(base.getTime()+i*86400000); days.push({ iso: isoOf(dt), wd: WD[i], dd: dt.getUTCDate(), mon: MON[dt.getUTCMonth()] }) }
                          const free = d.free || [], busy = d.busy || []
                          let lo = 480, hi = 1320
                          free.forEach(f => { const m = minOfHHMM(f.begin_time); if (m < lo) lo = m; if (m+30 > hi) hi = m+30 })
                          busy.forEach(b => { if (b.from_minutes < lo) lo = b.from_minutes; if (b.to_minutes > hi) hi = b.to_minutes })
                          lo = Math.max(360, Math.floor(lo/30)*30); hi = Math.min(1410, Math.ceil(hi/30)*30)
                          if (hi <= lo) { lo = 480; hi = 1320 }
                          const rows = []; for (let t=lo; t<hi; t+=30) rows.push(t)
                          const freeSet = new Set(free.map(f => f.date + '@' + (Math.floor(minOfHHMM(f.begin_time)/30)*30)))
                          const isBusy = (iso, t) => busy.some(b => b.date === iso && b.from_minutes < t+30 && b.to_minutes > t)
                          // урок по стартовому слоту (имя ученика показываем в первой ячейке урока)
                          const lessons = d.lessons || []
                          const lessonStart = new Map()
                          lessons.forEach(l => { const s = Math.floor(minOfHHMM(l.begin_time)/30)*30; if (!lessonStart.has(l.date + '@' + s)) lessonStart.set(l.date + '@' + s, l) })
                          const shortName = (n) => { const p = String(n || '').trim().split(/\s+/); return p.length >= 2 ? (p[0] + ' ' + p[1].charAt(0) + '.') : (p[0] || '') }
                          const cellStyle = (kind) => ({ minHeight:20, borderRadius:4, background: kind==='busy' ? '#fecaca' : kind==='free' ? '#bbf7d0' : '#f1f5f9', border: kind==='busy' ? '1px solid #f87171' : kind==='free' ? '1px solid #4ade80' : '1px solid #e8edf3', display:'flex', alignItems:'center', justifyContent:'center', overflow:'hidden' })
                          return (
                            <>
                              {header}
                              <div style={{ display:'flex', gap:16, justifyContent:'center', margin:'0 0 10px', fontSize:12, color:'#64748b' }}>
                                <span><span style={{ display:'inline-block', width:11, height:11, borderRadius:3, background:'#bbf7d0', border:'1px solid #4ade80', marginRight:5, verticalAlign:'-1px' }}></span>свободно</span>
                                <span><span style={{ display:'inline-block', width:11, height:11, borderRadius:3, background:'#fecaca', border:'1px solid #f87171', marginRight:5, verticalAlign:'-1px' }}></span>урок (имя ученика)</span>
                              </div>
                              <div style={{ overflowX:'auto' }}>
                                <table style={{ borderCollapse:'separate', borderSpacing:3, width:'100%', minWidth:540 }}>
                                  <thead>
                                    <tr>
                                      <th style={{ width:42 }}></th>
                                      {days.map(dd => (
                                        <th key={dd.iso} style={{ fontSize:11.5, fontWeight:700, color: dd.iso === todayIso ? '#0ea5e9' : '#64748b', padding:'2px 0' }}>
                                          {dd.wd}<br /><span style={{ fontWeight:600, color:'#94a3b8' }}>{dd.dd} {dd.mon}</span>
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {rows.map(t => (
                                      <tr key={t}>
                                        <td style={{ fontSize:11, color:'#94a3b8', textAlign:'right', paddingRight:6, whiteSpace:'nowrap' }}>{t%60===0 ? fmtMin(t) : ''}</td>
                                        {days.map(dd => {
                                          const b = isBusy(dd.iso, t)
                                          const fr = !b && freeSet.has(dd.iso + '@' + t)
                                          const kind = b ? 'busy' : fr ? 'free' : 'empty'
                                          const les = b ? lessonStart.get(dd.iso + '@' + t) : null
                                          const tip = les
                                            ? (dd.wd + ' ' + les.begin_time + (les.end_time ? '–' + les.end_time : '') + ' · ' + (les.student_name || 'ученик') + (les.subject ? ' · ' + les.subject : '') + (les.is_trial ? ' · пробный' : ''))
                                            : (dd.wd + ' ' + fmtMin(t) + ' — ' + (kind==='busy'?'занято':kind==='free'?'свободно':'—'))
                                          return (
                                            <td key={dd.iso}>
                                              <div style={cellStyle(kind)} title={tip}>
                                                {les && <span style={{ fontSize:9, lineHeight:1.05, fontWeight:600, color: les.is_trial ? '#b45309' : '#991b1b', padding:'0 2px', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', maxWidth:'100%' }}>{shortName(les.student_name) || '•'}</span>}
                                              </div>
                                            </td>
                                          )
                                        })}
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                              <div style={{ fontSize:11.5, color:'#94a3b8', marginTop:8 }}>Свободно — окошки, которые преподаватель открыл в личном кабинете. Занято — уроки и блокировки из МойКласс.</div>
                            </>
                          )
                        })()}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )}

      {!isWriter && view === 'trials' && (
        <div className="sopwrap" style={{ gridTemplateColumns: '1fr', maxWidth: 700, margin: '0 auto', padding: '22px 16px 40px' }}>
          <div className="tr-kpirow" style={{ gridTemplateColumns: 'repeat(4,1fr)' }}>
            <div className={'tr-kpi' + (trialPeriod === 'yesterday' ? ' on' : '')} onClick={() => setTrialPeriod('yesterday')}>
              <div className="num">{yesterdayCount}</div>
              <div className="lbl">Вчера{yesterdayNeedsFollowup > 0 ? ' · ' + yesterdayNeedsFollowup + ' требуют внимания' : ''}</div>
            </div>
            <div className={'tr-kpi' + (trialPeriod === 'today' ? ' on' : '')} onClick={() => setTrialPeriod('today')}>
              <div className="num">{trialCounts.today}</div>
              <div className="lbl">Сегодня</div>
            </div>
            <div className={'tr-kpi' + (trialPeriod === 'tomorrow' ? ' on' : '')} onClick={() => setTrialPeriod('tomorrow')}>
              <div className="num">{trialCounts.tomorrow}</div>
              <div className="lbl">Завтра</div>
            </div>
            <div className={'tr-kpi' + (trialPeriod === 'week' ? ' on' : '')} onClick={() => setTrialPeriod('week')}>
              <div className="num">{trialCounts.week}</div>
              <div className="lbl">Всего за неделю</div>
            </div>
          </div>

          {trialsLoading && <div className="cl-hint">Загружаю пробные уроки…</div>}
          {!trialsLoading && filteredTrials.length === 0 && <div className="cl-hint">На этот период пробных уроков нет</div>}

          {Object.keys(trialsByDay).sort().map(day => (
            <div key={day}>
              <div className="tr-dayhead">{trialDayLabel(day)}</div>
              {trialsByDay[day].map(t => {
                const notStayed = t.status === 'done' && t.needsFollowup
                const st = notStayed ? ['notstayed', 'Прошёл · не остался'] : (TRIAL_STATUS[t.status] || TRIAL_STATUS.planned)
                return (
                  <div className="tr-card" key={t.id}>
                    <div className="tr-thead">
                      <div className="tr-time">{t.time ? t.time.slice(0, 5) : '—'}</div>
                      <div className="tr-ava">{(t.clientName || '?')[0]}</div>
                      <div className="tr-who">
                        <div className="tr-nm">{t.clientName}</div>
                        <div className="tr-phone">{t.clientPhone}</div>
                        {t.childPhone && <div className="tr-phone">📱 ребёнок: {t.childPhone}</div>}
                        <div className="tr-subj">{t.subject}{t.grade ? ', ' + t.grade + (/^\d+$/.test(t.grade) ? ' класс' : '') : ''}</div>
                      </div>
                      <div className="tr-theadright">
                        <span className={'tr-st ' + st[0]}>{st[1]}</span>
                        {(t.status === 'noshow' || notStayed) ? (
                          <button className="iconbtn" title="Открыть задачу" onClick={() => setTrialModal({ type: 'task', item: t })}>📋</button>
                        ) : (
                          <button className="iconbtn" title="Открыть карточку клиента" onClick={() => setTrialModal({ type: 'client', item: t })}>👤</button>
                        )}
                      </div>
                    </div>
                    <div className="tr-infopanel">
                      <div className="tr-irow">
                        <span className="k">Записан на</span>
                        <span className="v">
                          {t.replacementStatus === 'direct' && (t.assignedTeacher || '—')}
                          {t.replacementStatus === 'assigned' && t.assignedTeacher + ' (замена)'}
                          {t.replacementStatus === 'searching' && <span className="muted">— идёт подбор преподавателя</span>}
                          {t.replacementStatus === 'not_found' && <span className="muted">— преподаватель не найден</span>}
                          {t.replacementStatus === 'not_started' && <span className="muted">— подбор ещё не запускался</span>}
                        </span>
                      </div>
                      <div className="tr-irow">
                        <span className="k">Подтвердил препод</span>
                        {t.replacementStatus === 'direct' && <span className="v yes">✅ да</span>}
                        {t.replacementStatus === 'assigned' && <span className="v yes">✅ да</span>}
                        {t.replacementStatus === 'searching' && <span className="v wait">⏳ ждём{t.waitingCandidate ? ' (' + t.waitingCandidate + ')' : ''}</span>}
                        {t.replacementStatus === 'not_found' && <span className="v no">❌ нет{t.rejectedNames.length ? ' (' + t.rejectedNames.join(', ') + ')' : ''}</span>}
                        {t.replacementStatus === 'not_started' && <span className="v muted">— подбор не запускался</span>}
                      </div>
                      <div className="tr-irow">
                        <span className="k">Клиент подтвердил (за 1ч)</span>
                        <span className={'v ' + (t.clientConfirmed ? 'yes' : 'muted')}>{t.clientConfirmed ? '✅ да' : '— ещё рано'}</span>
                      </div>
                      <div className="tr-irow">
                        <span className="k">Уведомления</span>
                        <span className={'v ' + (t.notified ? 'yes' : 'muted')}>{t.notified ? '✅ отправлены' : '— ещё рано'}</span>
                      </div>
                      {t.status === 'done' && (
                        <>
                          <div className="tr-irow">
                            <span className="k">Выбор после урока</span>
                            {t.trialChoice === 'keep' && <span className="v yes">нажал «Остаюсь с ним»</span>}
                            {t.trialChoice === 'other' && <span className="v no">нажал «Хочу другого»</span>}
                            {!t.trialChoice && <span className="v muted">— не выбрал</span>}
                          </div>
                          <div className="tr-irow">
                            <span className="k">Продолжил на постоянной основе</span>
                            {t.stayed === true && <span className="v yes">да</span>}
                            {t.stayed === false && <span className="v no">нет, постоянный урок не записан</span>}
                            {t.stayed == null && <span className="v muted">— скоро узнаем</span>}
                          </div>
                        </>
                      )}
                    </div>
                    {notStayed && (
                      <div className={'tasktag ' + (t.trialChoice === 'other' ? 'r' : 'o')} onClick={() => setTrialModal({ type: 'task', item: t })}>
                        <span className="dotpulse"></span>задача уже в очереди — <span className="lnk">открыть в «Задачи»</span>
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          ))}
        </div>
      )}

      {view === 'discrepancies' && (
        <div className="sopwrap" style={{ gridTemplateColumns: '1fr', maxWidth: 900, margin: '0 auto', padding: '22px 16px 40px' }}>
          {discLoading && <div className="cl-hint" style={{ padding: 24 }}>Загружаю список…</div>}
          {!discLoading && (
            <>
              <div className="disc-kpirow">
                <div className="disc-kpi warn">
                  <div className="num">{discrepancies.filter(d => !d.resolved).length}</div>
                  <div className="lbl">клиентов, где МойКласс не сходится</div>
                </div>
                <div className="disc-kpi">
                  <div className="num">{new Intl.NumberFormat('ru-RU').format(discrepancies.filter(d => !d.resolved).reduce((s, d) => s + Math.abs(d.diff), 0))} ₽</div>
                  <div className="lbl">суммарно (не долг клиентам)</div>
                </div>
                <div className="disc-kpi crit">
                  <div className="num">{discrepancies.filter(d => !d.resolved && d.action === 'review').length}</div>
                  <div className="lbl">клиентов с долгом</div>
                </div>
              </div>

              <div className="disc-banner">
                ℹ️ Это <b>не долг клиентам</b> и не пропавшие деньги. Верный остаток — баланс платформы. МойКласс
                просто не узнаёт о списании за прошедший урок и показывает старую, б<i>о</i>льшую цифру. Поправьте
                вручную в МойКлассе (карточка клиента → «Оплаты и счета» → Списание/Начисление) и нажмите «Исправлено».
              </div>

              <div className="card">
                <div className="chead" style={{ padding: '12px 18px' }}>
                  <b style={{ fontSize: 14 }}>Все случаи, по убыванию расхождения</b>
                </div>
                {discrepancies.length === 0 && <div className="cl-hint" style={{ padding: 24 }}>Расхождений нет</div>}
                {discrepancies.filter(d => !d.resolved).map(d => (
                  <div className="disc-row" key={d.mk_user_id}>
                    <div className="disc-ava">{(d.name || '?')[0]}</div>
                    <div className="disc-who">
                      <div className="nm">{d.name}</div>
                      <div className="sub">{d.phone}</div>
                    </div>
                    <div className="disc-action">
                      {d.action === 'review' && (
                        <>
                          <div className="verb down">🔴 Долг у клиента</div>
                          <div className="cap">Платформа: {new Intl.NumberFormat('ru-RU').format(d.ledger_balance)} ₽ · МойКласс: {new Intl.NumberFormat('ru-RU').format(d.mk_balans)} ₽</div>
                        </>
                      )}
                      {d.action === 'debit' && (
                        <>
                          <div className="verb down">↓ Списать {new Intl.NumberFormat('ru-RU').format(d.diff)} ₽ в МойКлассе</div>
                          <div className="cap">МойКласс: <s>{new Intl.NumberFormat('ru-RU').format(d.mk_balans)} ₽</s> → должно быть {new Intl.NumberFormat('ru-RU').format(d.ledger_balance)} ₽</div>
                        </>
                      )}
                      {d.action === 'credit' && (
                        <>
                          <div className="verb up">↑ Начислить {new Intl.NumberFormat('ru-RU').format(Math.abs(d.diff))} ₽ в МойКлассе</div>
                          <div className="cap">МойКласс: <s>{new Intl.NumberFormat('ru-RU').format(d.mk_balans)} ₽</s> → должно быть {new Intl.NumberFormat('ru-RU').format(d.ledger_balance)} ₽</div>
                        </>
                      )}
                    </div>
                    <div className="disc-btns">
                      <a className="mklink" href={'https://app.moyklass.com/user/' + d.mk_user_id + '/payments'} target="_blank" rel="noopener noreferrer">МойКласс ↗</a>
                      <button
                        className="fixbtn"
                        disabled={discResolving === d.mk_user_id}
                        onClick={() => resolveDiscrepancy(d)}
                      >{d.action === 'review' ? 'Разобрать' : (discResolving === d.mk_user_id ? '…' : '✓ Исправлено')}</button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}

      {view === 'otbor' && <OtborTab />}

      {/* «Задачи» менеджера по преподавателям: плохие отзывы (26.10) */}
      {view === 'badreviews' && isTutors && <BadReviewsTab onOpenCalls={() => setView('otbor')} />}

      {/* «Анкеты» менеджера по преподавателям (22.10): перенос /admin/moderation.html, страница отдаётся СРМ (/api/anketi/page) */}
      {view === 'anketi' && isTutors && (
        <iframe title="Анкеты преподавателей" src={'/api/anketi/page'}   /* токен теперь в cookie, в адресе он оседал в журналах (27.10.2026) */
          style={{ width: '100%', height: 'calc(100vh - 60px)', border: 0, display: 'block' }} />
      )}

      {view === 'migration' && (
        <div className="sopwrap" style={{ gridTemplateColumns: '1fr', maxWidth: 760, margin: '0 auto', padding: '22px 16px 40px' }}>
          <h2 style={{ fontSize: 20, marginBottom: 6 }}>Перенос клиента из старого МойКласса</h2>
          <p style={{ fontSize: 13.5, color: '#64748B', marginBottom: 22, maxWidth: '62ch', lineHeight: 1.5 }}>
            Введите телефон в любом виде — +7, 8 или просто с девятки. Найдём человека
            в выгрузке старого МК и одной кнопкой заведём карточку у нас.
          </p>

          <div className="card">
            <div style={{ display: 'flex', gap: 10, padding: 20 }}>
              <input
                type="text" placeholder="Номер телефона"
                value={migPhone} onChange={e => setMigPhone(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') searchMigration() }}
                style={{ flex: 1, fontSize: 14, border: '1px solid #E2E8F0', borderRadius: 10, padding: '11px 14px', outline: 'none', fontFamily: 'inherit' }}
              />
              <button onClick={searchMigration} disabled={migLoading}
                style={{ background: '#38BDF8', color: '#fff', border: 0, borderRadius: 10, padding: '0 20px', fontSize: 13.5, fontWeight: 700, cursor: 'pointer' }}
              >{migLoading ? 'Ищу…' : 'Найти в старом МК'}</button>
              {(migFound || migResult) && (
                <button onClick={resetMigration}
                  style={{ background: '#F1F5F9', color: '#334155', border: 0, borderRadius: 10, padding: '0 16px', fontSize: 13.5, fontWeight: 600, cursor: 'pointer' }}
                >Сброс</button>
              )}
            </div>
          </div>

          {migError && (
            <div className="mbanner" style={{ marginTop: 16, background: '#FEF2F2', color: '#B91C1C', border: '1px solid #FECACA' }}>{migError}</div>
          )}

          {migFound && migFound.items.map((c, idx) => (
            <div className="card" key={idx} style={{ marginTop: 18 }}>
              <div className="chead">
                <div className="ava">{(c.name || '?')[0]}</div>
                <div className="ttl">
                  <b>{c.name}</b>
                  <div className="sub">{c.phone || migPhone} · карточка № {c.client_no || '—'} (старый МК)</div>
                </div>
                <span style={{ marginLeft: 'auto', fontSize: 11.5, fontWeight: 700, padding: '4px 10px', borderRadius: 999,
                  background: migFound.already_on_platform ? '#DCFCE7' : '#FEF3C7',
                  color: migFound.already_on_platform ? '#15803D' : '#B45309' }}>
                  {migFound.already_on_platform ? 'уже у нас' : 'ещё не у нас'}
                </span>
              </div>
              <div className="body" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div className="panel">
                  <h3>Данные из старого МК</h3>
                  <div className="row"><span className="k">Ученик</span><span className="v">{c.name || '—'}</span></div>
                  <div className="row"><span className="k">Родитель</span><span className="v">{c.parent_name || '—'}</span></div>
                  <div className="row"><span className="k">Телефон</span><span className="v">{c.phone || '—'}</span></div>
                  <div className="row"><span className="k">Телефон родителя</span><span className="v">{c.parent_phone || '—'}</span></div>
                  <div className="row"><span className="k">Почта</span><span className="v">{c.email || '—'}</span></div>
                  <div className="row"><span className="k">Класс</span><span className="v">{c.grade || '—'}</span></div>
                  <div className="row"><span className="k">Город</span><span className="v">{c.city || '—'}</span></div>
                  <div className="row"><span className="k">Статус в старом МК</span><span className="v">{c.status || '—'}</span></div>
                  <div className="row"><span className="k">Ответственный</span><span className="v">{c.manager || '—'}</span></div>
                  <div className="row"><span className="k">Источник</span><span className="v">{c.came_from || '—'}</span></div>
                </div>

                <div className="panel">
                  <h3>История занятий</h3>
                  <div className="row"><span className="k">Посещений</span><span className="v">{c.visits}</span></div>
                  <div className="row"><span className="k">Записей на уроки</span><span className="v">{c.records}</span></div>
                  <div className="row"><span className="k">Занимался</span><span className="v">{c.first_visit || '—'} — {c.last_visit || '—'}</span></div>
                  <div className="row"><span className="k">Оплачено всего</span><span className="v">{new Intl.NumberFormat('ru-RU').format(c.paid_total || 0)} ₽</span></div>
                  <div className="row"><span className="k">Баланс в старом МК</span><span className="v">{new Intl.NumberFormat('ru-RU').format(c.balance || 0)} ₽</span></div>
                  {c.debt_total > 0 && <div className="row"><span className="k">Долг</span><span className="v" style={{ color: '#B91C1C' }}>{new Intl.NumberFormat('ru-RU').format(c.debt_total)} ₽</span></div>}
                </div>

                {idx === 0 && migFound.teachers && migFound.teachers.length > 0 && (
                  <div className="panel">
                    <h3>У кого занимался</h3>
                    {migFound.teachers.map((t, i) => (
                      <div className="row" key={i}>
                        <span className="k">{t.teacher}{t.subject ? ' · ' + t.subject : ''}</span>
                        <span className="v">
                          {t.visits} зан.
                          <span style={{ marginLeft: 8, fontSize: 11, fontWeight: 700, borderRadius: 999, padding: '2px 8px',
                            background: t.with_us ? '#DCFCE7' : '#F1F5F9', color: t.with_us ? '#15803D' : '#94A3B8' }}>
                            {t.with_us ? 'есть у нас' : 'не работает'}
                          </span>
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                {c.comments && (
                  <div className="panel">
                    <h3>Комментарии</h3>
                    <div style={{ fontSize: 13, color: '#475569', lineHeight: 1.55, whiteSpace: 'pre-wrap' }}>{c.comments}</div>
                  </div>
                )}

                {!migResult && idx === 0 && (
                  migFound.already_on_platform ? (
                    <div className="mbanner" style={{ background: '#EFF6FF', color: '#1D4ED8', border: '1px solid #BFDBFE' }}>
                      Клиент уже заведён у нас (МК ID {migFound.platform_mk_id}
                      {migFound.platform_name ? ', ' + migFound.platform_name : ''}). Кнопка ниже только
                      поставит ему бейдж «из старого МК» и подтянет чаты.
                    </div>
                  ) : null
                )}

                {!migResult && idx === 0 && (
                  <button onClick={runMigration} disabled={migRunning}
                    style={{ background: '#22C55E', color: '#fff', border: 0, borderRadius: 12, padding: '13px 20px', fontSize: 14, fontWeight: 800, cursor: 'pointer' }}
                  >{migRunning ? 'Создаю…' : 'Создать карточку в СРМ'}</button>
                )}
              </div>
            </div>
          ))}

          {migResult && (
            <div className="card" style={{ marginTop: 18 }}>
              <div className="body">
                <div className="mbanner" style={{ background: '#DCFCE7', color: '#15803D', border: '1px solid #BBF7D0' }}>
                  {migResult.created ? 'Карточка создана' : 'Клиент уже был у нас'} — {migResult.name || ''} (МК ID {migResult.mk_id}).
                  Бейдж «ученик из старого МК» проставлен.
                  {migResult.linked_chats && (migResult.linked_chats.max + migResult.linked_chats.tg > 0)
                    ? ` Привязано чатов: MAX — ${migResult.linked_chats.max}, Telegram — ${migResult.linked_chats.tg}.`
                    : ' Чатов с этим номером не нашлось.'}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {mergeOpen && (
        <div className="overlay" onClick={e => { if (e.target === e.currentTarget) setMergeOpen(false) }}>
          <div className="modal" style={{ maxWidth: 560 }}>
            <div className="mhead">
              <div className="ava">🧬</div>
              <div className="ttl">
                <b>Объединить дубли</b>
                <div className="sub">Карточка останется эта: {(clientDetail && clientDetail.name) || ''}</div>
              </div>
              <div className="x" onClick={() => setMergeOpen(false)}>✕</div>
            </div>
            <div className="mbody">
              {!mergeDone && (
                <>
                  <div style={{ fontSize: 13.5, color: '#475569', marginBottom: 12 }}>
                    С каким клиентом объединить эту карточку? Введите имя или телефон.
                  </div>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                    <input
                      type="text" placeholder="Имя или телефон" value={mergeQuery}
                      onChange={e => setMergeQuery(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Enter') searchMergeCandidates() }}
                      style={{ flex: 1, fontSize: 14, border: '1px solid #E2E8F0', borderRadius: 10, padding: '10px 12px', outline: 'none', fontFamily: 'inherit' }}
                    />
                    <button onClick={searchMergeCandidates} disabled={mergeBusy}
                      style={{ background: '#38BDF8', color: '#fff', border: 0, borderRadius: 10, padding: '0 16px', fontSize: 13.5, fontWeight: 700, cursor: 'pointer' }}>
                      {mergeBusy ? '…' : 'Найти'}
                    </button>
                  </div>

                  {mergeFound.length > 0 && !mergePreview && mergeFound.map(c => (
                    <div key={c.mk_id} onClick={() => pickMergeCandidate(c)}
                      style={{ cursor: 'pointer', padding: '10px 12px', borderRadius: 10, border: '1px solid #EEF2F6', marginBottom: 8, background: mergePick && mergePick.mk_id === c.mk_id ? '#EFF6FF' : '#fff' }}>
                      <div style={{ fontWeight: 600, fontSize: 14 }}>{c.name}</div>
                      <div style={{ fontSize: 12.5, color: '#94A3B8' }}>
                        {c.phone || 'без телефона'} · баланс {new Intl.NumberFormat('ru-RU').format(c.balance || 0)} ₽ · уроков впереди {c.lessons}
                      </div>
                    </div>
                  ))}

                  {mergePreview && (
                    <div className="mpanel" style={{ marginTop: 4 }}>
                      <div className="mrow"><span className="k">Остаётся</span><span className="v">{mergePreview.primary.name}</span></div>
                      <div className="mrow"><span className="k">Присоединяем</span><span className="v">{mergePreview.duplicate.name}</span></div>
                      <div className="mrow"><span className="k">Баланс сейчас</span><span className="v">{new Intl.NumberFormat('ru-RU').format(mergePreview.primary.balance || 0)} + {new Intl.NumberFormat('ru-RU').format(mergePreview.duplicate.balance || 0)} ₽</span></div>
                      <div className="mrow"><span className="k">Станет на карточке</span><span className="v" style={{ fontWeight: 700 }}>{new Intl.NumberFormat('ru-RU').format(mergePreview.total_balance || 0)} ₽</span></div>
                      <div className="mrow"><span className="k">Уроки</span><span className="v">переедут вместе с посещениями и абонементами</span></div>
                      {(mergePreview.blockers || []).map((b, i) => (
                        <div key={i} className="mbanner" style={{ marginTop: 10, background: '#FEF2F2', color: '#B91C1C', border: '1px solid #FECACA' }}>{b}</div>
                      ))}
                      <div style={{ marginTop: 10, fontSize: 12.5, color: '#B45309' }}>
                        Вторая карточка будет удалена в МойКлассе. Отменить объединение нельзя.<br/>
                        Платежи, абонементы и посещения переносит сам МойКласс — итоговый баланс появится в карточке в течение 15 минут.
                      </div>
                    </div>
                  )}
                </>
              )}

              {mergeDone && (
                <div className="mbanner" style={{ background: '#DCFCE7', color: '#15803D', border: '1px solid #BBF7D0' }}>
                  Карточки объединены. Платежи и абонементы переносит МойКласс — баланс обновится в течение 15 минут.
                  {mergeDone.balance_moved ? ` С дубля придёт ${new Intl.NumberFormat('ru-RU').format(mergeDone.balance_moved)} ₽.` : ''}
                  {mergeDone.linked_chats && (mergeDone.linked_chats.max + mergeDone.linked_chats.tg > 0)
                    ? ` Чатов переведено: MAX — ${mergeDone.linked_chats.max}, Telegram — ${mergeDone.linked_chats.tg}.`
                    : ''}
                </div>
              )}

              {mergeError && (
                <div className="mbanner err" style={{ marginTop: 10, background: '#FEF2F2', color: '#B91C1C', border: '1px solid #FECACA' }}>{mergeError}</div>
              )}
            </div>
            <div className="mfoot">
              <button className="mbtn quiet" onClick={() => setMergeOpen(false)}>{mergeDone ? 'Закрыть' : 'Отмена'}</button>
              {!mergeDone && (
                <button className="mbtn primary" onClick={runMerge}
                  disabled={mergeBusy || !mergePreview || (mergePreview.blockers || []).length > 0}>
                  {mergeBusy ? 'Объединение выполняется…' : 'Объединить'}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {trialModal && (
        <div className="overlay" onClick={e => { if (e.target === e.currentTarget) setTrialModal(null) }}>
          <div className="modal">
            <div className="mhead">
              <div className="ava">{(trialModal.item.clientName || '?')[0]}</div>
              <div className="ttl">
                <b>{trialModal.item.clientName}</b>
                <div className="sub">{trialModal.item.clientPhone}</div>
              </div>
              <div className="x" onClick={() => setTrialModal(null)}>✕</div>
            </div>
            <div className="mbody">
              <div className="mpanel">
                {trialModal.item.childPhone && <div className="mrow"><span className="k">Телефон ребёнка</span><span className="v">{trialModal.item.childPhone}</span></div>}
                <div className="mrow"><span className="k">Предмет</span><span className="v">{trialModal.item.subject}{trialModal.item.grade ? ', ' + trialModal.item.grade : ''}</span></div>
                <div className="mrow"><span className="k">Преподаватель</span><span className="v">{trialModal.item.assignedTeacher || 'уточняется'}</span></div>
                <div className="mrow"><span className="k">Урок</span><span className="v">{trialDayLabel(trialModal.item.date)} · {trialModal.item.time ? trialModal.item.time.slice(0, 5) : '—'}</span></div>
              </div>
              {trialModal.type === 'task' && trialModal.item.status === 'noshow' && (
                <div className="mbanner" style={{ background: '#FEF2F2', color: '#B91C1C', border: '1px solid #FECACA' }}>
                  <span className="tag">Не пришёл</span>
                  Клиент не зашёл на пробный урок — отработать через раздел «Задачи»
                </div>
              )}
              {trialModal.type === 'task' && trialModal.item.status === 'done' && trialModal.item.needsFollowup && (
                <div className="mbanner" style={{ background: '#FFF7ED', color: '#B45309', border: '1px solid #FDE68A' }}>
                  <span className="tag">Не остался</span>
                  {trialModal.item.trialChoice === 'other'
                    ? 'Клиент попросил другого преподавателя — отработать через раздел «Задачи»'
                    : 'Пробный прошёл, но постоянный урок не записан — отработать через раздел «Задачи»'}
                </div>
              )}
            </div>
            <div className="mfoot">
              <button className="mbtn quiet" onClick={() => setTrialModal(null)}>Закрыть</button>
              {trialModal.type === 'task' && (
                <button className="mbtn primary" onClick={() => { setView('tasks'); setTrialModal(null) }}>Открыть в «Задачи»</button>
              )}
              {trialModal.item.mkUserId && (
                <button className="mbtn primary" onClick={() => {
                  setView('clients')
                  setClientPhone(trialModal.item.clientPhone || '')
                  setSelClientId(trialModal.item.mkUserId)
                  setClientSearchStatus('found')
                  setTrialModal(null)
                }}>Открыть в «Мои клиенты»</button>
              )}
            </div>
          </div>
        </div>
      )}

      {view === 'chats' && (
        <div className="px-4 mt-4">
          <div className="lg:hidden bg-white rounded-2xl border border-slate-200 overflow-hidden">{renderChatList()}</div>
          <div className="hidden lg:flex items-center justify-center text-slate-400 text-sm h-[60vh]">Выберите чат в колонке слева</div>
        </div>
      )}
      {isWriter && (
        <div className="px-4 py-4 max-w-[1100px] mx-auto" style={{ display: view === 'deals' ? 'block' : 'none' }}>
          <DealWorkspace ref={dealRef} />
        </div>
      )}
      {isWriter && view === 'promo' && <PromoView />}
      {isWriter && view === 'trials' && (
        <div className="px-4 py-4 max-w-[1100px] mx-auto"><TrialsBoard /></div>
      )}
      {view === 'tasks' && <CallReviewCard wide Modal={CallDetailModal} />}
      {view === 'tasks' && <div className="sopwrap" style={{ gridTemplateColumns: '1fr', maxWidth: 1120, margin: '0 auto' }}>
        {/* ── Левая часть: карточка / пустые состояния ── */}
        {!onShift ? (
          <div className="empty">
            <div className="big">Вы не на смене</div>
            <div className="small">Включите «На смене» вверху справа — и задачи по клиентам начнут приходить сюда.</div>
          </div>
        ) : loading ? (
          <div className="empty"><div className="small">Загрузка задач…</div></div>
        ) : tasks.length === 0 ? (
          coldDeal ? (
            <ColdCallCard deal={coldDeal} onDone={loadColdDeal} onBook={form => setColdBook(form)}
              onMoveClient={vals => { setNewClientInitial(vals); setNewClientModalOpen(true) }} />
          ) : (
            <div className="empty">
              <div className="big">Задач нет 🎉</div>
              <div className="small">Всё разобрано. Новые задачи появятся здесь автоматически.</div>
            </div>
          )
        ) : cur ? (
          <div className="card">
            <div className="chead">
              <div className="ava">{(cur.clientName || '?').substring(0, 1).toUpperCase()}</div>
              <div className="ttl">
                <b>{cur.meta && cur.meta.mkUserId ? <button onClick={e => { e.stopPropagation(); setSelClientId(cur.meta.mkUserId); setClientDetail(null); setView('clients') }} style={{ background: 'none', border: 0, color: '#0284C7', cursor: 'pointer', padding: 0, font: 'inherit', fontWeight: 700 }}>{cur.clientName || 'Клиент'} ↗</button> : (cur.clientName || 'Клиент')}</b>
                <div className="sub">Задача №{sel + 1} · {taskLabel(cur).toLowerCase()}{cur.createdAt ? ' · ' + new Date(cur.createdAt).toLocaleString('ru-RU', { day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' }) : ''}</div>
              </div>
              <div className="qn">Очередь<br />{sel + 1} из {tasks.length}</div>
            </div>

            <div className={'banner ' + (isPhoneLeft(cur) || (cur.type === 'contact_violation' && !(cur.meta && cur.meta.banned)) ? 'amber' : T(cur.type).banner)}>
              <span className="tag">{taskLabel(cur)}</span>
              {cur.title || taskLabel(cur)}
            </div>

            <div className="body">
              {cur.type !== 'own_task' && (<div className="panel">
                <h3>Контекст</h3>
                {cur.clientName && cur.type !== 'contact_violation' && <div className="row"><span className="k">Клиент</span><span className="v">{cur.clientName}</span></div>}
                {cur.clientPhone && <div className="row"><span className="k">Телефон</span><span className="v">{isPhoneLeft(cur) ? fmtPhoneNice(cur.clientPhone) + ' · оставил в чате ' + fmtMskDateTime(cur.meta.phoneLeftAt) : cur.clientPhone}</span></div>}
                {cur.subject && <div className="row"><span className="k">Предмет</span><span className="v">{cur.subject}</span></div>}
                {cur.teacher && <div className="row"><span className="k">{cur.type === 'selfbook' || cur.type === 'noteacher' ? 'Записался на' : cur.type === 'notime' ? 'Выбрал преподавателя' : 'Преподаватель'}</span><span className="v">{cur.teacher}</span></div>}
                {cur.type === 'notime' && cur.meta && (
                  <>
                    {cur.meta.wantText && <div className="row"><span className="k">Хотел время</span><span className="v">{cur.meta.wantText}</span></div>}
                    {cur.meta.what && <div className="row"><span className="k">Что случилось</span><span className="v" style={{ color: '#B45309' }}>{cur.meta.what}</span></div>}
                    {cur.meta.bookedText && <div className="row"><span className="k">Записался</span><span className="v">{cur.meta.bookedText}</span></div>}
                    <div className="row"><span className="k">Новый клиент</span><span className="v">{cur.meta.isNew ? 'Да · первая запись' : 'Нет · записывался раньше'}</span></div>
                  </>
                )}
                {/* Строка «Преподаватель подтвердил» убрана 17.09 (Антон: «убери все упоминания о том,
                    что подтвердил препод или нет») — с 08.09 самозапись к конкретному преподу подтверждения
                    не требует, с 17.09 то же для записи менеджером; статус offerStatus почти всегда пуст. */}
                {cur.type === 'contact_violation' && cur.meta && (
                  <>
                    <div className="row"><span className="k">Попытка</span><span className="v" style={{ color: cur.meta.banned ? '#B91C1C' : '#B45309' }}>{cur.meta.banned ? '2-я · бан автоматически' : '1-я · при второй — автоматический бан'}</span></div>
                    {cur.meta.matched && cur.meta.matched.length > 0 && <div className="row"><span className="k">Что поймала защита</span><span className="v">{[...new Set(cur.meta.matched)].join(', ')}</span></div>}
                    {cur.meta.clients && cur.meta.clients.length > 0 && <div className="row"><span className="k">Кому писал</span><span className="v">{cur.meta.clients.length === 1 ? 'клиент ' + cur.meta.clients[0] : cur.meta.clients.length + ' клиентам: ' + cur.meta.clients.slice(0, 6).join(', ')}</span></div>}
                    {cur.meta.banned && <div className="row"><span className="k">Будущие уроки</span><span className="v">переданы другому преподавателю автоматически</span></div>}
                  </>
                )}
                {(cur.type === 'teacher_noshow' || cur.type === 'contact_violation') && cur.meta && cur.meta.teacherPhone && <div className="row"><span className="k">Телефон преподавателя</span><span className="v">{cur.meta.teacherPhone}</span></div>}
                {cur.meta && cur.meta.lessonDate && <div className="row"><span className="k">Время урока</span><span className="v">{fmtLessonDate(cur.meta.lessonDate, cur.meta.lessonTime)}</span></div>}
                {cur.type === 'selfreg' && cur.meta && (
                  <>
                    {cur.meta.registeredAt && <div className="row"><span className="k">Зарегистрировался</span><span className="v">{fmtAdminTime(cur.meta.registeredAt)}</span></div>}
                    {cur.meta.bookedAt && <div className="row"><span className="k">Записался</span><span className="v">{fmtAdminTime(cur.meta.bookedAt)}</span></div>}
                    {cur.meta.teacher && <div className="row"><span className="k">К кому записался</span><span className="v">{cur.meta.teacher}</span></div>}
                    {(cur.meta.subject || cur.meta.grade) && <div className="row"><span className="k">Предмет</span><span className="v">{[cur.meta.subject, cur.meta.grade].filter(Boolean).join(', ')}{cur.meta.isTrial ? ' · пробный' : ''}</span></div>}
                    {!cur.meta.bookedAt && <div className="row"><span className="k">Записался</span><span className="v" style={{ color: '#B45309' }}>пока нет — только зарегистрировался</span></div>}
                  </>
                )}
                {cur.type === 'teacher_noshow' && cur.meta && (
                  <>
                    <div className="row"><span className="k">Ученик в комнате</span><span className="v" style={{ color: '#047857' }}>{cur.meta.studentJoinedAt ? 'Да · зашёл в ' + fmtAdminTime(cur.meta.studentJoinedAt).split(', ').pop() : 'Да'}</span></div>
                    <div className="row"><span className="k">Преподаватель</span><span className="v" style={{ color: '#B91C1C' }}>В комнату не заходил{cur.meta.teacherActiveAt ? ' · в кабинете не активен с ' + fmtAdminTime(cur.meta.teacherActiveAt).split(', ').pop() : ' · в кабинете не активен'}</span></div>
                    <div className="row"><span className="k">Пуш преподу</span><span className="v">{cur.meta.pushSent ? 'Отправлен' + (cur.meta.pushSentAt ? ' в ' + fmtAdminTime(cur.meta.pushSentAt).split(', ').pop() : '') : 'Не доставлен (нет подписки на пуши)'}</span></div>
                    <div className="row"><span className="k">Первый урок с этим преподом</span><span className="v" style={{ color: cur.meta.isFirstLesson ? '#B91C1C' : '#0F172A' }}>{cur.meta.isFirstLesson ? 'Да' : 'Нет'}</span></div>
                  </>
                )}
                {cur.type === 'lapsed' && cur.meta && (
                  <>
                    {cur.meta.lessonsText && <div className="row"><span className="k">Уроков было</span><span className="v">{cur.meta.lessonsText}</span></div>}
                    {cur.meta.lastText && <div className="row"><span className="k">Последний урок</span><span className="v">{cur.meta.lastText}</span></div>}
                    <div className="row"><span className="k">Впереди</span><span className="v" style={{ color: '#B91C1C' }}>ничего не записано</span></div>
                    {cur.meta.balanceText && <div className="row"><span className="k">На балансе</span><span className="v">{cur.meta.balanceText}</span></div>}
                    {cur.meta.chatText && <div className="row"><span className="k">Последнее в чате</span><span className="v">{cur.meta.chatText}</span></div>}
                    {cur.meta.newText && <div className="row"><span className="k">Новый клиент</span><span className="v">{cur.meta.newText}</span></div>}
                  </>
                )}
                {cur.type === 'upsell' && cur.meta && (
                  <>
                    {cur.meta.conductedText && <div className="row"><span className="k">Проведено уроков</span><span className="v">{cur.meta.conductedText}</span></div>}
                    {cur.meta.nextText && <div className="row"><span className="k">Следующий урок</span><span className="v">{cur.meta.nextText}</span></div>}
                    {cur.meta.othersText && <div className="row"><span className="k">Другие предметы</span><span className="v">{cur.meta.othersText}</span></div>}
                    {cur.meta.balanceText && <div className="row"><span className="k">На балансе</span><span className="v">{cur.meta.balanceText}</span></div>}
                    {cur.meta.chatText && <div className="row"><span className="k">Последнее в чате</span><span className="v">{cur.meta.chatText}</span></div>}
                    {cur.meta.suggestText && <div className="row"><span className="k">Что предложить</span><span className="v">{cur.meta.suggestText} (подсказка по классу ученика)</span></div>}
                  </>
                )}
                {cur.meta && cur.meta.isTrial != null && <div className="row"><span className="k">Тип урока</span><span className="v">{cur.meta.isTrial ? 'Пробный' : 'Обычный'}</span></div>}
                {cur.meta && cur.meta.trialChoice && <div className="row"><span className="k">Выбор клиента</span><span className="v">{cur.meta.trialChoice === 'other' ? 'Хочу другого' : 'Остаюсь с ним'}</span></div>}
                {cur.meta && cur.meta.lesson && <div className="row"><span className="k">Урок</span><span className="v">{cur.meta.lesson}</span></div>}
                {cur.meta && cur.meta.note && <div className="row"><span className="k">Комментарий</span><span className="v">{cur.meta.note}</span></div>}
              </div>)}

              {cur.type === 'own_task' && (cur.meta && cur.meta.kind === 'trial_done'
                ? <TrialDoneChecklist task={cur} onToggle={toggleOwnCheck} onOpenClient={(mk) => { setSelClientId(mk); setClientDetail(null); setView('clients') }} />
                : <OwnTaskChecklist task={cur} onToggle={toggleOwnCheck} onOpenClient={(mk) => { setSelClientId(mk); setClientDetail(null); setView('clients') }} />
              )}
              {cur.type === 'chat' && (
                <>
                  <div className="sep">{cur.meta && cur.meta.guestId
                    ? 'Переписка гостя сайта с преподавателем — ваш ответ уйдёт от лица преподавателя'
                    : 'Переписка ученик ↔ преподаватель'}</div>
                  <div className="schat">
                    {chatErr ? (
                      <div className="note">Не удалось загрузить переписку — обновится автоматически</div>
                    ) : !chat ? (
                      <div className="note">Загрузка переписки…</div>
                    ) : chat.messages.length === 0 ? (
                      <div className="note">В этом чате пока нет сообщений</div>
                    ) : (isPhoneLeft(cur)
                      ? [...chat.messages, { id: 'phone-' + cur.id, from_role: 'phone', created_at: cur.meta.phoneLeftAt }]
                          .sort((a, b) => new Date(String(a.created_at).includes('T') ? a.created_at : String(a.created_at).replace(' ', 'T') + 'Z') - new Date(String(b.created_at).includes('T') ? b.created_at : String(b.created_at).replace(' ', 'T') + 'Z'))
                      : chat.messages).map(m => (
                      m.from_role === 'phone' ? (
                        <div key={m.id} className="phone">Гость оставил номер: <b>{fmtPhoneNice(cur.clientPhone)}</b><span>{fmtMskDateTime(m.created_at).replace(/^.*?, /, '')} · в переписке не показан, преподаватель и гость эту строку не видят. Позвоните и запишите на урок.</span></div>
                      ) : m.from_role === 'system' ? (
                        <div key={m.id} className="note">{m.text}</div>
                      ) : (
                        <div key={m.id} className={'m ' + m.from_role}>
                          <div className="who">{
                            m.from_role === 'student' ? (cur.clientName || 'Ученик')
                            : m.from_role === 'support' ? '🛟 Поддержка'
                            : (cur.teacher || 'Преподаватель')
                          }</div>
                          <div className="bub">{m.text || (m.attachment_name ? '📎 ' + m.attachment_name : '📎 вложение')}</div>
                          <div className="tm">{new Date((m.created_at || '').replace(' ', 'T') + 'Z').toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}</div>
                        </div>
                      )
                    ))}
                    <div ref={chatEndRef} />
                  </div>
                  <div className="scomposer">
                    <input
                      value={chatText}
                      onChange={e => setChatText(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Enter') sendSupportMsg() }}
                      placeholder={cur.meta && cur.meta.guestId ? 'Ответить гостю от лица преподавателя…' : 'Написать в чат как Поддержка…'}
                      maxLength={4000}
                    />
                    <button onClick={sendSupportMsg} disabled={chatSending || !chatText.trim()}>Отправить</button>
                  </div>
                </>
              )}

              {cur.type === 'contact_violation' && cur.meta && (
                <div className="panel" style={{ marginTop: 12 }}>
                  <h3>Переписка с преподавателем (чат платформы)</h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 7, maxHeight: 260, overflowY: 'auto' }}>
                    {(cur.meta.messages || []).map((m, i) => (
                      <div key={'b' + i} style={{ alignSelf: 'flex-start', maxWidth: '86%', background: '#F1F5F9', border: '1px dashed #94A3B8', color: '#64748B', borderRadius: 12, padding: '8px 11px', fontSize: 13, lineHeight: 1.4 }}>
                        <div style={{ fontSize: 10.5, color: '#B45309', fontWeight: 600, marginBottom: 2 }}>🚫 не отправлено клиенту · {fmtMskDateTime(String(m.at || '').replace(' ', 'T') + 'Z')}</div>{m.text}
                      </div>
                    ))}
                    {cvMsgs.map(m => (
                      <div key={m.id} style={{ alignSelf: m.from_side === 'admin' ? 'flex-end' : 'flex-start', maxWidth: '86%', background: m.from_side === 'admin' ? '#fff' : '#E0F2FE', border: m.from_side === 'admin' ? '1px solid #E5E7EB' : 'none', borderRadius: 12, padding: '8px 11px', fontSize: 13, lineHeight: 1.4 }}>
                        <div style={{ fontSize: 10.5, color: '#94A3B8', fontWeight: 600, marginBottom: 2 }}>{m.from_side === 'admin' ? 'Вы' : 'Преподаватель'} · {fmtMskDateTime(String(m.created_at || '').replace(' ', 'T') + 'Z')}</div>{m.text || (m.attachment_name ? '📎 ' + m.attachment_name : '')}
                      </div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                    <input value={cvText} onChange={e => setCvText(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') sendCv() }} placeholder="Написать преподавателю в чат платформы…" maxLength={4000} style={{ flex: 1, border: '1px solid #E2E8F0', borderRadius: 10, padding: '9px 12px', fontSize: 13 }} />
                    <button className="btn quiet" onClick={sendCv} disabled={cvSending || !cvText.trim()}>✉ Написать в чат платформы</button>
                  </div>
                  {!cvWrote && <div style={{ fontSize: 12, color: '#64748B', marginTop: 10 }}>Кнопка «Связался с преподавателем» включится, когда вы напишете преподавателю в чат платформы. Без сообщения задачу закрыть нельзя.</div>}
                </div>
              )}
              {T(cur.type).checklist && (
                <>
                  <div className="sep">Что проговорить в звонке</div>
                  <div style={{ padding: '12px 14px', background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: 12, fontSize: 13.5, lineHeight: 1.6 }}>
                    {T(cur.type).checklist.map((c, i) => (
                      <div key={i} style={{ display: 'flex', gap: 9, alignItems: 'flex-start', marginTop: i ? 6 : 0 }}>
                        <span style={{ color: '#0284C7', fontWeight: 700, flexShrink: 0 }}>{i + 1})</span>
                        <span>{c}</span>
                      </div>
                    ))}
                  </div>
                </>
              )}
              <div className="sep">Итог</div>
              <div className="actrow">
                {T(cur.type).outcomes.filter(o => !o.onlyBan || (cur.meta && cur.meta.banned)).map(o => (
                  <button key={o.k} className={'btn ' + o.c} disabled={cvLocked(o)} style={cvLocked(o) ? { opacity: .45, cursor: 'not-allowed' } : undefined} onClick={() => o.action === 'cvrestore' ? cvRestore(cur) : o.action === 'reschedule' ? openTaskReschedule(cur) : o.action === 'snooze' ? setSnoozeOpen(true) : o.action === 'upsellbook' ? startUpsellBook(cur) : o.action === 'upsellno' ? setUpsellNo({ task: cur, text: '' }) : o.action === 'refuse' ? setRefuseModal({ id: cur.meta && cur.meta.mkUserId, name: cur.clientName, fromTask: cur }) : resolve(cur, o.k)}>{o.t}</button>
                ))}
                <button className="btn quiet" onClick={() => setSnoozeOpen(v => !v)}>📅 Перенести звонок</button>
              </div>
              {cur.type === 'upsell' && upsellBook && upsellBook.id === cur.id && (
                <div style={{ marginTop: 12, padding: '12px 14px', background: '#F0FDF4', border: '1px solid #BBF7D0', borderRadius: 12 }}>
                  <div style={{ fontWeight: 700, color: '#166534', marginBottom: 6 }}>Клиент согласен — запишите на первый урок нового предмета</div>
                  <div style={{ fontSize: 13, color: '#475569', marginBottom: 8 }}>Клиент уже у нас занимается, анкету заполнять не нужно. Предложить: {cur.meta && cur.meta.suggestText}</div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <button className="mbtn primary" disabled={!clientDetail} onClick={() => { setTrialBookedMsg(null); setTrialPickerOpen(true) }}>Записать на пробный</button>
                    <button className="mbtn primary" disabled={!clientDetail} onClick={() => { setTrialBookedMsg(null); setPaidPickerOpen(true) }}>Записать на платное</button>
                  </div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
                    <button className="btn quiet" onClick={() => setSnoozeOpen(true)}>↪ Согласен, запишем позже — перезвонить (дата)</button>
                    <button className="btn quiet" onClick={() => setUpsellBook(null)}>← Назад к итогам звонка</button>
                  </div>
                </div>
              )}
              {cur.type === 'upsell' && upsellNo && upsellNo.task.id === cur.id && (
                <div style={{ marginTop: 12, padding: '12px 14px', background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 12 }}>
                  <div style={{ fontSize: 13, color: '#475569', marginBottom: 6 }}>Причина одной строкой — она сохранится в итоге задачи</div>
                  <input value={upsellNo.text} onChange={e => setUpsellNo({ task: upsellNo.task, text: e.target.value })} placeholder="Например: хватает одного предмета, подумаем после четверти" maxLength={200} autoFocus style={{ width: '100%', border: '1px solid #E2E8F0', borderRadius: 8, padding: '8px 10px', font: 'inherit' }} />
                  <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                    <button className="btn no" onClick={() => { const t = upsellNo.task, why = upsellNo.text.trim(); setUpsellNo(null); resolve(t, 'не нужно' + (why ? ': ' + why : '')) }}>Закрыть: не нужно</button>
                    <button className="btn quiet" onClick={() => setUpsellNo(null)}>Отмена</button>
                  </div>
                </div>
              )}
              {snoozeOpen && <SnoozeCallForm task={cur} onSubmit={snooze} onClose={() => setSnoozeOpen(false)} />}
              {taskReschedule && (
                <RescheduleLessonModal
                  studentId={taskReschedule.studentId}
                  lesson={taskReschedule.lesson}
                  onClose={() => setTaskReschedule(null)}
                  onDone={() => { const t = taskReschedule.task; setTaskReschedule(null); resolve(t, 'перезаписал') }}
                />
              )}
            </div>
          </div>
        ) : null}

        {/* ── Правая колонка: счётчик + очередь ── */}
        <div className="side">
          <div className="skpi" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, textAlign: 'center' }}>
            <div>
              <div className="num">{tasks.length}</div>
              <div className="lbl">задач в очереди</div>
            </div>
            <div>
              <div className="num" style={{ color: '#10B981' }}>{done}</div>
              <div className="lbl">разобрано сегодня</div>
            </div>
            <div>
              <div className="num" style={{ color: '#0369A1' }}>{(myTasks || []).filter(t => t.status !== 'done').length}</div>
              <div className="lbl">моих задач</div>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, alignItems: 'start' }}>
          <div className="queue">
            <h4>Задачи на сегодня</h4>
            {tasks.length === 0 ? (
              <div style={{ padding: '10px 8px', color: '#94A3B8', fontSize: 13 }}>Пусто</div>
            ) : tasks.map((t, i) => (
              <div key={t.id} className={'qitem' + (i === sel ? ' cur' : '')} onClick={() => setSel(i)}>
                <span className={'dot ' + T(t.type).dot} />
                <div>
                  <span className={'qtag ' + (isPhoneLeft(t) ? 't2' : T(t.type).tag)}>{taskLabel(t)}</span>
                  <div className="qn2">{t.meta && t.meta.mkUserId ? <button onClick={e => { e.stopPropagation(); setSelClientId(t.meta.mkUserId); setClientDetail(null); setView('clients') }} style={{ background: 'none', border: 0, color: '#0284C7', cursor: 'pointer', padding: 0, font: 'inherit', fontWeight: 700 }}>{t.clientName || 'Клиент'} ↗</button> : (t.clientName || 'Клиент')}</div>
                  <div className="qr">{isPhoneLeft(t) ? fmtPhoneNice(t.clientPhone) + (t.teacher ? ' · ' + t.teacher : '') : (t.title || taskLabel(t))}</div>
                  {t.createdAt && <div style={{ fontSize: 11, color: '#94A3B8', marginTop: 2 }}>{new Date(t.createdAt).toLocaleString('ru-RU', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</div>}
                </div>
              </div>
            ))}
          </div>
          <div className="queue">
            <h4>Мои задачи</h4>
            {(!myTasks || myTasks.filter(t => t.status !== 'done').length === 0) ? (
              <div style={{ padding: '10px 8px', color: '#94A3B8', fontSize: 13 }}>Пусто</div>
            ) : myTasks.filter(t => t.status !== 'done').map(t => (
              <div key={t.id} className="qitem" style={{ cursor: 'default' }}>
                <span className="dot p" />
                <div>
                  <div className="qn2">{t.mk_user_id ? <button onClick={() => { setSelClientId(t.mk_user_id); setClientDetail(null); setView('clients') }} style={{ background: 'none', border: 0, color: '#0284C7', cursor: 'pointer', padding: 0, font: 'inherit', fontWeight: 700 }}>{t.client_name || ('ученик #' + t.mk_user_id)} ↗</button> : (t.client_name || 'Ученик')}</div>
                  <div className="qr">{t.text}</div>
                  <div style={{ fontSize: 11, color: '#94A3B8', marginTop: 2 }}>{t.due_date ? 'до ' + fmtDue(t.due_date) : 'без срока'}</div>
                  <div style={{ marginTop: 5 }}>
                    <button onClick={() => setMyTaskStatus(t.mk_user_id, t.id, 'done')} style={{ fontSize: 10.5, border: '1px solid #cbd5e1', background: '#fff', color: '#475569', borderRadius: 7, padding: '2px 8px', cursor: 'pointer', fontFamily: 'inherit' }}>Выполнена</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          </div>
        </div>
      </div>}
        </div>
        {!['otbor', 'anketi', 'badreviews'].includes(view) && <TelegramPanel chats={tgChats} setChats={setTgChats} sel={tgSel} setSel={setTgSel} onOpenDeal={isWriter ? openDealFromChat : null} onOpenClient={(id) => { setSelChatId(null); setSelClientId(id); setClientDetail(null); setView('clients') }} onOpenTutor={(id) => { setSelChatId(null); setSelTutorId(id); setView('tutors'); setTimeout(() => setTutorTab('students'), 60) }} />}
      </div>
      {chatModal}
      {adminChatModal}
    </div>
  )
}

// Загрузка методички в библиотеку платформы (Роман 27.10.2026).
// Менеджер кидает PDF, сервер разбирает обложку (текстовый слой, а у сканов —
// распознавание) и предлагает предмет, класс и автора. Менеджер подтверждает
// или правит, файл переименовывается по общему правилу и уезжает в нужную
// ячейку библиотеки. Перезапуск платформы не нужен: она читает библиотеку с
// диска на каждый запрос, материал виден в уроках сразу.
function LibraryUploadModal({ onClose }) {
  // Стиль полей — как в остальных окнах этого файла.
  const fld = { width: '100%', padding: '10px 12px', border: '1px solid #e6ebf1', borderRadius: 10, fontSize: 14, outline: 'none', marginTop: 4 }
  const [stage, setStage] = useState('pick')      // pick | analyzing | confirm | saving | done | error
  const [info, setInfo] = useState(null)
  const [subject, setSubject] = useState('')
  const [grade, setGrade] = useState('')
  const [filename, setFilename] = useState('')
  const [err, setErr] = useState('')
  const [result, setResult] = useState(null)
  const [dupPath, setDupPath] = useState('')   // путь учебника, который уже есть

  async function pickFile(file) {
    if (!file) return
    setErr(''); setStage('analyzing')
    const fd = new FormData()
    fd.append('file', file)
    try {
      const { data } = await api.post('/api/library/analyze', fd, { timeout: 300000 })
      setInfo(data)
      setSubject(data.guess.subject || '')
      setGrade(data.guess.grade ? String(data.guess.grade) : '')
      setFilename(data.filename || '')
      setStage('confirm')
    } catch (e) {
      setErr(e.response?.data?.error || 'Не удалось разобрать файл')
      setStage('error')
    }
  }

  async function save() {
    setErr(''); setStage('saving')
    try {
      const { data } = await api.post('/api/library/commit', {
        id: info.id, subject: subject.trim().toLowerCase(), grade, filename,
      }, { timeout: 300000 })
      setResult(data); setStage('done')
    } catch (e) {
      setErr(e.response?.data?.error || 'Не удалось положить файл')
      setDupPath(e.response?.data?.duplicate || '')
      setStage('error')
    }
  }

  const known = (info && info.subjects) || []
  const subjectNew = subject && !known.includes(subject.trim().toLowerCase())
  const gradeNew = info && subject && grade &&
    !((info.grades || {})[subject.trim().toLowerCase()] || []).includes(String(grade))

  return (
    <div className="overlay" onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal" style={{ maxWidth: 560 }}>
        <div className="mhead">
          <div className="ttl"><b>Методический материал</b>
            <div className="sub">PDF попадёт в библиотеку платформы — ту, что преподаватели открывают в уроке</div>
          </div>
          <div className="x" onClick={onClose}>✕</div>
        </div>
        <div className="mbody" style={{ display: 'grid', gap: 14 }}>

          {stage === 'pick' && (
            <label style={{ display: 'block', border: '2px dashed #cbd5e1', borderRadius: 12, padding: 28,
                            textAlign: 'center', cursor: 'pointer', color: '#475569' }}>
              <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}>Выберите PDF</div>
              <div style={{ fontSize: 12.5, color: '#94a3b8' }}>Учебник, задачник или методичка. До 200 МБ.</div>
              <input type="file" accept="application/pdf,.pdf" style={{ display: 'none' }}
                     onChange={e => pickFile(e.target.files && e.target.files[0])} />
            </label>
          )}

          {stage === 'analyzing' && (
            <div style={{ padding: 10, fontSize: 14, color: '#475569' }}>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>Файл принят, идёт анализ…</div>
              <div style={{ fontSize: 12.5, color: '#94a3b8' }}>
                Читаю обложку и первые страницы. Если это скан, распознаю текст — тогда дольше, до минуты.
              </div>
            </div>
          )}

          {stage === 'confirm' && info && (
            <>
              <div style={{ fontSize: 13.5, color: '#0f172a' }}>
                {info.guess.subject
                  ? <>Это <b>{info.guess.subject}</b>{info.guess.grade ? <>, <b>{info.guess.grade} класс</b></> : ''}
                      {info.guess.author ? <>, автор <b>{info.guess.author}</b></> : ''}.</>
                  : <>Не смог определить предмет сам — укажите вручную.</>}
                {!info.hasText && <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 4 }}>
                  В файле нет текстового слоя, определял распознаванием обложки — проверьте.
                </div>}
              </div>

              {(info.maybeDuplicate || []).length > 0 && (
                <div style={{ fontSize: 12.5, color: '#B91C1C', background: '#FEF2F2',
                              border: '1px solid #FECACA', borderRadius: 8, padding: '8px 10px' }}>
                  <b>Похоже, этот учебник уже есть на платформе.</b>
                  <div style={{ marginTop: 4 }}>
                    Такой же по объёму файл лежит здесь: {(info.maybeDuplicate || []).join(', ')}.
                  </div>
                  <div style={{ marginTop: 4, color: '#7F1D1D' }}>
                    Перед загрузкой сверимся по содержимому — если это тот же файл, он не загрузится.
                  </div>
                </div>
              )}

              <label style={{ fontSize: 13, color: '#475569' }}>Предмет
                <input style={fld} value={subject} onChange={e => setSubject(e.target.value)} list="lib-subjects" placeholder="математика" />
                <datalist id="lib-subjects">{known.map(s => <option key={s} value={s} />)}</datalist>
              </label>
              {subjectNew && (
                <div style={{ fontSize: 12.5, color: '#B45309', background: '#FFFBEB',
                              border: '1px solid #FDE68A', borderRadius: 8, padding: '8px 10px' }}>
                  Такого предмета в библиотеке нет. Создать «{subject.trim().toLowerCase()}»?
                  Папка появится вместе с файлом.
                </div>
              )}

              <label style={{ fontSize: 13, color: '#475569' }}>Класс
                <select style={fld} value={grade} onChange={e => setGrade(e.target.value)}>
                  <option value="">Выберите</option>
                  {[1,2,3,4,5,6,7,8,9,10,11].map(g => <option key={g} value={String(g)}>{g} класс</option>)}
                </select>
              </label>
              {gradeNew && grade && !subjectNew && (
                <div style={{ fontSize: 12.5, color: '#B45309' }}>
                  В «{subject}» такого класса ещё не было — ячейка создастся.
                </div>
              )}

              <label style={{ fontSize: 13, color: '#475569' }}>Имя файла в библиотеке
                <input style={fld} value={filename} onChange={e => setFilename(e.target.value)} />
                <span style={{ fontSize: 11.5, color: '#94a3b8' }}>
                  Как у остальных: «Предмет, Автор и др., год.pdf»
                </span>
              </label>

              <div style={{ fontSize: 12, color: '#94a3b8' }}>
                Исходное имя: {info.original} · {info.sizeMb} МБ
              </div>

              <button className="btn" onClick={save} disabled={!subject || !grade || !filename}
                      style={{ background: '#0284C7', color: '#fff', border: 0, borderRadius: 10,
                               padding: '11px 16px', fontWeight: 700, cursor: 'pointer' }}>
                Переименовать и положить в библиотеку
              </button>
            </>
          )}

          {stage === 'saving' && (
            <div style={{ padding: 10, fontSize: 14, color: '#475569' }}>
              <b>Переименовываю и кладу файл в соответствующую ячейку…</b>
              <div style={{ fontSize: 12.5, color: '#94a3b8', marginTop: 4 }}>Делаю превью обложки и копирую на медиа-сервер.</div>
            </div>
          )}

          {stage === 'done' && (
            <div style={{ display: 'grid', gap: 10 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#047857' }}>Успешно выполнено</div>
              <div style={{ fontSize: 13, color: '#475569' }}>
                Лежит в библиотеке: <b>{result && result.path}</b>
              </div>
              <div style={{ fontSize: 12.5, color: '#94a3b8' }}>
                Материал уже доступен преподавателям в уроке — перезапуск платформы не требуется.
              </div>
              <button className="btn" onClick={onClose}
                      style={{ background: '#0f172a', color: '#fff', border: 0, borderRadius: 10,
                               padding: '11px 16px', fontWeight: 700, cursor: 'pointer' }}>Закрыть</button>
            </div>
          )}

          {stage === 'error' && (
            <div style={{ display: 'grid', gap: 10 }}>
              <div style={{ fontSize: 14, color: '#B91C1C' }}>{err}</div>
              {/* Дубль — не ошибка загрузки, а нормальный исход: учебник уже на
                  платформе. Предлагать «попробовать снова» тут бессмысленно. */}
              {dupPath ? (
                <>
                  <div style={{ fontSize: 12.5, color: '#64748B' }}>
                    Преподаватели уже видят его в уроке, повторно класть не нужно.
                  </div>
                  <button className="btn" onClick={onClose}
                          style={{ background: '#0f172a', color: '#fff', border: 0, borderRadius: 10,
                                   padding: '11px 16px', fontWeight: 700, cursor: 'pointer' }}>Закрыть</button>
                </>
              ) : (
                <button className="btn" onClick={() => { setStage('pick'); setErr('') }}
                        style={{ background: '#e2e8f0', border: 0, borderRadius: 10, padding: '10px 16px', cursor: 'pointer' }}>
                  Попробовать снова
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
